var cmsheroShopify ,designMode =  false;    
window.theme = window.theme || {};
    
var ProductTextCountdown = function() {
        function ProductTextCountdown() {
          this.selectors = {};
          this.load();
        }; 
        ProductTextCountdown.prototype = $.extend({}, ProductTextCountdown.prototype, {
          load: function() {
            this.init($('.js-text-countdown').not('.text-countdown--init'));
          },
          init: function($elems) {
            var $countdown = $elems.not('.text-countdown--init');
 
            $countdown.each(function () {
              var $this = $(this),
                  $counter = $this.find('[data-js-text-countdown-counter]'),
                  $date = $this.find('[data-js-text-countdown-delivery]'),
                  reset_time = +$this.attr('data-reset-time'),
                  delivery_time = +$this.attr('data-delivery-time'),
                  delivery_format = $this.attr('data-delivery-format'),
                  delivery_excludes = $this.attr('data-delivery-excludes').replace(/ /gi, '').toLowerCase().split(','),
                  year = $this.attr('data-y'),
                  month = $this.attr('data-m'),
                  day = $this.attr('data-d'),
                  hour = $this.attr('data-h'),
                  minute = $this.attr('data-i'),
                  second = $this.attr('data-s'),
                  date_counter = new Date();   
              
			  var austDay = new Date(year,month-1,day,hour,minute,second);

              date_counter.setDate(date_counter.getDate()+1);
              date_counter.setHours(reset_time, 0, 0, 0);

              var labels = ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Mins', 'Secs'];
              var layout = '<span class="box-count day"><span class="number">{dnn}</span> <span class="text">Days</span></span><span class="box-count hrs"><span class="number">{hnn}</span> <span class="text">Hours</span></span><span class="box-count min"><span class="number">{mnn}</span> <span class="text">Mins</span></span><span class="box-count secs"><span class="number">{snn}</span> <span class="text">Secs</span></span>';
              
              var t = $counter.countdown({
                until: austDay,                
                labels: labels, 
                layout: layout
              })
              .on('finish.countdown', function() {
                $counter.hide();
              });
 			  
              $this.addClass('text-countdown--init');
            });
          },
          destroy: function($countdown) {
            if($countdown.hasClass('text-countdown--init')) {
              $countdown.countdown('remove').off().removeClass('text-countdown--init').html('');
            }
          }          
        });

        theme.ProductTextCountdown = new ProductTextCountdown;
      };
var SortingCollections = function() {

    function SortingCollections(container) {
        this.$container = $(container);
    
        this.namespace = '.sorting-collections';

        this.onLoad();
    };

    SortingCollections.prototype = $.extend({}, SortingCollections.prototype, {
        onLoad: function() {
            var $control = this.$container.find('[data-sorting-collections-control]'),
                $collections = this.$container.find('[data-sorting-collections-ajax] [data-collection]'),
                $products = this.$container.find('[data-sorting-collections-items]'),
                xhr = null;

            this.$control = $control;           
            function loadProducts($button, loader) {
                if(xhr) {
                    xhr.abort();
                }

                var $control = $button.closest('[data-sorting-collections-control]'),
                	collection = $button.attr('data-collection'),
                    $products = $button.closest("section").find('[data-sorting-collections-items]'),
                    count_limit = $products.attr('data-limit'),
                    grid_classes = $products.attr('data-grid');
              	
              	var	slider =  "false";
                var first_col_50 = "false";
              if($products.attr('data-slider') != "false"){
               	slider =  "true";
              }
              console.log(slider);
              if($products.attr('data-first50')!=null){
               	var first_col_50 = "true";
              }
              if($button.closest("section").find("div[data-js-collection-tab] .js-sorting-collection-tab").length > 0){
                $button.closest("section").find("div[data-js-collection-tab] .js-sorting-collection-tab").slick('unslick');                
              }
               $button.closest("section").find("div[data-sorting-collections-ajax] div[data-sorting-collections-items]").css('opacity','0');
               $button.closest("section").find("div[data-sorting-collections-ajax] [loader-tab]").removeClass('hidden');
                xhr = $.ajax({
                    type: 'GET',
                    url: '/collections/' + collection,
                    cache: false,
                    data: {
                        view: 'sorting',
                        count_limit: count_limit,
                        grid_classes: encodeURIComponent(grid_classes),
                        first_col_50:first_col_50,
                        slider:slider
                    },
                    dataType: 'html',
                    success: function (data) {
                      var $childern;

                      $products.html(data);

                      if($products[0].hasAttribute('data-is-design-mode')) {
                        $childern = $products.children();

                        $childern.addClass(grid_classes);

                        if($childern.length > count_limit) {
                          for(var i = count_limit; i < $childern.length; i++) {
                            $childern.eq(i).remove();
                          }
                        }
                      } 
                      /*theme.Tooltip.reinit();*/
                      $control.find('a').removeClass('active');
                      $button.addClass('active');
                      /* Re-init review and tooltip */
                      
                        SPR.registerCallbacks();
                        SPR.initRatingHandler();
                        SPR.initDomEls();
                        SPR.loadProducts();
                        SPR.loadBadges();
                      
                      
                      if($button.closest("section").find("div[data-js-collection-tab] .js-sorting-collection-tab").length > 0){
                        var count = $button.closest("section").find("div[data-sorting-collections-items]").data("number");
                        $button.closest("section").find("div[data-js-collection-tab] .js-sorting-collection-tab").not('.slick-initialized').slick({
                          lazyLoad: 'ondemand',
                          slidesToShow: count,
                          slidesToScroll: count,
                          dots: false,
                          arrows: true,
                          infinite: false,  
                          responsive: [
                            {
                              breakpoint: 1200,
                              settings: {
                                slidesToShow: count,
                                slidesToScroll: count,
                                dots: false,
                                arrows: true,
                                infinite: false                          
                              }
                            },
                            {
                              breakpoint: 992,
                              settings: {
                                dots: false,
                                arrows: true,  
                                infinite: false,
                                slidesToShow: count-1,
                                slidesToScroll: count-1
                              }
                            },
                            {
                              breakpoint: 767,
                              settings: {
                                arrows: true,  
                                infinite: false,
                                slidesToShow: 2,
                                slidesToScroll: 2
                              }
                            },
                            {
                              breakpoint: 650,
                              settings: {
                                arrows: true,  
                                infinite: false,
                                slidesToShow: 2,
                                slidesToScroll: 2
                              }
                            }, 
                            {
                              breakpoint: 480,
                              settings: {
                                arrows: true,  
                                infinite: false,
                                slidesToShow: 2,
                                slidesToScroll: 2
                              }
                            }
                          ]});

                      }
                      setTimeout(function(){ 
                        tippy('.product-item .js-compare, .product-item .js-wishlist, .product-item .js_quick_view:not(.no-icon)', {
                          placement: 'top',
                          animation: 'scale',
                          arrow: true
                        })
                      },500)
                      
                       xhr = null;
                       $button.closest("section").find("div[data-sorting-collections-ajax] div[data-sorting-collections-items]").css('opacity','1');
                       $button.closest("section").find("div[data-sorting-collections-ajax] [loader-tab]").addClass('hidden');
                    }
                });
            };

            $control.on('click', 'a', function (e) {
                var $this = $(this);

                if(!$this.hasClass('active')) {
                    loadProducts($this, true);
                }

                e.preventDefault();
                return false;
            });
        },
        onUnload: function() {
            this.$container.off(this.namespace);

            this.$control.off();
        }
    });
	theme.SortingCollections = new SortingCollections('.type_tab_collection');
};
var ProductImagesHover = function() {

    function ProductImagesHover() {
        this.selectors = {
          	images: '.js-product-images-navigation',
            images_hover: '.js-product-images-hover',
            images_hovered_end: '.js-product-images-hovered-end'
        };

        this.load();
    };

    ProductImagesHover.prototype = $.extend({}, ProductImagesHover.prototype, {
        load: function() {
            function changeImage($wrap, $image, url, id) {
                $wrap.attr('data-js-product-image-hover-id', $image.attr('data-image-id'));
                theme.ProductImagesNavigation.changeSrc($image, url, id);            
              
            };
            jQuery('body').on('mouseenter', this.selectors.images_hover, function (e) {
              var $this = $(this),
                  $image = $this.find('[data-image-lazy]'),
                  url = $this.attr('data-js-product-image-hover'),
                  id = $this.attr('data-js-product-image-hover-id');
              if(url) {
                changeImage($this, $image, url, id);
                $this.one('mouseleave', function () {
                  var url = $image.attr('data-url-img'),
                      id = $this.attr('data-js-product-image-hover-id');
                  changeImage($this, $image, url, id);
                });
              }              
            })
            jQuery($(this.selectors.images)).each(function(){
              var $this = $(this),
                  $image = $this.find('[data-image-lazy]'),
                  url = $this.attr('data-js-product-image-hover'),
                  id = $this.attr('data-js-product-image-hover-id');
              if(url) {
                changeImage($this, $image, url, id);               
              }              
            })
            
        },
        disable: function ($image) {
            $image.parents(this.selectors.images_hover).removeClass('js-product-images-hover').unbind('mouseleave');
        }
    });

    theme.ProductImagesHover = new ProductImagesHover;
};
var ProductImagesNavigation = function() {

    function ProductImagesNavigation() {
        this.selectors = {
            images_nav: '.js-product-images-navigation'
        };

        this.load();
    };

    ProductImagesNavigation.prototype = $.extend({}, ProductImagesNavigation.prototype, {
        load: function() {
            var _ = this;

            $body.on('click', '[data-js-product-images-navigation]:not([data-disabled])', function() {
                var $this = $(this),
                    $product = $this.parents('[data-js-product]'),
                    direction = $this.attr('data-js-product-images-navigation');

                theme.ProductImagesHover.disable($product.find('[data-image-lazy]'));

                var data = theme.ProductOptions.switchByImage($product, direction, null, function (data) {
                    _._updateButtons($product, data.is_first, data.is_last);
                });
            });
        },
        switch: function($product, data) {
            var $image_container = $product.find('[data-js-product-image]'),
                $image,
                $image_hover,
                image,
                src,
                master_src;

            if($image_container.length) {
                $image = $image_container.find('[data-image-lazy]');
                image = data.update_variant.featured_image;
				$image_hover = $image_container.find('[data-image-hover]');
                theme.ProductImagesHover.disable($image);

                if(!image || !image.src) {
                    if(data.json.images[0]) {
                        image = data.json.images[0];
                    }
                }

                if(image && image.src && +image.id !== +$image.attr('data-image-id')) {
                    src = Shopify.resizeImage(image.src, Math.ceil($image_container.width()) + 'x') + ' 1x, ' + Shopify.resizeImage(image.src, Math.ceil($image_container.width()) * 2 + 'x') + ' 2x';
                    /*src = Shopify.resizeImage(image.src, Math.ceil($image_container.width()) + 'x');*/
                    master_src = Shopify.resizeImage(image.src, 'grande');					
                    this.changeSrc($image,$image_hover, src, image.id, master_src);					
                    if($image.parents(this.selectors.images_nav).length) {
                        this._updateButtons($product, +data.json.images[0].id === +image.id, +data.json.images[data.json.images.length - 1].id === +image.id);
                    }
                }
            }
        },          
        changeSrc: function ($image, $image_hover, srcset, id, master_src) {
            var $parent = $image.parent();

            id = id || 'null';   
            $image.attr('srcset', srcset).attr('data-image-id', id);    
          	$image_hover.fadeOut(function() {
          		$image_hover.css('background-image', 'url('+master_src+')').fadeIn();
            })
            if(master_src) {
                $image.attr('data-master', master_src);
            }
        },
        _updateButtons: function($product, is_first, is_last) {
            $product.find('[data-js-product-images-navigation="prev"]')[is_first ? 'attr' : 'removeAttr']('data-disabled', 'disabled');
            $product.find('[data-js-product-images-navigation="next"]')[is_last ? 'attr' : 'removeAttr']('data-disabled', 'disabled');
        }
    });

    theme.ProductImagesNavigation = new ProductImagesNavigation;
};
var ProductCurrency = function() {

    function ProductCurrency() {
      	this.selectors = {
          multipleСurrencies: "true"                  
        };		
    };

    ProductCurrency.prototype = $.extend({}, ProductCurrency.prototype, {
        load: function() {
          var moneyFormat = $("span[data-shop-currency]").attr("data-shop-currency");
            if(this.selectors.multipleСurrencies != "false") {
                var cookieCurrency;                
                try {
                    cookieCurrency = Currency.cookie.read();
                } catch(err) {}
                
                $('span.money span.money').each(function () {
                    $(this).parents('span.money').removeClass('money');
                });

                $('span.money').each(function () {
                    $(this).attr('data-currency-' + moneyFormat, $(this).html());
                });

                if (cookieCurrency == null) {
                    if (moneyFormat !== Currency.defaultCurrency) {
                        Currency.convertAll(moneyFormat,Currency.defaultCurrency);
                    } else {
                        Currency.currentCurrency = Currency.defaultCurrency;
                    }
                } else if (cookieCurrency === moneyFormat) {
                    Currency.currentCurrency = moneyFormat;
                } else {
                    Currency.convertAll(moneyFormat,cookieCurrency);
                }
            }
        },     
        convert: function(value, type) {
          /*var shopCurrency = $("span[data-shop-currency]").attr("data-shop-currency");*/
          var shopCurrency = Currency.currentCurrency;
          var newCurrency = Currency.currentCurrency;
          if(Currency.currentCurrency=== undefined) newCurrency= 'USD';
          var oldCurrency = shopCurrency;

          if (isNaN(value)) {
            value = 0.0;
          }

          var cents = 0.0;          
         
         var oldFormat = Currency.moneyFormats['USD'][Currency.format] || '';
          var newFormat = Currency.moneyFormats[Currency.currentCurrency][Currency.format] || '';
          if(Currency.currentCurrency=== undefined) {
              var newFormat = Currency.moneyFormats['USD'][Currency.format] || '';
          }		  
          if (oldFormat.indexOf('amount_no_decimals') !== -1) {
               cents = Currency.convert(parseInt(value, 10) * 100, oldCurrency, newCurrency);
          } else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
               cents = Currency.convert(parseInt(value, 10) / 10, oldCurrency, newCurrency);
          } else {
               cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
          }
          if (type == 'nosymbol') {
            return cents; 
          } 
          var my_data = Currency.formatMoney(cents, newFormat);
          return my_data;
        },
        setPrice: function($price, price, compare_at_price) {
            var cookieCurrency;                
            try {
              cookieCurrency = Currency.cookie.read();
            } catch(err) {}
            price = +price;
            compare_at_price = +compare_at_price;

            var html = '',
                sale = compare_at_price && compare_at_price > price;

            $price[sale ? 'addClass' : 'removeClass']('price--sale');            
            html += '<span class="money">';
            html += this.convert(price,"12");
            html += '</span>';
            if(sale ) {
                html += '<span class="compare">';
                html += this.convert(compare_at_price, "xx");
                html += '</span>';
            }
            if($price.closest(".price").find("span:last-child").hasClass("compare")){
             	 /*$price.closest(".price").find("span:last-child").hide();*/
            }
            $price.html(html); 
           
        },
        update: function() {
            var cookieCurrency;                
            try {
              cookieCurrency = Currency.cookie.read();
            } catch(err) {}
            if($(".currency-picker__label").length > 0){
				var moneyFormat = $("span[data-shop-currency]").attr("data-shop-currency");
            }else{
				var moneyFormat = Currency.currentCurrency;
            }
            
            if(this.selectors.multipleСurrencies) {               
                if (cookieCurrency != null) {
                	Currency.convertAll(moneyFormat, cookieCurrency);
                }
            }
        }
    });

    theme.ProductCurrency = new ProductCurrency;
};    
var Loader = function() {

    function Loader() {
        var _ = this;

        this.$loader = $('#theme-loader .js-loader');

        _.load();
    };

    Loader.prototype = $.extend({}, Loader.prototype, {
        load: function () {
          
        },
        set: function($elem, obj) {         
            /*if($elem.length && $elem.find('.nt_bg_lz').length > 0) { 
                setTimeout(function () {
                   jQuery("body").addClass('ajax_loading');
                }, 0);
            }*/
             $elem.addClass('loading-element');
        },
        unset: function ($elem) {            
            //jQuery("body").removeClass('ajax_loading');    
             $elem.removeClass('loading-element');
        }
    });

    theme.Loader = new Loader;
};
var ProductOptions = function() {

        function ProductOptions() {
          	this.namespaces = [
                'wishlist',
                'compare'
            ];
            this.selectors = {
                    options: '.js-product-options',
                    options_attr: '[data-js-product-options]'                   
            };
          
            this.afterChange = [];
			
            this.load();
            
        };

        ProductOptions.prototype = $.extend({}, ProductOptions.prototype, {
            load: function() {
                var _ = this,
                    timeout,
                    xhr;
                window.$body = jQuery("html").find('body');
                function onProcess(e) {
                    var $this = $(this),
                        $options = $this.parents(_.selectors.options),
                        $section = $this.parents('[data-property]');

                    if ($this.hasClass('disabled') || ($this.hasClass('active') && !$section[0].hasAttribute('data-disable-auto-select'))) {
                        return;
                    }

                    var $values = $section.find('[data-js-option-value]'),
                        $product = $this.parents('[data-js-product]'),
                        json = $product.attr('data-json-product'),
                        current_values = [],
                        update_variant = null;

                    $values.removeClass('active');
                    $values.parent().removeClass('active');
                    $this.addClass('active');
                    $this.parent().addClass('active');

                    $section.removeAttr('data-disable-auto-select');

                    _._loadJSON($product, json, function (json) {
                        var $active_values = $options.find('[data-js-option-value].active').add($options.find('option[data-value]:selected'));

                        $.each($active_values, function() {
                            var $this = $(this);

                            current_values.push($this.attr('data-value'));
                        });

                        $options.find('[data-js-option-value]').removeClass('active');

                        $.each(json.variants, function() {
                            if(current_values.join(' / ') === Shopify.handleizeArray(this.options).join(' / ')) {
                             
                                if(!this.available) {
                                    return false;
                                }

                                update_variant = this;

                                return false;
                            }
                        });

                        if(!update_variant && current_values.length > 1) {
                            $.each(json.variants, function() {
                                if(current_values[0] === Shopify.handleize(this.options[0]) && current_values[1] === Shopify.handleize(this.options[1])) {
                                    if(!this.available) {
                                         
                                        if(update_variant) {
                                            return;
                                        }
                                    }

                                    update_variant = this;

                                    if(this.available) {
                                        return false;
                                    }
                                }
                            });
                        }

                        if(!update_variant) {
                            $.each(json.variants, function() {
                                if(current_values[0] === Shopify.handleize(this.options[0])) {
                                    if(!this.available) {
                                        if(update_variant) {
                                            return;
                                        }
                                    }

                                    update_variant = this;

                                    if(this.available) {
                                        return false;
                                    }
                                }
                            });
                        }

                        if(!update_variant) {
                            update_variant = _._getDefaultVariant(json);
                        }

                        _._updatePossibleVariants($product, {
                            update_variant: update_variant,
                            json: json
                        });

                        $.each(update_variant.options, function(i, k) {
                            var $prop = $options.find('[data-property]').eq(i);

                            $prop.find('[data-js-option-value][data-value="' + Shopify.handleize(k) + '"]').addClass('active');
                            $prop.filter('[data-js-option-select]').val(Shopify.handleize(k)).trigger('change', [ true ]);
                        });

                        _._switchVariant($product, {
                            update_variant: update_variant,
                            json: json,
                            has_unselected_options: $product.find('[data-property][data-disable-auto-select]').length ? true : false
                        });
                    });
                };

                $body.on('click', this.selectors.options + ' [data-js-option-value]', onProcess);

                $body.on('mouseenter', this.selectors.options + '[data-js-options-onhover] [data-js-option-value]', onProcess);

                $body.on('change', '[data-js-product] [data-js-option-select]', function (e, onupdate) {
                    if(onupdate) {
                        return;
                    }

                    var $this = $(this).find('option[data-value]:selected');

                    $(this).parents('.select').find('[data-js-select-dropdown]').removeAttr('data-dropdown-unselected');

                    onProcess.call($this, e);
                });

                $body.on('change', '[data-js-product-variants="control"]', function () {
                    var $this = $(this),
                        $product = $this.parents('[data-js-product]'),
                        id = $this.find('option:selected').attr('value'),
                        json = $product.attr('data-json-product'),
                        update_variant = null;

                    _._loadJSON($product, json, function (json) {
                        $.each(json.variants, function() {
                            if(+this.id === +id) {
                                update_variant = this;
                                return false;
                            }
                        });

                        _._switchVariant($product, {
                            update_variant: update_variant,
                            json: json,
                            dontUpdateVariantsSelect: true
                        });
                    });
                });
                
            },
            _loadJSON: function ($product, json, callback, animate) {
              
                if($product[0].hasAttribute('data-js-process-ajax-loading-json')) {
                    $product.one('json-loaded', function () {
                        if(callback) {
                            callback(JSON.parse($product.attr('data-json-product')));
                        }
                    });

                    return;
                }

                animate = animate === undefined ? true : animate;
				
                if(json) {
                    if(callback) {
                        callback(typeof json == 'object' ? json : JSON.parse(json));
                    }
                } else {
                    $product.attr('data-js-process-ajax-loading-json', true);

                    if(animate) {
                        theme.Loader.set($product);
                    }

                    var handle = $product.attr('data-product-handle');

                    var xhr = $.ajax({
                        type: 'GET',
                        url: theme.routes.root_url + 'products/' + handle,
                        data: {
                            view: 'get_json'
                        },
                        cache: false,
                        dataType: 'html',
                        success: function (data) {
                            json = JSON.parse(data);
                            $product.attr('data-json-product', JSON.stringify(json));

                            if(animate) {
                                theme.Loader.unset($product);
                            }

                            if(callback) {
                                callback(json);
                            }

                            $product.trigger('json-loaded');
                        },
                        complete: function () {
                            $product.removeAttr('data-js-process-ajax-loading-json');
                        }
                    });

                    return xhr;
                }
            },
            switchByImage: function($product, get_image, id, callback) {
                var _ = this,
                    $image = $product.find('[data-js-product-image] [data-image-lazy]'),
                    json = $product.attr('data-json-product'),
                    data = false;
                
                this._loadJSON($product, json, function (json) {
                    var json_images = json.images,
                        current_image_id = (get_image === 'by_id') ? +id : +$image.attr('data-image-id'),
                        image_index,
                        update_variant;

                    $.each(json_images, function(i) {
                        if(+this.id === current_image_id) {
                            image_index = i;
                            return false;
                        }
                    });
                    
                    if(image_index || image_index === 0) {
                        if(get_image === 'prev' && image_index !== 0) {
                            image_index--;
                        } else if(get_image === 'next' && image_index !== json_images.length - 1) {
                            image_index++;
                        }

                        $.each(json.variants, function() {
                            if(this.featured_image && +this.featured_image.id === +json_images[image_index].id) {
                                update_variant = this;
                                return false;
                            }
                        });

                        if(!update_variant) {
                            update_variant = _._getDefaultVariant(json);
                            update_variant.featured_image = json_images[image_index];
                        }

                        _._updateOptions($product, {
                            update_variant: update_variant,
                            json: json
                        });

                        _._switchVariant($product, {
                            update_variant: update_variant,
                            json: json
                        });

                        data = {
                            index: image_index,
                            image: json_images[image_index],
                            is_first: image_index === 0,
                            is_last: image_index === json_images.length - 1
                        };
                      
                     
                    }

                    callback(data);
                });
            },
            _updatePossibleVariants: function ($product, data) {
                var $options = $product.find(this.selectors.options_attr),
                    $section_eq_values,
                    $section_eq_select_options,
                    possible_variants = [];

                if(data.update_variant.options.length > 1) {
                    $.each(data.json.variants, function() {
                        if(Shopify.handleize(this.options[0]) !== Shopify.handleize(data.update_variant.options[0])) {
                            return;
                        } else if(!this.available && this.id !== data.update_variant.id) {
                            return;
                        }

                        possible_variants.push(this);
                    });

                    $section_eq_values = $options.find('[data-property]').eq(1).find('[data-js-option-value]');
                    $section_eq_select_options = $options.find('[data-property]').eq(1).filter('[data-js-option-select]').parents('.select').find('[data-value]');

                    $section_eq_values.addClass('disabled');
                    $section_eq_select_options.attr('disabled', 'disabled');

                    $.each(possible_variants, function () {
                        $section_eq_values.filter('[data-js-option-value][data-value="' + Shopify.handleize(this.options[1]) + '"]').removeClass('disabled');
                        $section_eq_select_options.filter('[data-value="' + Shopify.handleize(this.options[1]) + '"]').removeAttr('disabled');
                    });

                    if(data.update_variant.options.length > 2) {
                        possible_variants = [];

                        $.each(data.json.variants, function() {
                            if(Shopify.handleize(this.options[0]) !== Shopify.handleize(data.update_variant.options[0]) || Shopify.handleize(this.options[1]) !== Shopify.handleize(data.update_variant.options[1])) {
                                return;
                            } else if(!this.available && this.id !== data.update_variant.id) {
                                return;
                            }

                            possible_variants.push(this);
                        });

                        $section_eq_values = $options.find('[data-property]').eq(2).find('[data-js-option-value]');
                        $section_eq_select_options = $options.find('[data-property]').eq(2).filter('[data-js-option-select]').parents('.select').find('[data-value]');

                        $section_eq_values.addClass('disabled');
                        $section_eq_select_options.attr('disabled', 'disabled');

                        $.each(possible_variants, function () {
                            $section_eq_values.filter('[data-js-option-value][data-value="' + Shopify.handleize(this.options[2]) + '"]').removeClass('disabled');
                            $section_eq_select_options.filter('[data-value="' + Shopify.handleize(this.options[2]) + '"]').removeAttr('disabled');
                        });
                    }
                }
            },
            _switchVariant: function($product, data) {
                data.update_variant.metafields = $.extend({}, data.json.metafields);

                $.each(data.json.variants_metafields, function() {
                    if(+this.variant_id === +data.update_variant.id) {
                        data.update_variant.metafields = $.extend(true, data.update_variant.metafields, this.metafields);
                    }
                });

                this._updateContent($product, data);
            },
            _getDefaultVariant: function(json) {
                var default_variant = {};

                $.each(json.variants, function() {
                    if(+this.id === +json.default_variant_id) {
                        Object.assign(default_variant, this);
                        return false;
                    }
                });

                return default_variant;
            },
            checkProductStatus: function($products) {              
                $products = $products || $('[data-js-product]');                
              	
              // Duyệt các namespaces: wishlist và compare
                for(var bI = 0; bI < this.namespaces.length; bI++){
                  // Tạo selector cho từng namespaces
                  var selectors = {                   
                      button: '.js-store-lists-add-' + this.namespaces[bI]                   
                  };
                  // Nếu khách hàng đã đăng nhập thì tạo current_storage
                  if(theme.customer) {
                    var current_storage = this.namespaces[bI] + '-customer-' + theme.customer_id;
                  } else {
                    var current_storage = this.namespaces[bI] + '-guest';
                  }
				  // Lấy dữ liệu từ localStorage
                  var storage = localStorage.getItem(current_storage),
                      items = storage ? JSON.parse(storage) : [],
                      $active_products = $();

				  // Với mỗi dữ liệu trong mỗi namespaces
                  $.each(items, function () {
                      $.each(this, function (k, v) {                      	
                          var $selected_product = $products.filter('[data-product-handle="' + v + '"][data-product-variant-id="' + k + '"]');						
                          if ($selected_product.length) {
                              $active_products = $active_products.add($selected_product);
                          }
                      });
                  });
				  // Xoá thuộc tính data-button-status cho các namespaces
                  $products.not($active_products).find(selectors.button).removeAttr('data-button-status');
                  // Thiết lập active cho sản phẩm có namespaces
                  $active_products.find(selectors.button).attr('data-button-status', 'added');
                }
            },
            _updateContent: function($product, data) {
                var clone_id = $product.attr('data-js-product-clone-id'),
                    $clone_product = $('[data-js-product-clone="' + clone_id + '"]');

                $product.attr('data-product-variant-id', data.update_variant.id);
                $product.add($clone_product).find('[data-js-product-options]').attr('data-variant-was-chanched', true);

                this._updateFormVariantInput($product, data);
                this._updatePrice($product, $clone_product, data);
                this._updateLabelSale($product, data);
                this._updateLabelInStock($product, data);
                this._updateLabelOutStock($product, data);
                this._updateLabelHot($product, data);
                this._updateLabelNew($product, data);
                this._updateCountdown($product, data);
                this._updateAddToCart($product, $clone_product, data);
                this._updateDynamicCheckout($product, data);
                this._updateSKU($product, data);
                this._updateBarcode($product, data);
                this._updateAvailability($product, data);
                this._updateStockCountdown($product, data);
                this._updateGallery($product, data);
                this._updateLinks($product, data);
                this._updateHistory($product, data);				
                this.checkProductStatus($product);
                theme.ProductImagesNavigation.switch($product, data);

                if(!data.dontUpdateVariantsSelect) {
                    this._updateVariantsSelect($product, data);
                }

                if($clone_product.length) {
                    this._updateOptions($clone_product, data, $product);
                    theme.ProductImagesNavigation.switch($clone_product, data);
                }
            },
            _updateOptions: function($product, data, $product_origin) {
                var _ = this;

                $product.each(function () {
                    var $this = $(this),
                        $options = $this.find(_.selectors.options_attr),
                        $sections;

                    if($options.length) {
                        $options.find('[data-js-option-value]').removeClass('active');

                        _._updatePossibleVariants($this, data);

                        $.each(data.update_variant.options, function(i, k) {
                            var $prop = $options.find('[data-property]').eq(i);

                            $prop.find('[data-js-option-value][data-value="' + Shopify.handleize(k) + '"]').addClass('active');
                            $prop.filter('[data-js-option-select]').val(Shopify.handleize(k)).trigger('change', [ true ]);
                        });
                    }

                    if($product_origin && theme.product.variant_auto_select !== 'enable') {
                        $sections = $product.find('[data-property]');

                        $sections.attr('data-disable-auto-select');

                        $product_origin.find('[data-property]').each(function (i, v) {
                            if(!this.hasAttribute('data-disable-auto-select')) {
                                $sections.eq(i).removeAttr('data-disable-auto-select');
                            }
                        });
                    }
                });
            },
            _updateFormVariantInput: function ($product, data) {
                var $input = $product.find('[data-js-product-variant-input]');

                $input.attr('value', data.update_variant.id);
            },
            _updateVariantsSelect: function($product, data) {
                var $select = $product.find('[data-js-product-variants]');

                if($select.length) {
                    $select.val(data.update_variant.id).change();
                }
            },          
            _updateAddToCart: function($product, $clone_product, data) {
                var $button = $product.add($clone_product).find('[data-js-product-button-add-to-cart]');                
                $button.data('pid', data.update_variant.id);
                if($button.length && !data.has_unselected_options) {
                    data.update_variant.available ? $button.removeAttr('disabled data-button-status') : $button.attr('disabled', 'disabled').attr('data-button-status', 'sold-out');
                }
            },
            _updateDynamicCheckout: function($product, data) {
                var $button = $product.find('[data-js-product-button-dynamic-checkout]');

                if($button.length && !data.has_unselected_options) {
                    data.update_variant.available ? $button.removeClass('d-none') : $button.addClass('d-none');
                }
            },
            _updatePrice: function($product, $clone_product, data) {
                var $price = $product.add($clone_product).find('[data-js-product-price]'),
                    $details = $product.find('[data-js-product-price-sale-details]'),
                    details;

                if($price.length) {                    
                    theme.ProductCurrency.setPrice($price, data.update_variant.price, data.update_variant.compare_at_price);
                }

                if($details.length) {
                    $.each(data.json.variants_price_sale_details, function () {
                        if(+this.id === +data.update_variant.id) {
                            details = this.details;
                        }
                    });

                    $details.html(details ? details : '')[details ? 'removeClass' : 'addClass']('d-none-important');
                }

                if($price.length || $details.length) {
                    theme.ProductCurrency.update();
                }
            },
            _updateLabelSale: function($product, data) {
                var $label = $product.find('[data-js-product-label-sale]');

                if($label.length) {
                    var html = '',
                        sale = (data.update_variant.compare_at_price && data.update_variant.compare_at_price > data.update_variant.price);

                    $label[!sale ? 'addClass' : 'removeClass']('d-none-important');

                    if(sale) {
                        var percent = Math.ceil(100 - data.update_variant.price * 100 / data.update_variant.compare_at_price);

                      html += "-{{ percent }}%";
                        html = Shopify.addValueToString(html, {
                            'percent': percent
                        });
                    }

                    $label.html(html);
                }
            },
            _updateLabelInStock: function($product, data) {
                var $label = $product.find('[data-js-product-label-in-stock]');

                if($label.length) {
                    $label[!data.update_variant.available ? 'addClass' : 'removeClass']('d-none-important');
                }
            },
            _updateLabelOutStock: function($product, data) {
                var $label = $product.find('[data-js-product-label-out-stock]');

                if($label.length) {
                    $label[data.update_variant.available ? 'addClass' : 'removeClass']('d-none-important');
                }
            },
            _updateLabelHot: function($product, data) {
                var $label = $product.find('[data-js-product-label-hot]');

                if($label.length) {
                    $label[data.update_variant.metafields.labels && data.update_variant.metafields.labels.hot ? 'removeClass' : 'addClass']('d-none-important');
                }
            },
            _updateLabelNew: function($product, data) {
                var $label = $product.find('[data-js-product-label-new]');

                if($label.length) {
                    $label[data.update_variant.metafields.labels && data.update_variant.metafields.labels.new ? 'removeClass' : 'addClass']('d-none-important');
                }
            },
            _updateCountdown: function($product, data) {
                var $countdown = $product.find('[data-js-product-countdown]'),
                    date = data.update_variant.metafields.countdown && data.update_variant.metafields.countdown.date ? data.update_variant.metafields.countdown.date : false,
                    $countdown_init,
                    need_coundown;

                if($countdown.length) {
                    $countdown_init = $countdown.find('.js-countdown');
                    need_coundown = date && data.update_variant.compare_at_price && data.update_variant.compare_at_price > data.update_variant.price;

                    if(need_coundown && $countdown_init.attr('data-date') !== date) {
                        theme.ProductCountdown.reinit($countdown_init, date);
                    }

                    if(!need_coundown) {
                        $countdown.addClass('d-none-important');
                    }
                }
            },
            _updateSKU: function($product, data) {
                var $sku = $product.find('[data-js-product-sku]');

                if($sku.length) {
                    $sku[data.update_variant.sku ? 'removeClass' : 'addClass']('d-none-important');

                    $sku.find('span').html(data.update_variant.sku);
                }
            },
            _updateBarcode: function($product, data) {
                var $barcode = $product.find('[data-js-product-barcode]');

                if($barcode.length) {
                    $barcode[data.update_variant.barcode ? 'removeClass' : 'addClass']('d-none-important');

                    $barcode.find('span').html(data.update_variant.barcode);
                }
            },
            _updateAvailability: function($product, data) {
                var $availability = $product.find('[data-js-product-availability]');

                if($availability.length) {
                    var html = '',
                        quantity = 0;

                    $.each(data.json.variants_quantity, function() {
                        if(+this.id === +data.update_variant.id) {
                            quantity = +this.quantity;
                        }
                    });

                    var vStr = "In stock ({{ count }} {{ item }})";
                    if(data.update_variant.available) {
                        /* html += "In stock ({{ count }} {{ item }})"; */                       
                        html += Shopify.addValueToString(vStr, {
                            'count': quantity,
                            'item': quantity === 1 ? "item" : "items"
                        });
                    } else {
                      html += "Out of stock";
                    }

                    $availability.attr('data-availability', data.update_variant.available).find('span').html(html);
                }
            },
            _updateStockCountdown: function ($product, data) {
                var $stock_countdown = $product.find('[data-js-product-stock-countdown]'),
                    $title = $stock_countdown.find('[data-js-product-stock-countdown-title]'),
                    $progress = $stock_countdown.find('[data-js-product-stock-countdown-progress]'),
                    min = +$stock_countdown.attr('data-min'),
                    quantity = 0;

                $.each(data.json.variants_quantity, function () {
                    if(+this.id === +data.update_variant.id) quantity = +this.quantity;
                });

                if($title) {
                  $title.html(Shopify.addValueToString("Hurry! Only {{ quantity }} Left in Stock!", {
                        'quantity': '<span class="stock-countdown__counter">' + quantity + '</span>'
                    }));
                }

                if($progress) {
                    $progress.width(quantity / (min / 100) + '%');
                }

                if($stock_countdown.length) {
                    $stock_countdown[quantity > 0 && quantity < min ? 'removeClass' : 'addClass']('d-none-important');
                }
            },
            _updateGallery: function ($product, data) {
                var $gallery = $product.find('[data-js-product-gallery]'),
                    $for_option = $gallery.find('[data-js-for-option]'),
                    image;

                if(data.update_variant.option1) {
                    $for_option.each(function () {
                        var $this = $(this);

                        $this[$this.attr('data-js-for-option') === Shopify.handleize(data.update_variant.option1) ? 'removeClass' : 'addClass']('d-none');
                    });

                    if(!$for_option.filter(':not(.d-none)').length) {
                        $for_option.removeClass('d-none');
                    }
                }

                if($gallery.find('.fotorama').length) {
                    if(data.update_variant.featured_media) {
                        image = data.update_variant.featured_media;
                    } else if(data.json.media[0]) {
                        image = data.json.media[0];
                    }

                    $gallery.productGallery('switchImageById', image.id);
                }
              /*A Chung update */
              image = data.update_variant.featured_image;  
              if(image != null){
                if(image.id !=""){   
                  $("#thumb_img_"+image.id).trigger("click"); 
                }
              }
              /* End */
            },
            _updateLinks: function ($product, data) {
                var url = decodeURIComponent(window.location.origin) + '/products/' + data.json.handle + '?variant=' + data.update_variant.id;            	
                $product.find('a[href*="products/' + data.json.handle + '"]').attr('href', url);
              	// Tìm nút quickview trong product grid item 
                var $pr_pid = $product.find('a.js_quick_view');                
                if($pr_pid.length > 0){ // nếu tìm thấy thì cập nhật data-pid cho nút Quickview
					$pr_pid.prop('data-pid',data.update_variant.id);
                }
            },
            _updateHistory: function ($product, data) {
                var $options = $product.find(this.selectors.options);

                if(!data.has_unselected_options && $options.length && $options[0].hasAttribute('data-js-change-history')) {
                    var url = window.location.href.split('?')[0] + '?variant=' + data.update_variant.id;

                    history.replaceState({foo: 'product'}, url, url);
                }
            }
        });

        theme.ProductOptions = new ProductOptions();
    };  
var ProductVisitors = function() {

    function ProductVisitors() {
        this.selectors = {

        };

        this.load();
    };

    ProductVisitors.prototype = $.extend({}, ProductVisitors.prototype, {
        load: function() {
            this.init($('.js-visitors').not('.visitors--init'));
        },
        init: function($elems) {
            var $countdown = $elems.not('.visitors--init');

            function randomInteger(min, max) {
                return Math.round(min - 0.5 + Math.random() * (max - min + 1));
            };

            $countdown.each(function () {
                var $this = $(this),
                    $counter = $this.find('[data-js-counter]'),
                    min = $this.attr('data-min'),
                    max = $this.attr('data-max'),
                    interval_min = $this.attr('data-interval-min'),
                    interval_max = $this.attr('data-interval-max'),
                    stroke = +$this.attr('data-stroke'),
                    current_value,
                    new_value;

                $this.addClass('visitors--processing');

                function update() {
                    setTimeout(function() {
                        if(!$this.hasClass('visitors--processing')) {
                            return;
                        }

                        current_value = +$counter.text();
                        new_value = randomInteger(min, max);

                        if(Math.abs(current_value - new_value) > stroke) {
                            new_value = new_value > current_value ? current_value + stroke : current_value - stroke;
                            new_value = randomInteger(current_value, new_value);
                        }

                        $counter.text(new_value);

                        update();
                    }, randomInteger(interval_min, interval_max) * 1000);
                };

                update();

                $this.addClass('visitors--init');
            });
        },
        destroy: function($countdown) {
            if($countdown.hasClass('visitors--init')) {
                $countdown.off().removeClass('visitors--processing visitors--init').html('');
            }
        }
    });

    theme.ProductVisitors = new ProductVisitors;
};


var ProductGallery = function(){
  
    function ProductGallery() {
        this.selectors = {
             main: '[data-zoom]',
             nav: '[data-thumb-id]'
        };
       
        this.load();
    };
    ProductGallery.prototype = $.extend({}, ProductGallery.prototype, {
        load: function() {
            this.init();
        },
        init: function() { 
          
          var zoomImage = $(this.selectors.main);
          var style_zoom;
          var zoomConfig; 
          style_zoom = zoomImage.data("style-zoom");
          
          switch(style_zoom) {
            case 1:
              zoomConfig = {
                gallery: 'slider-nav', 
                galleryActiveClass: "slick-current"
              }; 
              break;
            case 2:
              zoomConfig = {
                gallery: 'slider-nav', 
                zoomType: 'inner',
                cursor: 'crosshair',
                galleryActiveClass: "slick-current"
              };
              break;
            case 3:
              zoomConfig = {
                gallery: 'slider-nav', 
                zoomType: 'lens',
                lensShape: 'round',
                lensSize: 200,
                galleryActiveClass: "slick-current"
              };
              break;
            case 4:
              zoomConfig = {
                gallery: 'slider-nav', 
                scrollZoom: true,
                galleryActiveClass: "slick-current"
              };
              break;
            default:
              zoomConfig = {
                gallery: 'slider-nav', 
                galleryActiveClass: "slick-current"
              }; 
          }
         if($("div[data-thumb-id]").length > 0){           	
             $("div[data-thumb-id]").on('click',function(){
               // Remove old instance od EZ
               $('.zoomContainer').remove();
               zoomImage.removeData('elevateZoom');
               // Update source for images
               zoomImage.attr('src', $(this).data('image'));
               zoomImage.data('zoom-image', $(this).data('z-image'));
               // Reinitialize EZ
               zoomImage.ezPlus(zoomConfig);
             })
             
             if($("#js-product-selectors").length == 0){               
                $("div[data-thumb-id]").first().trigger("click");
             }
           }else{
               if(zoomImage.length > 0){
                 zoomImage.ezPlus(this.zoomConfig);
               }
           }
        },
        create: function($src, $zoom_img){
            var zoomImage = $(this.selectors.main);
            var style_zoom;
            var zoomConfig; 
            style_zoom = zoomImage.data("style-zoom");

            switch(style_zoom) {
              case 1:
                zoomConfig = {
                  gallery: 'slider-nav', 
                  galleryActiveClass: "slick-current"
                }; 
                break;
              case 2:
                zoomConfig = {
                  gallery: 'slider-nav', 
                  zoomType: 'inner',
                  cursor: 'crosshair',
                  galleryActiveClass: "slick-current"
                };
                break;
              case 3:
                zoomConfig = {
                  gallery: 'slider-nav', 
                  zoomType: 'lens',
                  lensShape: 'round',
                  lensSize: 200,
                  galleryActiveClass: "slick-current"
                };
                break;
              case 4:
                zoomConfig = {
                  gallery: 'slider-nav', 
                  scrollZoom: true,
                  galleryActiveClass: "slick-current"
                };
                break;
              default:
                zoomConfig = {
                  gallery: 'slider-nav', 
                  galleryActiveClass: "slick-current"
                }; 
            }
            // Remove old instance od EZ
            $('.zoomContainer').remove();
            zoomImage.removeData('elevateZoom');
            // Update source for images
            zoomImage.attr('src', $src);
            zoomImage.data('zoom-image', $zoom_img);
            // Reinitialize EZ
            zoomImage.ezPlus(zoomConfig);
        },
        destroy: function(){
            var zoomImage = $(this.selectors.main);
            // Remove old instance od EZ
            $('.zoomContainer').remove();
            zoomImage.removeData('elevateZoom');
        }
    });

    theme.ProductGallery = new ProductGallery; 
 };                  
var StoreLists = function() {

    function Engine(namespace, callback) {
        this.namespace = namespace;

        this.selectors = {
            button: '.js-store-lists-add-' + namespace,
            button_remove: '.js-store-lists-remove-' + namespace,
            button_clear: '.js-store-lists-clear-' + namespace,
            has_items: '[data-js-store-lists-has-items-' + namespace + ']',
            dhas_items: '[data-js-store-lists-dhas-items-' + namespace + ']'
        };

        if(theme.customer) {
            this.current_storage = namespace + '-customer-' + theme.customer_id;

            this.app_obj = {
                namespace: namespace,
                customerid: theme.customer_id,
                shop: theme.permanent_domain,
                domain: theme.host,
                iid: theme.lists_app.iid
            };
        } else {
            this.current_storage = namespace + '-guest';
        }

        this.load(callback);
    };

    Engine.prototype = $.extend({}, Engine.prototype, {
        load: function(callback) {
            var _ = this;
            window.$body = jQuery("html").find('body');
            if(theme.customer) {              	
                var customer_storage = localStorage.getItem(this.current_storage),
                    customer_storage_arr = customer_storage ? JSON.parse(customer_storage) : [],
                    guest_storage = localStorage.getItem(this.namespace + '-guest'),
                    guest_storage_arr = guest_storage ? JSON.parse(guest_storage) : [],
                    sort_data_arr = [],
                    sort_customer_storage_arr,
                    sort_concat_arr,
                    sort_concat_arr_json;

                var sortObjectsArray = function(arr) {
                    var obj = {},
                        new_arr = [],
                        i = 0;

                    for(i = 0; i < arr.length; i++) {
                        $.each(arr[i], function (k, v) {
                            obj[k + ''] = v;
                        });
                    }

                    $.each(obj, function (k, v) {
                        var obj = {};

                        obj[k] = v;
                        new_arr.push(obj);
                    });

                    return new_arr;
                };

                var loadData = function() {
                    _.getCustomerList(function (data) {
                        if(data.status !== 200) {
                            return;
                        }

                        sort_customer_storage_arr = sortObjectsArray(customer_storage_arr);

                        if(data.items && data.items.length) {
                            sort_data_arr = sortObjectsArray(data.items);
                        }

                        sort_concat_arr = sortObjectsArray(sort_customer_storage_arr.concat(sort_data_arr));

                        sort_concat_arr_json = JSON.stringify(sort_concat_arr);

                        if(sort_concat_arr_json !== JSON.stringify(sort_customer_storage_arr) || sort_concat_arr_json !== JSON.stringify(sort_data_arr)) {
                            localStorage.setItem(_.current_storage, sort_concat_arr_json);

                            _.setCustomerList(sort_concat_arr_json);
                        }

                        _.updateHeaderCount();
                        _.checkProductStatus();
                        
                        localStorage.removeItem(_.namespace + '-guest');
                    });
                };

                if(guest_storage_arr.length) {
                    callback({
                        trigger: function (is_active) {
                            if(is_active) {
                                customer_storage_arr = customer_storage_arr.concat(guest_storage_arr);
                            }

                            loadData();
                        },
                        info: {
                            namespace: _.namespace,
                            count: guest_storage_arr.length
                        }
                    });
                } else {
                    loadData();
                }
            } else {              	
                this.checkProductStatus();
            }
            $body.on('click', "[data-id='#js_wishlist_popup']", function(e) {
               var $popup = $('[data-js-popup-ajax]');
               _.update($popup);
            })
            $body.on('click', "[data-js-popup-button='wishlist-full']", function(e) {
               e.preventDefault();               
               var $popup = $('[data-js-popup-ajax]');
               _.updateFull($popup);
              
                var namespace = "wishlist";
                var $content = $popup.find('.popup-' + namespace + '-full__content');
                $content.parent().removeClass('open');
                setTimeout(function(){ $content.parent().addClass('open');}, 500);
              
                setTimeout(function(){ 
                  tippy('.product-item .js-compare, .product-item .js-wishlist, .product-item .js_quick_view:not(.no-icon),.product-item.small .js_add_to_cart_button, .product-item-style2 .js-compare, .product-item-style2 .js-wishlist, .product-item-style2 .js_quick_view', {
                    placement: 'top',
                    animation: 'scale',
                    arrow: true
                  })
                }, 500)
                
            })
            $body.on('click', "[data-js-popup-button='compare-full']", function(e) {
               e.preventDefault();       
               var $popup = $('[data-js-popup-name="compare-full"]');
               _.updateCompareFull($popup);
                var namespace = "compare";
                var $content = $popup.find('.popup-' + namespace + '-full__content');
                $content.parent().removeClass('open');
               setTimeout(function(){ $content.parent().addClass('open');}, 500);
                
                 
               
            })
            $body.on('click', ".popup-wishlist-full__head [data-js-popup-close], .popup-compare-full__head [data-js-popup-close]", function(e) {
                $.magnificPopup.close(function(){
                $("a[data-js-tooltip]").each(function(){                            
                  $(this).attr("disabled","disabled");
                }) 
              });
            })
           
            $body.on('click', this.selectors.button, function(e) {
                var $this = $(this);
                
                $this.attr('disabled', 'disabled');

                var $product = $this.parents('[data-js-product]'),
                    handle = $product.attr('data-product-handle'),
                    id = +$product.attr('data-product-variant-id');

                if($this.attr('data-button-status') === 'added') {
                    _.removeItem(id, handle, function(data) {
                        $this.removeAttr('data-button-status');
                        $this.removeAttr('disabled');
                    });
                } else {                    
                    _.addItem(id, handle, function(data) {
                        $this.attr('data-button-status', 'added');
                        $this.removeAttr('disabled');
                    });
                }

                e.preventDefault();
                return false;
            });

            function removeCallback($product, handle) {
                var find = '[data-js-store-lists-product-' + _.namespace + ']';

                if(handle) find += '[data-product-handle="' + handle + '"]';

                $(find).each(function () {
                    var $this = $(this);
                    $($this.parent('[class*="col"]').children().length == 1 ? $this.parent() : $this).remove();
                });

                if($product && typeof $product !== undefined && $product.length) $product.remove();
          
            };

            $body.on('click', this.selectors.button_remove, function(e) {
                //e.preventDefault();
                var $this = $(this),
                    $product = $this.parents('[data-js-product]'),
                    handle = $product.attr('data-product-handle'),
                    id = +$product.attr('data-product-variant-id');
                _.removeItem(id, handle, function() {
                    removeCallback($product, handle);
                });
            });

            $body.on('click', this.selectors.button_clear, function() {
                _.clear(function() {
                    removeCallback();
                });
            });
        },
        setCustomerList: function(items, callback) {
            if(theme.customer) {
                $.ajax({
                    type: "POST",
                    url: "https://" + theme.lists_app.url + "/api/massadd",
                    data: $.extend({}, this.app_obj, {
                        purge: 'yes',
                        items: items
                    }),
                    cache: false,
                    success: function(data) {
                        if(callback) callback(data);
                    }
                });
            }
        },
        getCustomerList: function(callback) {
            if(theme.customer) {
                $.ajax({
                    type: 'POST',
                    url: 'https://' + theme.lists_app.url + '/api/getlist',
                    data: this.app_obj,
                    cache: false,
                    success: function(data) {
                        if(callback) callback(data);
                    }
                });
            }
        },
        addCustomerItem: function(id, handle, callback) {
            if(theme.customer) {
                $.ajax({
                    type: 'POST',
                    url: 'https://' + theme.lists_app.url + '/api/add',
                    data: $.extend({}, this.app_obj, {
                        key: id,
                        value: handle
                    }),
                    cache: false,
                    success: function(data) {
                        if(callback) callback(data);
                    }
                });
            }
        },
        removeCustomerItem: function(id, callback) {
            if(theme.customer) {
                $.ajax({
                    type: 'POST',
                    url: 'https://' + theme.lists_app.url + '/api/delete',
                    data: $.extend({}, this.app_obj, {
                        key: id,
                        _method: 'DELETE'
                    }),
                    cache: false,
                    success: function(data) {
                        if(callback) callback(data);
                    }
                });
            }
        },
        clearCustomerItem: function(callback) {
            if(theme.customer) {
                $.ajax({
                    type: 'POST',
                    url: 'https://' + theme.lists_app.url + '/api/massdelete',
                    data: $.extend({}, this.app_obj, {
                        _method: 'DELETE'
                    }),
                    cache: false,
                    success: function(data) {                        
                        if(callback) callback(data);
                    }
                });
            }
        },
        addItem: function(id, handle, callback) {
            var storage = localStorage.getItem(this.current_storage),
                items = storage ? JSON.parse(storage) : [],
                obj = {};

            obj[id] = handle;

            items.push(obj);

            localStorage.setItem(this.current_storage, JSON.stringify(items));

            this.checkProductStatus();
            this.updateHeaderCount();
            var $popup = $('[data-js-popup-ajax]');
            this.update($popup);
            this.addCustomerItem(id, handle);

            $('[data-js-' + this.namespace + '-count]').parent().trigger('click');
            if(callback) callback();
        },
        removeItem: function(id, handle, callback) {
            var storage = localStorage.getItem(this.current_storage),
                items = storage ? JSON.parse(storage) : [];

            $.each(items, function (i) {
                if(this[id] && this[id] === handle) {
                    items.splice(i, 1);
                    return false;
                }
            });

            localStorage.setItem(this.current_storage, JSON.stringify(items));

            this.checkProductStatus();

            $(this.selectors.has_items)[items.length > 0 ? 'removeClass' : 'addClass']('d-none');
            $(this.selectors.dhas_items)[items.length > 0 ? 'addClass' : 'removeClass']('d-none');

            this.updateHeaderCount();
            var $popup = $('[data-js-popup-ajax]');
            this.update($popup);
            this.removeCustomerItem(id);

            if (callback) callback();
        },
        clear: function (callback) {
            localStorage.removeItem(this.current_storage);

            this.checkProductStatus();

            $(this.selectors.has_items).addClass('d-none');
            $(this.selectors.dhas_items).removeClass('d-none');

            this.updateHeaderCount();

            this.clearCustomerItem();          
          	  
            if (callback) callback();
        },
        checkProductStatus: function($products) {
            $products = $products || $('[data-js-product]');			
            var _ = this,
                storage = localStorage.getItem(this.current_storage),
                items = storage ? JSON.parse(storage) : [],
                $active_products = $();

            $.each(items, function () {
                $.each(this, function (k, v) {                  
                    var $selected_product = $products.filter('[data-product-handle="' + v + '"][data-product-variant-id="' + k + '"]');

                    if ($selected_product.length) {                      	
                        $active_products = $active_products.add($selected_product);
                    }
                });
            });

            $products.not($active_products).find(_.selectors.button).removeAttr('data-button-status');
            $active_products.find(_.selectors.button).attr('data-button-status', 'added');
        },
        updateHeaderCount: function(callback) {
            var storage = localStorage.getItem(this.current_storage),
                count = storage ? JSON.parse(storage).length : 0;

            $('[data-js-' + this.namespace + '-count]').attr('data-js-' + this.namespace + '-count', count).html(count);
			
            if (callback) callback();
        },
        _resultToHTML: function($items, data, callback) {
            var $template = $($('#template-' + this.namespace + '-ajax')[0].content),
                $fragment = $(document.createDocumentFragment());
			
            for(var i = 0; i < data.params.length; i++) {
                $.each(data.params[i], function (k, v) {
                    var product = null,
                        variant = null;
					
                    $.each(data.products, function () {
                        if(this.handle === v) {
                            product = this;
                        }
                    });

                    if(!product) return;					
					
                    $.each(product.variants, function() {  
                      	
                        if(+this.id === +k) {
                            variant = this;
                            return false;
                        }
                    });
					
                    var image = variant.featured_image ? variant.featured_image.src : product.featured_image;

                    var $item = $template.clone(),
                        $product = $item.find('.product-store-lists'),
                        $image = $item.find('.product-store-lists__image img'),
                        $title = $item.find('.product-store-lists__title a'),
                        $variant = $item.find('.product-store-lists__variant'),
                        $price = $item.find('.product-store-lists__price .price'),
                        $links = $item.find('a').not('.product-store-lists__remove');
                  		

                    $product.attr('data-product-variant-id', k);
                    $product.attr('data-product-handle', v);
                    $links.attr('href', '/products/' + v + '?variant=' + k);
                    $title.html(product.title);
                    $image.attr('srcset', Shopify.resizeImage(image, '120x') + ' 1x, ' + Shopify.resizeImage(image, '240x') + ' 2x');

                    if(variant.title !== 'Default Title') {
                        $variant.html(variant.title).removeClass('d-none-important');
                    }

                    theme.ProductCurrency.setPrice($price, variant.price, variant.compare_at_price);

                    $fragment.append($item);
                });
            }
            
            $items.html('');
            $items.append($fragment);

            if(callback) {
                callback();
            }
        },
        _getProducts: function(items, callback) {
            var _ = this,
                handles = [],
                cycles = 1,
                data_items = [],
                i = 0;

            if (this.xhr) {
                this.xhr.abort();
            }

            for(; i < items.length; i++) {
                $.each(items[i], function () {
                    handles.push(this)
                });
            }

            i = 0;
            cycles = Math.max(1, Math.ceil(handles.length/20));

            function recurcionRequests(i) {
                var request_handles = handles.slice(i * 20, (i + 1) * 20);
                
                _.xhr = $.ajax({
                    type: 'GET',
                    url: '/collections/all',
                    cache: false,
                    data: {
                        view: 'products_by_handle',
                        constraint: request_handles.join('+')
                    },
                    dataType: 'html',
                    success: function (data) {                                   
                        $.each(JSON.parse(data), function() {
                            data_items.push(this);
                        });

                        i++;

                        if(i < cycles) {
                            recurcionRequests(i);
                        } else {
                            callback({
                                params: items,
                                products: data_items
                            });
                        }
                    }
                });
            };

            recurcionRequests(i);
        },
        update: function($popup, callback) {
            var _ = this,
                storage = localStorage.getItem(this.current_storage),
                items = storage ? JSON.parse(storage) : [],
                $content = $popup.find('.popup-' + this.namespace + '_content'),
                $empty = $popup.find('.popup-' + this.namespace + '_empty'),
                $items = $popup.find('.popup-' + this.namespace + '_items'),
                $count = $popup.find('[data-js-popup-' + this.namespace + '-count]');
            $content[items.length > 0 ? 'removeClass' : 'addClass']('d-none');
            $empty[items.length > 0 ? 'addClass' : 'removeClass']('d-none');
            
               if(items.length > 0) {
                var data = this._getProducts(items, function(data) {                  	
                    _._resultToHTML($items, data, callback);

                    theme.ProductCurrency.update();
                });
            } else {
                $items.html('');

                if(callback) {
                    callback();
                }
            }
        },
        updateFull: function ($popup, callback) {
            var namespace = "wishlist";
            var _ = this,
                $content = $popup.find('.popup-' + namespace + '-full__content');
				
            $content.html('this.namespace');

            var obj = {
                type: 'GET',
                data: {
                    view: namespace
                },
                cache: false,
                success: function(data) {
                    $content.html(data);  
                    if (typeof theme.ProductCurrency != "undefined") {
                    	theme.ProductCurrency.update();
                    }
                    $(".close_popup_ajax").trigger("click");
                    $.magnificPopup.open({
                      items: {
                        src: '.popup-' + namespace + '-full'
                      },
                      type: 'inline',
                      removalDelay: 500, //delay removal by X to allow out-animation
                      tClose: "Close",
                      callbacks: { 
                        close: function(){ 
                          $("a[data-js-tooltip]").each(function(){
                        	$(this).attr("disabled","disabled");
                          })
                        }
                      }
                    }); 
                  if($('.spr-badge-starrating').length > 0){
                    SPR.registerCallbacks();
                    SPR.initRatingHandler();
                    SPR.initDomEls();
                    SPR.loadProducts();
                    SPR.loadBadges();
                  }
                }
            };
			$(document).on("mouseover", "body", function(){ 
              $("a[data-js-tooltip]").each(function() {
              	$(this).removeAttr("disabled", "disabled"); 
              })
            })
            
            if(theme.customer) {
                $.extend(obj, {
                    url: '/cart'
                });
            } else {
                var storage = localStorage.getItem(theme.StoreLists.lists[namespace].current_storage),
                    items = storage ? JSON.parse(storage) : [],
                    constraint = [];

                for(var i = 0; i < items.length; i++) {
                    $.each(items[i], function (v, k) {
                        constraint.push(k + '=' + v);
                    });
                }

                constraint.join('+');				
                $.extend(true, obj, {
                    url: '/collections/all',
                    data: {
                        constraint: constraint
                    }
                });
            }
            $.ajax(obj);
        },
        updateCompareFull: function ($popup, callback) {
            var namespace = "compare";
            var _ = this,
                $content = $popup.find('.popup-' + namespace + '-full__content');
				
            $content.html('this.namespace');
			
            var obj = {
                type: 'GET',
                data: {
                    view: namespace
                },
                cache: false,
                success: function(data) {
                    $content.html(data);  
                    if (typeof theme.ProductCurrency != "undefined") {
                    	theme.ProductCurrency.update();
                    }
                    $(".close_popup_ajax").trigger("click");
                    $.magnificPopup.open({
                      items: {
                        src: '.popup-' + namespace + '-full'
                      },
                      type: 'inline',
                      removalDelay: 500, //delay removal by X to allow out-animation
                      tClose: "Close",
                      callbacks: {
                        close: function(){
                          $("a[data-js-tooltip]").each(function(){                            
                            $(this).attr("disabled","disabled");
                          })
                        }
                      }
                    });   
                    SPR.registerCallbacks();
                    SPR.initRatingHandler();
                    SPR.initDomEls();
                    SPR.loadProducts();
                    SPR.loadBadges();   
                 
                  
                }
            };
            $(document).on("mouseover","body",function(){
              $("a[data-js-tooltip]").each(function(){                            
                $(this).removeAttr("disabled","disabled");
              })
            })

            if(theme.customer) {
                $.extend(obj, {
                    url: '/cart'
                });
            } else {
                var storage = localStorage.getItem(theme.StoreLists.lists[namespace].current_storage),
                    items = storage ? JSON.parse(storage) : [],
                    constraint = [];

                for(var i = 0; i < items.length; i++) {
                    $.each(items[i], function (v, k) {
                        constraint.push(k + '=' + v);
                    });
                }

                constraint.join('+');

                $.extend(true, obj, {
                    url: '/collections/all',
                    data: {
                        constraint: constraint
                    }
                });
            }
            $.ajax(obj);
        } 
    });
    function StoreLists() {
        this.namespaces = [
            'wishlist',
            'compare'
            
        ];

        this.load();
    };
    function Popup(namespace) {
        this.namespace = namespace;
        this.load();
    };

   
    StoreLists.prototype = $.extend({}, StoreLists.prototype, {
        lists: {},
        popups: {},
        load: function () {
            var triggers_array = [];

            for(var i = 0; i < this.namespaces.length; i++) {
                this.lists[this.namespaces[i]] = new Engine(this.namespaces[i], function (obj) {
                    triggers_array.push(obj);
                });               
            }

            if(triggers_array.length) {
                var $button_confirm = $('[data-js-button-transfer-data]');
                $button_confirm.one('click', function () {
                    $button_confirm.attr('data-js-active', true);                    
                });
            }
            this.updateHeaderCount();
        },
        checkProductStatus: function () {          
            $.each(this.lists, function () {                
                this.checkProductStatus();
            });
        },
        updateHeaderCount: function () {
            $.each(this.lists, function () {
                this.updateHeaderCount();
            });
        }
    });
  theme.StoreLists = new StoreLists;
};
(function( $ ) {
   "use strict";
  
      var body = jQuery('body'),
          $ld = jQuery('#ld_cl_bar'),
          $ld_cart = jQuery('.ld_cart_bar'),      
          rtl = body.hasClass('rtl_true'), 
          sp_notices = '#sp_notices_wrapper',     
          window_w = jQuery(window).width();
      var change = false;  
      var interact_main_product = true;
      var id_new ="";
      var ajaxSelector= '.js_filter_block a,.js_ajaxsortby a, .js_paginate_ajax a, a.js_ajax_filter, a.clear_filter_js';
  
      function convert_currency_andy(value, type) {
        var shopCurrency = $("span[data-shop-currency]").attr("data-shop-currency");
        var newCurrency = Currency.currentCurrency;
        if(Currency.currentCurrency=== undefined) newCurrency= 'USD';
        var oldCurrency = shopCurrency;
        
        if (isNaN(value)) {
          value = 0.0;
        }
        
        var cents = 0.0;
        var oldFormat = Currency.moneyFormats['USD'][Currency.format] || '';
        var newFormat = Currency.moneyFormats[Currency.currentCurrency][Currency.format] || '';
        if(Currency.currentCurrency=== undefined) {
            var newFormat = Currency.moneyFormats['USD'][Currency.format] || '';
        }
                                                
        if (oldFormat.indexOf('amount_no_decimals') !== -1) {
             cents = Currency.convert(parseInt(value, 10) * 100, oldCurrency, newCurrency);
        } else if (oldCurrency === 'JOD' || oldCurrency == 'KWD' || oldCurrency == 'BHD') {
             cents = Currency.convert(parseInt(value, 10) / 10, oldCurrency, newCurrency);
        } else {
             cents = Currency.convert(parseInt(value, 10), oldCurrency, newCurrency);
        }
        if (type == 'nosymbol') {
          return cents; 
        }    
                                          
        var my_data = Currency.formatMoney(cents, newFormat);
        return my_data;

      };
     

/* ---------------------------------------------
     Quantity Product Page
--------------------------------------------- */       
               
      // Hàm xoá danh sách cart
      function clearCart(){
		"use strict";
         $.ajax({
          type: "POST",
          url: '/cart/clear.js',
          success: function(){
            location.reload();
          },
          dataType: 'json'
        });                                          	
      }
      // Xử lý sự kiện khi click vào nút clear cart
      $('.clear-cart').on('click',function(e){
        e.preventDefault();
        clearCart();
      }) 
                                           
      function searchURL(url) {        
        try{
          var arr = url.split('&product_type='),
              arr_q = arr[1].split('&q=');
          return arr[0]+'&q='+arr_q[1]+'*'+'+product_type:'+arr_q[0];
        } catch(e){
          return url+'*';
        }       
      };
      function updateShipping(paramPrice){
		var scripts = document.getElementsByTagName('script');
        var ShopId = "";
        var Price = paramPrice;
        
        for(var i = 0, l = scripts.length; i < l; i++){
          if(scripts[i].getAttribute('data-freeshipping-id')!=null){           
            var ShopId = scripts[i].getAttribute('data-freeshipping-id');
          }    
        }
        var start = 0; 
       
      }
  
  	  // Hàm để tạo countdown timer cho giỏ hảng 
  	  var interval = null;
      function create_timer(paramMinutes, paramElement){
		"use strict";
        var timer2 = paramMinutes + ":00";
        clearInterval(interval); 
        interval = null;
        interval = setInterval(function() {
          var timer = timer2.split(':');
          //by parsing integer, I avoid all extra string processing
          var minutes = parseInt(timer[0], 10);
          var seconds = parseInt(timer[1], 10);
          --seconds;
          minutes = (seconds < 0) ? --minutes : minutes;
          if (minutes == 0 && seconds == 0){                   
            clearInterval(interval);
            clearCart();     
            $(".js_mini_time").removeClass("open");
          }
          if (minutes < 0) clearInterval(interval);
          seconds = (seconds < 0) ? 59 : seconds;
          seconds = (seconds < 10) ? '0' + seconds : seconds;
          //minutes = (minutes < 10) ?  minutes : minutes;
          $(paramElement).html(minutes + ':' + seconds);
          timer2 = minutes + ':' + seconds;
        }, 1000);
        
      }
  
  	  // Hàm xoá interval của countdown
      function clearIntervalTimer(){
		"use strict";
        clearInterval(interval);
      }
  	  // Hàm kiểm tra giỏ hàng có sản phẩm không? Nếu có sản phẩm thì bắt đầu countdown
      function checkCart(){
		"use strict";
        $.ajax({
              url: ' /cart.js',
              type: 'GET', 
              dataType: 'json',
              success: function(data) {
                if (data.item_count > 0) {     
                  if($(".js_mini_time").length > 0){                    
                    var vMinutes = $(".js_mini_time").data("minutes");
                    create_timer(vMinutes, ".js_mini_time .count");
                  }
                } 
              }
             
        })
      }
  	  function getshippingdata(){
		"use strict";
        $.ajax({
              url: ' /cart.js',
              type: 'GET', 
              dataType: 'json',
              success: function(data) {
                                
                var vTotalPrice = parseInt(data.total_price / 100);
                var vPrimary_goal = parseInt("70");
                var vGoal_msg = "Congrats! you’ve unlocked free shipping!";
                var background_color = "#FBF2DF";
                var priceConver = "<b>" + convert_currency_andy(vPrimary_goal*100,'xx') + "</b>";
                var freeshippingtext = "Free shipping to your country for orders over  {amount}";
                freeshippingtext = freeshippingtext.replace("{amount}", priceConver);
                var cnewprice = vPrimary_goal -  vTotalPrice;
                var cNewPriceConver = "<b>" + convert_currency_andy(cnewprice*100,'xx')  + "</b>";
                var progresstext = "Only {amount_left} away from free shipping!";
                progresstext = progresstext.replace("{amount_left}", cNewPriceConver);                
                var vElement = '<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_2797_10591)"><path d="M8.66683 23.0003H6.00016C5.63216 23.0003 5.3335 22.7017 5.3335 22.3337C5.3335 21.9657 5.63216 21.667 6.00016 21.667H8.66683C9.03483 21.667 9.33349 21.9657 9.33349 22.3337C9.33349 22.7017 9.03483 23.0003 8.66683 23.0003Z" fill="#121212"/><path d="M30.3336 23H28.6669C28.2989 23 28.0002 22.7013 28.0002 22.3333C28.0002 21.9653 28.2989 21.6667 28.6669 21.6667H29.7802L30.6789 16.8773C30.6669 14.4267 28.5736 12.3333 26.0002 12.3333H21.6229L19.5016 21.6667H23.3336C23.7016 21.6667 24.0002 21.9653 24.0002 22.3333C24.0002 22.7013 23.7016 23 23.3336 23H18.6669C18.4642 23 18.2722 22.908 18.1456 22.7493C18.0189 22.592 17.9709 22.384 18.0162 22.1867L20.4402 11.52C20.5096 11.2147 20.7789 11 21.0909 11H26.0002C29.3082 11 32.0002 13.692 32.0002 17L30.9882 22.456C30.9296 22.772 30.6549 23 30.3336 23Z" fill="#121212"/><path d="M25.9998 25.6667C24.1625 25.6667 22.6665 24.172 22.6665 22.3333C22.6665 20.4947 24.1625 19 25.9998 19C27.8372 19 29.3332 20.4947 29.3332 22.3333C29.3332 24.172 27.8372 25.6667 25.9998 25.6667ZM25.9998 20.3333C24.8972 20.3333 23.9998 21.2307 23.9998 22.3333C23.9998 23.436 24.8972 24.3333 25.9998 24.3333C27.1025 24.3333 27.9998 23.436 27.9998 22.3333C27.9998 21.2307 27.1025 20.3333 25.9998 20.3333Z" fill="#121212"/><path d="M11.3333 25.6667C9.496 25.6667 8 24.172 8 22.3333C8 20.4947 9.496 19 11.3333 19C13.1707 19 14.6667 20.4947 14.6667 22.3333C14.6667 24.172 13.1707 25.6667 11.3333 25.6667ZM11.3333 20.3333C10.2307 20.3333 9.33333 21.2307 9.33333 22.3333C9.33333 23.436 10.2307 24.3333 11.3333 24.3333C12.436 24.3333 13.3333 23.436 13.3333 22.3333C13.3333 21.2307 12.436 20.3333 11.3333 20.3333Z" fill="#121212"/><path d="M8.6665 11.0003H3.33317C2.96517 11.0003 2.6665 10.7017 2.6665 10.3337C2.6665 9.96566 2.96517 9.66699 3.33317 9.66699H8.6665C9.0345 9.66699 9.33317 9.96566 9.33317 10.3337C9.33317 10.7017 9.0345 11.0003 8.6665 11.0003Z" fill="#121212"/><path d="M8.66683 15.0003H2.00016C1.63216 15.0003 1.3335 14.7017 1.3335 14.3337C1.3335 13.9657 1.63216 13.667 2.00016 13.667H8.66683C9.03483 13.667 9.3335 13.9657 9.3335 14.3337C9.3335 14.7017 9.03483 15.0003 8.66683 15.0003Z" fill="#121212"/><path d="M8.66667 19.0003H0.666667C0.298667 19.0003 0 18.7017 0 18.3337C0 17.9657 0.298667 17.667 0.666667 17.667H8.66667C9.03467 17.667 9.33333 17.9657 9.33333 18.3337C9.33333 18.7017 9.03467 19.0003 8.66667 19.0003Z" fill="#121212"/><path d="M18.6668 23H14.0002C13.6322 23 13.3335 22.7013 13.3335 22.3333C13.3335 21.9653 13.6322 21.6667 14.0002 21.6667H18.1348L21.1642 8.33333H6.00016C5.63216 8.33333 5.3335 8.03467 5.3335 7.66667C5.3335 7.29867 5.63216 7 6.00016 7H22.0002C22.2028 7 22.3948 7.092 22.5215 7.25067C22.6482 7.408 22.6962 7.616 22.6508 7.81333L19.3175 22.48C19.2482 22.7853 18.9775 23 18.6668 23Z" fill="#121212"/></g><defs><clipPath id="clip0_2797_10591"><rect width="32" height="32" fill="white"/></clipPath></defs></svg>';
                $('<style>.evm-free-shipping-text-1, .evm-free-shipping-text-2, .evm-free-shipping-text-3{padding:8px 0px;font-weight:600;}  .evm-free-shipping-wrapper{background:'+background_color+';}</style>').appendTo('body');
                $(".evm-freeshipping").empty();
                $(".evm-freeshipping").append("<div id='price-field'></div><div class='evm-free-shipping-wrapper'></div>");

                if(vTotalPrice == 0)
                {
                  $(".evm-freeshipping .evm-free-shipping-wrapper").append("<div class='free-shipping-text evm-free-shipping-text-1'>"+ vElement +"<span>"+freeshippingtext+"  </div>");
                }
                else
                {
                  if(vGoal_msg)
                  {
                    
                    if(vTotalPrice < vPrimary_goal &&  vTotalPrice >= 0 &&  vTotalPrice != 0)
                    {
                      $(".evm-freeshipping .evm-free-shipping-wrapper").append("<div class='free-shipping-text evm-free-shipping-text-1'>"+ vElement +"<span>" +progresstext+"</span></div>");
                    }
                    else if(vTotalPrice >= vPrimary_goal )
                    {
                      $(".evm-freeshipping .evm-free-shipping-wrapper").append("<div class='free-shipping-text evm-free-shipping-text-2 congratulation'>"+ vElement +"<span>"+vGoal_msg+"</span></div>");
                    }
                    else
                    {
                      $(".evm-freeshipping .evm-free-shipping-wrapper").append("<div class='free-shipping-text evm-free-shipping-text-3'>"+ vElement +"<span>" + freeshippingtext);
                    }
                  }else{
                    $(".evm-freeshipping .evm-free-shipping-wrapper").append("<div class='free-shipping-text evm-free-shipping-text-1'>"+ vElement +"<span>"+freeshippingtext+"  </span></div>");
                  }
                }
                var vPercent = parseInt(vTotalPrice / vPrimary_goal * 100);
                if(vPercent >= 100){
                  vPercent = 100;
                  if($(".pyro").length > 0){
                    $(".pyro").addClass("open");
                    setTimeout(function(){
                      $('.pyro').removeClass('open');
                    },5000);
                  }
                }
                if(vPercent <= 4){
                  vPercent = 4;
                }
				
                if($("div[data-bar-progress]").length > 0){
                  $("div[data-bar-progress]").css('width',vPercent + '%');
                }
                $("#js_cart_popup .mini_progress").addClass("open");
              }
        })
      }
  	  // Hàm show danh sách popup giở hàng
      function ShowCart(paramAction){   
            $.ajax({
              url: ' /cart.js',
              type: 'GET', 
              dataType: 'json',
              success: function(data) {
               
                $(".js-cart-count").text(data.item_count);
                $(".js-cart-inner").empty();   
                $(".js-total-price").empty();                                      
                var html = '';                                      
                if (data.item_count > 0) {      
                      $(".js-cart-inner").removeClass("cart-empty");                            
                      var index_item = 0;

                      /*html = html + '<h5 class="title">You have <span class="count-item">'+data.item_count+ '</span> item(s) in your cart</h5>';*/
                        html = html + '<ul class="list-item">';
                            $.each(data.items, function(index, el) {   
                              
                              var vTitle = el.title;
                              var vCheck = false;
                              var vTitleValue = vTitle;
                              var vVariant = null;
                              var vQuantity = el.quantity;
                              
                              if(vQuantity < 10){
                                vQuantity = "0"+vQuantity;
                              }
                              if(vTitle.includes("-")){
                                 var pos = vTitle.indexOf("-");
                                 vTitleValue = vTitle.substr(0,pos);
                                 vVariant = vTitle.substr(pos+1);    
                                if(vVariant.includes(" /")){
                                  vVariant = vVariant.replace(" /", ",");
                                }
                              }
                            html = html + '<li class="product-item" id="item-'+el.id+'">';
                              html = html + '<a href="'+el.url+'" class="thumb"><img class="lazyload" data-src="'+el.image +'" width="80" height="80" alt="'+el.title+'" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="></a>';
                              html = html + '<div class="info">';
                                html = html + '<a href="'+el.url+'" class="product-name">'+ vTitleValue +'</a>';
                                if(vVariant != null){
									 html = html + '<span class="variant">'+ vVariant +'</span>';
                                  
                                }
                                html = html + '<div class="product-item-qty">';
                                  html = html + '<span class="number price">';
                                    html = html + '<span ><span class="amount"><span class="money" data-currency-'+Currency.currentCurrency+'="'+convert_currency_andy(el.price,'xx')+'">'+convert_currency_andy(el.price,'xx')+'</span></span></span>';
                                  html = html + '</span>';
                                 /* html = html + '<span class="qty"> Qty: ' + el.quantity+ '</span>';*/
                                html = html + '</div>';  
                              	html = html + '<div class="js-quantity quantity">';
                                  html = html + '<div class="group-quantity-button">';
                                    html = html + '<a class="js_minus" href="#">';
                                      html = html + '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.0004 13H5.00037V11H19.0004V13V13Z"/></svg>';
                                    html = html + '</a>';
                                    html = html + '<input data-id="'+el.id+'" class="inp-quantity js_qty" style="text-align: center;" data-step="1" data-min="1" type="text" size="4" title="Qty" value="'+ vQuantity +'" name="quantity" data-max="">';
                                    html = html + '<a class="js_plus" href="#">';
                                      html = html + '<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M19.0006 13H13.0006V19H11.0006V13H5.00061V11H11.0006V5H13.0006V11H19.0006V13Z"/></svg>';
                                    html = html + '</a>';
                                  html = html + '</div>';
                                  html = html + '<a class="js-remove-item remove" href="javascript:void(0);" data-id="'+el.id+'" title="Remove this item"> Remove';
                                  html = html + '</a>';
                             	html = html + '</div>';
                              
                              
                              html = html + '</div>';
                             
                              	
                              html = html + '</a>';
                            html = html + '</li>';   
                            });  
                       html = html + '</ul>';                         
                      if($(".js_mini_time").length > 0){
                        $(".js_mini_time").addClass("open"); // show countdown timer at cart popup    
                        if(paramAction == 'add'){   
                        	// Gọi hàm tạo countdown timer trong giỏ hàng
                        	if($(".js_mini_time").length > 0){                    
                              var vMinutes = $(".js_mini_time").data("minutes");
                              create_timer(vMinutes, ".js_mini_time .count");
                            }
                        }
                      }

                  }else{ 
                       html = html + '<div class="cart-empty">';
                              html = html + '<i class="fa fa-shopping-bag"></i><p>Your cart is currently empty.</p> ';
                       html = html + '</div>'; 
                   	// 
                    if($(".js_mini_time").length > 0){
                    	$(".js_mini_time").removeClass("open"); // hide countdown timer at cart popup
                    }
                  }

                  $(".js-cart-inner").html(html);                  
                  $(".js-total-price").html(convert_currency_andy(data.total_price ));// Cập nhật giá   
                  $(".js-total-price").attr('data-total-price-cart',data.total_price);// Cập nhật giá
                  updateShipping(data.total_price);  // Cập nhật shipping  
                	
                  // Hiển thi thông điệp khi thêm sản phẩm vào giỏ hàng	
                  if(paramAction == 'add'){                    
                    setTimeout(function(){
                      	$("#js_cart_content").prepend('<div class="cms_message_cart"><span class="green"><i class="fas fa-smile"></i> Product added to cart successfully</span></div>');  
                  		$("#js_cart_content .cms_message_cart").addClass("open");
                    },1000);
                    setTimeout(function(){
                       $("#js_cart_content .cms_message_cart").removeClass("open");
                       $("#js_cart_content .cms_message_cart").empty();
                     },3500);                              
                  }
                  
                }
              
              })  
              // Cập nhật lại free shipping
                getshippingdata();
          };
     
      function get_pid_variant(option){
            var js_product_selectors = $("#js-product-selectors");                                      
            var result  = js_product_selectors.val();
            js_product_selectors.find("option").each(function(){
                                               
                var str = $(this).text();
                var arr = str.split(' - ');
                arr[arr.length] = $(this).val();
                //console.log($(this).val());
                var ok = true;
                var count = 0;
              for(var i = 0; i < option.length; i++){
                for(var j = 0; j< arr.length; j++){
                  if(option.length >= 1){
                    var tg = arr[j].replace(/ /g,'');
                  }else{
                    var tg = arr[j]; 
                  }
                  var val = tg.split('/');
                  for(var k=0; k < val.length; k++){
                    var option_trim = option[i].replace(/ /g,'');
                    if(option_trim == val[k]){
                      count++;
                    }
                  }              
                }
              }
              if(count != option.length){
                ok = false;
              }
              if (ok==true){
                result =  arr[arr.length - 1];  
                //console.log("Tìm thấy");
                return false;
              }          
            });
            
        return result;
      }
      function TriggerSidebarDropdown() {
        if (body.hasClass('pside_opened')) return;
        // Show hidden sidebar/dropdown             
        jQuery('.cms_popup[data-id="#js_cart_popup"]').trigger('click');             
      };
      function TriggerAfterATC(bl,id) {            
        TriggerSidebarDropdown();            
      };
  	  function addItemFrom(item, _this){
        	var $this = jQuery(_this);  
        	 $this.css({'opacity':'.5'});  
            var params = {
              type: 'POST',
              url: '/cart/add.js',
              data: {
                "items": item
              },
              dataType: 'json',
              success: function(response) { 
                 var vAction = "add";
                 ShowCart(vAction);                  
                 $this.css({'opacity':'1'}); 
                 TriggerSidebarDropdown();          	
                 
              },
              error: function(XMLHttpRequest, textStatus) {
                cmsheroShopify.onError(XMLHttpRequest, textStatus);
                $this.attr('disabled', 'disabled').attr('data-button-status', 'sold-out');
                $this.find('.text').text("Sold Out"); 
                $this.find(".txt_add").text("Sold Out");
              }
            };
                                      
            $.ajax(params);
            
        };
      function addProduct(item,_this) { 
          var $this = jQuery(_this);  
          $this.css({'opacity':'.5'});  
          var params = {
              type: 'POST',
              url: '/cart/add.js',
              data:{
               "items": item
              },
              dataType: 'json',
              success: function(response) {   
                var vAction = "add";
                ShowCart(vAction);                  
                $('.js_add_to_cart_button').removeAttr("disabled").css('pointer-events', 'auto');  
                $this.css({'opacity':'1'}); 
                TriggerSidebarDropdown(); 
              },
              error: function(XMLHttpRequest, textStatus) {                
                $this.attr('disabled', 'disabled').attr('data-button-status', 'sold-out');
                $this.find('.text').text("Sold Out"); 
                $this.find(".txt_add").text("Sold Out");                         
              }
            };
            $.ajax(params);
        };
 		
	    function buyItNow(item,_this) { 
          var $this = jQuery(_this);         
          var params = {
              type: 'POST',
              url: '/cart/add.js',
              data:{
               "items": item
              },
              dataType: 'json',
              success: function(response) {               
              	window.location.href="/checkout";
              },
              error: function(XMLHttpRequest, textStatus) {                
                $this.attr('disabled', 'disabled').attr('data-button-status', 'sold-out');
                $this.find('.text').text("Sold Out"); 
                $this.find(".txt_add").text("Sold Out");         
              }
            };
            $.ajax(params);
        };
        

        function changeItem(vid, qty, _item) {
          var params = {
            type: 'POST',
            url: '/cart/change.js',
            data:  'quantity='+qty+'&id='+vid,
            dataType: 'json',
            success: function(cart) {              
              $(".js-total-price").html(convert_currency_andy(cart.total_price)); /*Cập nhật lại giá của giỏ hàng*/
              $(".js-total-price").attr('data-total-price-cart',cart.total_price);
              $(".js-cart-count").text(cart.item_count); // Cập nhật lại số lượng sản phẩm trên giỏ hàng
              cmsheroShopify.onCartUpdate(0,0);
              updateShipping(cart.total_price);
              // Cập nhật lại free shipping
              getshippingdata();

            },
            error: function(XMLHttpRequest, textStatus) {
              cmsheroShopify.onError(XMLHttpRequest, textStatus);
            },
            complete: function() {             
             
            }
          };
          $.ajax(params);
        };
        
      	if($("#Quantity").attr("data-max") == 0){
          $("#Quantity").val($("#Quantity").attr("data-max"));
        }
      
   cmsheroShopify = (function() {
        var 
          cmsheroTheme = {
            popupAnimation: 'mfp-move-horizontal',            
            money_format : '$'
        };
        return {
           init: function() {
             //localStorage.clear();
             if(type_name == "product"){
             	cmsheroShopify.recently_viewed();
                var ls = localStorage.getItem('product_recent'),
                    id = 'id:'+$('.main-content.shop-page.main-content-detail').attr('id');

                if (ls != null) { 
                var arrls = ls.split(','),
                    index = arrls.indexOf(id);

               } else { 
                var arrls = new Array();
              }
               if ( arrls.indexOf(id) < 0  ) {                         
                 arrls.unshift(id);
                 localStorage.setItem('product_recent', arrls.toString());
                 //console.log("Product was added to localStorage!")
               }else{
                 //console.log("Couldn't add product to localStorage!")
               }
             }
             if ( $('#js_recently_wrapper').length > 0 ) {
               $('#js_recently_wrapper').addClass('lazyload').one('lazyloaded', function(e) {
                 cmsheroShopify.recently_viewed();
                 
               });
             }
             
             	getshippingdata();
             
             /*
             if ( $('#js_recently_wrapper1').length > 0 ) {
                 cmsheroShopify.recently_viewed1();
             }*/
             cmsheroShopify.SalesPopup();
             /*$('.js_lz_slpr.dn').removeClass('dn').addClass('lazyload').one('lazyincluded', function(e) {       
                  cmsheroShopify.SalesPopup();
             });*/
                          
             $("div[data-wrapper-slidershow] .content-item").css('visibility',"visible");
           },
           formatMoney: function(cents, format) {
              if (typeof cents == 'string') { cents = cents.replace('.', ''); }
              var value = '',
                  placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
                  formatString = (format || t_moneyFormat || '$');

              var defaultOption = function(opt, def) {
                 return (typeof opt == 'undefined' ? def : opt);
              }

              var formatWithDelimiters = function(number, precision, thousands, decimal) {
                 precision = defaultOption(precision, 2);
                 thousands = defaultOption(thousands, ',');
                 decimal = defaultOption(decimal, '.');

                 if (isNaN(number) || number == null) {
                    return 0;
                 };

                 number = (number / 100.0).toFixed(precision);

                 var parts = number.split('.');
                 var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
                 var cents = parts[1] ? (decimal + parts[1]) : '';

                 return dollars + cents;
              }

              switch (formatString.match(placeholderRegex)[1]) {
                 case 'amount':
                    value = formatWithDelimiters(cents, 2);
                    break;
                 case 'amount_no_decimals':
                    value = formatWithDelimiters(cents, 0);
                    break;
                 case 'amount_with_comma_separator':
                    value = formatWithDelimiters(cents, 2, '.', ',');
                    break;
                 case 'amount_no_decimals_with_comma_separator':
                    value = formatWithDelimiters(cents, 0, '.', ',');
                    break;
              }

              return formatString.replace(placeholderRegex, value);
           },
           consoleTheme: function(e, t, n, r) {
               console.log("%c ".concat(e, " %c ").concat(t, " %c"), "background:".concat(n || "#35495f", " ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff"), "background:".concat(r || "#41b883", " ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff"), "background:transparent")
           },
           getRandomInt : function (min, max) {
                return Math.floor(Math.random() * (max - min + 1)) + min;
           },
           SalesPopup : function () {
              if ($('div[data-popup-crossell]').length == 0  || $(window).width() < 768) return;
                
                var popup = $('div[data-popup-crossell]'),
                    stt = popup.data('stt'),
                    show = stt.show,
                    limit = stt.limit - 1,
                    pp_type = stt.pp_type, 
                    catLink = stt.catlink,
                    arrId = JSON.parse($('#id_sale_pp').html()),
                    arrTitle = JSON.parse($('#title_sale_pp').html()),
                    arrUrl = stt.url,
                    arrImage = stt.image,
                    arrID = stt.id,
                    arrLocation = JSON.parse($('#location_sale_pp').html()),
                    arrTime = JSON.parse($('#time_sale_pp').html()),
                    ClassUp = stt.ClassUp,
                    ClassDown = stt.classDown[ClassUp],
                    StarTimeout,StayTimeout,

                    slpr_img = $('.js_slpr_img'),
                    slpr_a = $('.js_slpr_a'),
                    slpr_tt = $('.js_slpr_tt'),
                    slpr_location = $('.js_slpr_location'),
                    slpr_ago = $('.js_slpr_ago'),
                    slpr_qv = $('.pp_slpr_qv'),

                    index = 0,
                    min = 0,
                    max = arrUrl.length - 1,
                    max2 = arrLocation.length - 1,
                    max3 = arrTime.length - 1,
                    StarTime = stt.StarTime * stt.StarTime_unit,
                    StayTime = stt.StayTime * stt.StayTime_unit;

              
                  var Updatedata = function (index) {

                    // update img 
                    var img = arrImage[index],
                         img_url = img.replace(".jpg?v=", "_65x.jpg?v=").replace(".png?v=", "_65x.png?v=").replace(".gif?v=", "_65x.gif?v="),
                         img_url2 = img.replace(".jpg?v=", "_130x.jpg?v=").replace(".png?v=", "_130x.png?v=").replace(".gif?v=", "_130x.gif?v=");
                    slpr_img.attr('src',img_url).attr('srcset',img_url+' 1x,'+img_url2+' 2x');

                    // update title
                    slpr_tt.text(arrTitle[index]);
                    slpr_tt.attr("data-pid",arrId[index]);
                    // update link
                    slpr_a.attr('href',arrUrl[index]);
                    
                    // update id quick view
                    slpr_qv.attr('data-id',arrID[index]);

                    // update location
                    slpr_location.text(arrLocation[cmsheroShopify.getRandomInt(min, max2)]);

                    // update time
                    slpr_ago.text(arrTime[cmsheroShopify.getRandomInt(min, max3)]);

                    showSalesPopUp();
                  };

                // Load sales popup
                var loadSalesPopup = function () {
                  //if (nt_check) return;
                    if (pp_type == '1') {
                      Updatedata(index);
                      ++index;
                      if (index > limit || index > max) {index = 0} 

                    } else {
                     Updatedata(cmsheroShopify.getRandomInt(min, max));
                    }

                    StayTimeout = setTimeout(function() {
                        unloadSalesPopup();
                    }, StayTime);
               };

               // unLoad sales popup
               var unloadSalesPopup = function () {
                  hideSalesPopUp();
                  StarTimeout = setTimeout(function(){                    
                     loadSalesPopup();
                  }, StarTime);
               };
               //slideOutDown, fadeOut

               var showSalesPopUp = function () {
                 popup.removeClass('hide').addClass(ClassUp).removeClass(ClassDown); 
               };

               var hideSalesPopUp = function () {
                  popup.removeClass(ClassUp).addClass(ClassDown); 
               };

               $(".pp_slpr_close").on("click", function(e){
                   e.preventDefault();
                  hideSalesPopUp();
                  clearTimeout(StayTimeout);
                  clearTimeout(StarTimeout);
               });

               popup.on('open_slpr_pp', function () {
                  unloadSalesPopup();
               });
               

               if (designMode ) return;

               // Run unloadSalesPopup 
               unloadSalesPopup();

            },
            back_to_top: function(){
              $(window).scroll(function(){
                  if ($(this).scrollTop() > 300) {
                      $('.back-to-top').fadeIn();
                      $('.back-to-top').addClass('show');
                  } else {
                      $('.back-to-top').fadeOut();
                      $('.back-to-top').removeClass('show');
                  }
              });
              $(document).on('click','.back-to-top',function(){
                  $('html, body').animate({scrollTop : 0},800);
                  return false;
              });

            },          
            clone_main_menu: function(){ 
              var b = function (f, e) {
                    return e + f
              }
              var d = function (e, f) {
                    if (e.find(".menu-item-has-children").length) {
                        e.find(".menu-item-has-children").each(function() {
                            var i = jQuery(this);
                            d(i, f);
                            var g = "cms-panel-" + f;
                            while (jQuery("#" + g).length) {
                                f++;
                                g = "cms-panel-" + f
                            }
                            i.prepend('<a class="cms-next-panel" href="#' + g + '" data-target="#' + g + '"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.72402 10.0809C3.57366 9.9366 3.55999 9.7108 3.68302 9.55168L3.72402 9.50609L7.37729 5.99995L3.72402 2.49381C3.57366 2.34951 3.55999 2.1237 3.68302 1.96458L3.72402 1.919C3.87439 1.7747 4.10968 1.76158 4.27548 1.87964L4.32299 1.919L8.27593 5.71255C8.42629 5.85685 8.43996 6.08265 8.31693 6.24177L8.27593 6.28736L4.32299 10.0809C4.15759 10.2396 3.88942 10.2396 3.72402 10.0809Z" fill="#121212"/></svg></a>');
                            var h = jQuery("<div>").append(i.find("> .submenu").clone()).html();
                            i.find("> .submenu").remove();
                            jQuery(".cms-clone-wrap .cms-panels").append('<div id="' + g + '" class="cms-panel cms-sub-panel cms-hidden">' + h + "</div>")
                        })
                    }
              }
              var c = function () {
                if (!jQuery(".cms-clone-wrap").length) {
                    jQuery("#site-header-wrap.header").prepend('<div class="cms-clone-wrap"><div class="cms-panels-actions-wrap"><span class="cms-close-btn cms-close-panels"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/><path d="M6 6L18 18" stroke="inherit" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></span></div><div class="cms-search-panel"></div><div class="cms-panels"></div><div class="cms-footer-panel"></div></div>')
                    jQuery("#site-header-wrap .site-header__logo-image").clone().appendTo(".cms-panels-actions-wrap");
                    if(jQuery(".header-nav .topbar-product-search").length > 0){
                    	jQuery(".header-nav .topbar-product-search").clone().appendTo(".cms-search-panel");
                    }else{
                      	if(jQuery(".topbar-product-search").length > 0){
                          jQuery(".topbar-product-search").clone().appendTo(".cms-search-panel");
                        }
                    }
                  	if(jQuery("header .middle-bar.hidden-sm .menu-language").length > 0){
                      jQuery("header .middle-bar.hidden-sm .menu-language").clone().appendTo(".cms-footer-panel");
                      jQuery("header .middle-bar.hidden-sm .list-socials").clone().appendTo(".cms-footer-panel");
                    }else{
                      jQuery("header .menu-language").clone().appendTo(".cms-footer-panel");
                      jQuery("header .list-socials").clone().appendTo(".cms-footer-panel");
                    }
                }
                var e = 0;
                var f = Array();
                jQuery(".clone-main-menu").each(function() {
                    var g = jQuery(this);
                    var l = g;
                    var i = l.attr("id");
                    var h = "cms-clone-" + i;
                    if (!$("#" + h).length) {
                        var j = g.clone(true);
                        j.find(".menu-item").addClass("clone-menu-item");
                        j.find("[id]").each(function() {
                            j.find('.vc_tta-panel-heading a[href="#' + jQuery(this).attr("id") + '"]').attr("href", "#" + b(jQuery(this).attr("id"), "cms-clone-"));
                            jQuery(this).attr("id", b(jQuery(this).attr("id"), "cms-clone-"))
                        });
                        j.find(".cms-menu").addClass("cms-menu-clone");
                        if (!jQuery(".cms-clone-wrap .cms-panels #cms-panel-" + i).length) {
                            jQuery(".cms-clone-wrap .cms-panels").append('<div id="cms-panel-' + i + '" class="cms-panel cms-main-panel"><ul class="depth-01"></ul></div>')
                        }
                        var k = jQuery(".cms-clone-wrap .cms-panels #cms-panel-" + i + " ul");
                        k.html(j.html());
                        d(k, e)
                    }
                })
              }
              c();   
              
              
              jQuery(document).on("click", ".cms-next-panel", function(g) {
                  var f = jQuery(this);
                  var j = f.closest(".menu-item-has-children");
                  var k = f.closest(".cms-panel");
                  var i = f.attr("href");                
                //find id parent of li
                  var parent_id = f.parent().attr("id");
                  var _pos = parent_id.indexOf("_");
                  var id_num = parent_id.substring(_pos+1);
                  var lazy_id = "cms-clone-bk_"+id_num;
                  
                  if (jQuery(i).length) {
                       /* Menu lazy click */   
                      jQuery(i).find(".lazy_menu").removeClass("lazyloading").addClass("lazyload").on("lazyincluded",function(){		
                      })
                      k.addClass("cms-sub-opened");
                      jQuery(i).addClass("cms-panel-opened").removeClass("cms-hidden").attr("data-parent-panel", k.attr("id"));
                      var h = j.find(".cms-item-title").attr("title");
                      if (typeof h != "undefined" && typeof h != false) {
                          if (!jQuery(".cms-panels-actions-wrap .cms-current-panel-title").length) {
                              jQuery(".cms-panels-actions-wrap").prepend('<span class="cms-current-panel-title"></span>')
                          }
                          jQuery(".cms-panels-actions-wrap .cms-current-panel-title").html(h)
                      } else {
                          jQuery(".cms-panels-actions-wrap .cms-current-panel-title").remove()
                      }
                      jQuery(".cms-panels-actions-wrap .cms-prev-panel").remove();
                      jQuery(".cms-panels-actions-wrap").prepend('<a class="cms-prev-panel" href="#' + k.attr("id") + '" data-cur-panel="' + i + '" data-target="#' + k.attr("id") + '"></a>')
                  }
                 
                  
                  g.preventDefault()
              });
              jQuery(document).on("click", ".cms-prev-panel", function(h) {
                  var f = jQuery(this);
                  var g = f.attr("data-cur-panel");
                  var k = f.attr("href");
                  jQuery(g).removeClass("cms-panel-opened").addClass("cms-hidden");
                  jQuery(k).addClass("cms-panel-opened").removeClass("cms-sub-opened");
                  var j = jQuery(k).attr("data-parent-panel");
                  if (typeof j == "undefined" || typeof j == false) {
                      jQuery(".cms-panels-actions-wrap .cms-prev-panel").remove();
                      jQuery(".cms-panels-actions-wrap .cms-current-panel-title").remove()
                  } else {
                      jQuery(".cms-panels-actions-wrap .cms-prev-panel").attr("href", "#" + j).attr("data-cur-panel", k).attr("data-target", "#" + j);
                      var i = jQuery("#" + j).find('.cms-next-panel[data-target="' + k + '"]').closest(".menu-item").find(".cms-item-title").attr("data-title");
                      if (typeof i != "undefined" && typeof i != false) {
                          if (!jQuery(".cms-panels-actions-wrap .cms-current-panel-title").length) {
                              jQuery(".cms-panels-actions-wrap").prepend('<span class="cms-current-panel-title"></span>')
                          }
                          jQuery(".cms-panels-actions-wrap .cms-current-panel-title").html(i)
                      } else {
                          jQuery(".cms-panels-actions-wrap .cms-current-panel-title").remove()
                      }
                  }
                  h.preventDefault()
              });
              jQuery(document).on("click", ".mobile-navigation", function() {
                  jQuery(".cms-clone-wrap").addClass("open");
                  return false
              });
              jQuery(document).on("click", ".cms-clone-wrap .cms-close-panels", function() {
                  jQuery(".cms-clone-wrap").removeClass("open");
                  return false
              })
              jQuery(document).on("click", ".cms-panels .cms-item-title" , function(e) {
                var p = $(this).closest(".menu-item");
                var link = $(this).attr("href");
                if (p.hasClass('menu-item-has-children')){                  
                   p.find(".cms-next-panel").trigger("click");
                }else{
                   window.location.href = link;
                }
                return false;              	
              })
            },
            popupSidebar : function() {
                var mask = $('.mask-overlay'),
                    classActive = 'act_current',
                    html = $('html');

                jQuery(document).on("click", ".cms_popup", function (e) {                   
                   var _this = $(this),
                       _id = _this.data('id'), 
                       $id = $(_id);
                   
                   if ( $id.length == 0 ) return;
                   e.preventDefault();
                
                   closeMenu();
                   if (!_this.hasClass(classActive)) { openMenu(_this,_id,$id) }

                });
                // click touchstart
                jQuery(document).on("click touchstart", ".mask-overlay", function (e) {                  
                   closeMenu();
                });
                jQuery(document).on('click', '.act_opened .close_popup_ajax', function () {
                   closeMenu();
                });

                function openMenu(_this,_id,$id) {                
                   _this.addClass(classActive);
                   html.addClass('hside_opened');
                   body.addClass('pside_opened');
                   $id.addClass('act_opened');
                   mask.addClass('mask_opened');   
                  // Kiểm tra nếu click vào icon giỏ hàng và countdown timer tồn tại thì sẽ kiểm tra và chạy countdown timer
                  if(_id == "#js_cart_popup" && $("#js_cart_popup .js_mini_time").length > 0){                    
                    checkCart();
                  }
                }

                function closeMenu() {
                   jQuery('.cms_popup.act_current').removeClass(classActive);
                   html.removeClass('hside_opened');
                   body.removeClass('pside_opened');
                   jQuery('.hero_canvas.act_opened').removeClass('act_opened');
                   mask.removeClass('mask_opened'); 
                   // Nếu tồn tại tính năng countdown giỏ hàng thì sẽ xoá interval khi đóng popup
                   if($("#js_cart_popup .js_mini_time").length > 0){                       
                     if(interval != null ){
                       clearIntervalTimer();
                     }
                   }
                }
             },            
            searchProduct : function () {
                 if (body.hasClass('js_search_false')) return;

                  var slug_js = '&view=js', timer = 0, data,_this,frm,btn,$result,ld_bar,skeleto,val_old,val_currect;
                  var $ntSearch = $('#js_search_popup');
                  $(".js_iput_search").trigger("focus");
                  jQuery(document).on('mouseover',"#js_search_popup",function(){                    
                    if (typeof theme.ProductCurrency != "undefined") {
                      theme.ProductCurrency.update();                       
                    }else{
                      
                    }
                  });
              	
              	  /* Change currency */
                  $(".middle-bar div[data-prs-search]").hide();
              	  /* End change */
              	  jQuery(document).on('click', 'form[data-js-search-form] .js_btn_search', function(event) {
                    event.preventDefault();
                    var vSearch = $("form[data-js-search-form] .js_iput_search").val();                    
                    $(".js_iput_search").val(vSearch + "*");
                    jQuery("form[data-js-search-form]").submit();
                  })
                  jQuery(document).on('keyup', '.js_iput_search', function(e,bl) {
                     var _this = $(this);
                     var frm = _this.closest("form");
                     var popup_inner = _this.closest(".js-popup-inner");
                     var btn = frm.find('.js_btn_search');
                     _this.attr('autocomplete', 'on');
                     var $result = popup_inner.find('div[data-prs-search]');
                     var ld_bar = popup_inner.find('.ld_bar_search');
                     var top_search = popup_inner.find('div[data-js-top-search]');
                     var loading = popup_inner.find('div[data-wrap-prs-search]');
                     var val_currect = _this.val();
                    if ( (val_old == val_currect || val_currect == "") && bl != '1' ) return;
                    ld_bar.addClass('on_star');
                    $result.hide();
                    
                    
                    loading.addClass('ajax_loading'); 
                    $('.cl_h_search').addClass('atc_show_rs');
                    if (btn.hasClass('use_jsfull') && $(window).width() > 1024) {
                        slug_js = '&view=js_full'
                    } else { 
                        slug_js = '&view=js';
                    }

                    clearTimeout(timer);
                    timer = setTimeout(function () {                     
                    data = searchURL(frm.serialize());
                   
                    $.ajax({
                      url: frm.attr('action'), 
                      data : data+slug_js,
                      success: function(result){
                        var arr = result.split('||');
                        $('.search_header__prs>span').html("Search Results:");
                         $('.search_header__prs>span').hide();                        
                         $(arr[0]).show();
                          $result.html(arr[1]);
                          val_old = val_currect;
                          body.trigger('refresh_currency');
                       },
                      error: function(xhr,status,error){
                        console.log(error);
                        loading.removeClass('ajax_loading');
                       },
                      complete: function(){                        
                        btn.removeClass('pe_none');
                        ld_bar.addClass('on_end');
                         setTimeout(function(){ 
                            ld_bar.attr('class', '').addClass('ld_bar_search');                            
                            popup_inner.find("div[data-wrap-prs-search ]").show();
                           	popup_inner.find("div[data-wrap-prs-search]").addClass("has-result");
                           	loading.removeClass('ajax_loading');
                            $result.show();
                             if(top_search.length > 0){
                               top_search.hide();
                             }
                         }, 280);
                       }
                    });
                  }, 400);
                    
                    /*var code = e.which;
                    if(code == 13) {                      
                      $(this).val(val_currect + "*"); 
                      $(".js_btn_search").removeAttr("disabled");
                      $(".js_btn_search").css('pointer-events','auto');
                      $(".js_btn_search").trigger('click');
                    }*/

                  });
                
                 $ntSearch.on('change', 'select', function() {                   
                    $ntSearch.find('.js_iput_search').trigger('keyup',1);
                  });

                  $('.h_search_frm').on('change', 'select', function() { 
                    $('.h_search_frm .js_iput_search').trigger('keyup',1);
                  });

                $ntSearch.addClass('lazyload').one('lazyincluded', function(e) {
                   //console.log('search ajax')
                  body.trigger('refresh_currency');                
                  val_old = '';
                  
                });   
              
              	// Focus input search khi hiển thị giao diện search
                $(document).on("click","a[data-id='#js_search_popup']",function(){
                  $("form[data-js-search-form] .js_iput_search").focus();
                })
                // Focus input search khi hiển thị giao diện search trên mobile
                $(document).on("click","#site-header-wrap .menu-bar",function(){
					$("#site-header-wrap .js_iput_search").focus();
                })
            },
            onCartUpdate : function(bl,blUp_items,id) {
              //console.log(blUp_items)
              if (body.hasClass('template-cart')) {
                $.get('/cart?view=pagejs', function(data) {
                  var arrCat = data.split("<!--split-->");

                  if (arrCat[0] != $('.jsccount').first().html() ) {
                   if ( parseInt(arrCat[0]) == 0 ) {
                       $('.nt_js_cart, .js_cart_cd').hide();
                       $('.shipping_calc_page').addClass('dn');
                       $('.empty_cart_page').show();
                    } else {
                       $('.empty_cart_page').hide();
                       $('.nt_js_cart, .js_cart_cd').show();
                       $('.shipping_calc_page').removeClass('dn');
                    }

                    $('.jsccount').html(arrCat[0])
                    var aar1 = arrCat[1].split(',]'),
                        this_thres = $('.cart_thres_'+aar1[0]);
                    if (aar1 != 'spt4') {
                         this_thres.find('.mn_thres_js').html( aar1[1] );
                      if (this_thres.is(":hidden")) {
                        $('.cart_thres_1,.cart_thres_2,.cart_thres_3').slideUp(200);
                           this_thres.slideDown(250);
                      }
                    }
                    if (blUp_items) {$('.js_cat_items').html(arrCat[2]);}
                    $('.js_cat_dics').html(arrCat[3]);
                    $('.js_cat_ttprice').html(arrCat[4]);

                       //console.log(arrCat[5])
                    if (arrCat[5] == '1') {
                         $('.js_gift_wrap').addClass('dn');
                    } else {
                         $('.js_gift_wrap').removeClass('dn');
                    }

                    body.trigger('refresh_currency');
                  }
                  $('.nt_js_cart.loading, .js_addtc.loading, .js_frm_cart.loading, .js_add_group.loading, .sticky_atc_js.loading').removeClass('loading');
                  $ld.trigger( "ld_bar_end" );
                  if (blUp_items) {
                     $('html, body').animate({
                          scrollTop: $('#shopify-section-cart-template').offset().top - 40
                     }, 400);
                  }
                });

              } else {

                $.get('/cart?view=js', function(data) {
                  var arrCat = data.split("<!--split-->");

                  if (arrCat[0] != $('.jsccount').first().html() ) {
                    if ( parseInt(arrCat[0]) == 0 ) {
                       $('.nt_js_cart .js_cart_note,.nt_js_cart .js_cart_footer,.nt_js_cart .js_cart_tool,.js_cat_items,.js_cart_cd').hide();
                       $('.nt_js_cart .empty').show();
                    } else {
                       $('.nt_js_cart .empty').hide();
                       $('.nt_js_cart .js_cart_note,.nt_js_cart .js_cart_footer,.nt_js_cart .js_cart_tool,.js_cat_items,.js_cart_cd').show();
                    }

                    $('.jsccount').html(arrCat[0])
                    var aar1 = arrCat[1].split(',]'),
                        this_thres = $('.cart_thres_'+aar1[0]);
                    if (aar1 != 'spt4') {
                         this_thres.find('.mn_thres_js').html( aar1[1] );
                      if (this_thres.is(":hidden")) {
                        $('.cart_thres_1,.cart_thres_2,.cart_thres_3').slideUp(200);
                           this_thres.slideDown(250);
                      }
                    }
                    if (blUp_items) {$('.js_cat_items').html(arrCat[2]);}
                    $('.js_cat_dics').html(arrCat[3]);
                    $('.js_cat_ttprice').html(arrCat[4]);

                    if (arrCat[5] == '1') {
                      $('.js_cart_tls_back').trigger('click')
                         $('.js_gift_wrap').addClass('dn');
                    } else {
                         $('.js_gift_wrap').removeClass('dn');
                    }

                       if ( $('.popup_uppr_wrap').length > 0 ) {
                         id = 19041994;
                         TriggerAfterATC(bl,id);
                       } else if ($.magnificPopup.instance.isOpen){
                      $.magnificPopup.close();
                      setTimeout(function(){ TriggerAfterATC(bl,id); }, 505);
                    } else {
                      TriggerAfterATC(bl,id);
                    }
                       //cmsheroShopify.WidgetCartUpdateMobile(); 
                       body.trigger('refresh_currency');
                      // open hidden sidebar cart
                  }
                  $('.nt_js_cart.loading, .js_addtc.loading, .js_frm_cart.loading, .js_add_group.loading, .sticky_atc_js.loading').removeClass('loading');
                  $ld.trigger( "ld_bar_end" );
                });
              }
            },
            CreatNotices : function(txt) {
               $(sp_notices).html('<p class="shopify-info sp_notice"><i class="facl facl-attention"></i>'+txt+'<i class="pegk pe-7s-close"></i></p>');
               setTimeout(function(){ $(sp_notices+' .sp_notice').addClass('show_notice'); }, 200);
            },
            HideNotices : function() {
                $(sp_notices+' .show_notice').removeClass('show_notice');
            },
            onError : function(XMLHttpRequest, textStatus) {              
              var data = eval('(' + XMLHttpRequest.responseText + ')');
              cmsheroShopify.CreatNotices(data.description);
            },
            ajaxSwatch : function(){                
                jQuery(document).on('click', '.swatch .swatch-element', function(e) {   
                  
                   var  val = $(this).data('value'),
                        val_option_index =  $(this).closest(".swatch").data("option-index"),
                        js_handle_product = $("#js-handle-product"),  
                        js_product_price = $("#js-product-price"),
                        handle_product  = js_handle_product.val(),
                        js_product_selectors = $("#js-product-selectors"),
                        js_swatch = $('.swatch'),
                        js_atc_product = $(".js_sticky_sl"),
                        sticky_atc_a = $(".sticky_atc_a"),
                        sticky_atc_price = $(".sticky_atc_price"),
                        arr_variants = new Array(),  
                       	img_variants = new Array(),  
                        option = [],
                        index = 0;
                  if($(this).closest(".wrap_swatch").find(".header-swatch span").length > 0){
                    	var vSpanLabelHeader = $(this).closest(".wrap_swatch").find(".header-swatch span");
                    	vSpanLabelHeader.text(val);
                  }
                   if(val_option_index == 0){
                       e.preventDefault();
                       js_swatch.find(':radio').removeAttr('checked');
                       js_swatch.find('.swatch-element').removeClass('checked');
                       $(this).addClass("checked").find(':radio').attr("checked", "checked");
                       option[index] = val;

                       $.getJSON('/products/'+handle_product+'.js', function(response) { 
                         
                         for (var i = 0; i < response.variants.length;i++){
                           var vVariant = response.variants[i];
                           var arr_item_options = response.variants[i].options; // List of options: 
                           var arr_item_available = response.variants[i].available;  // List of available items                         
                           //check options which contains selected option
                           if(arr_item_options.includes(val)){  
                             for (var j = 0; j < arr_item_options.length;j++){
                               if(!arr_variants.includes(arr_item_options[j])&&(arr_item_options[j] != val) && arr_item_available == true){ 
                                 arr_variants.push(arr_item_options[j]);                                
                               }
                             }
                           }
                           // check variant which contains option then get list image of this variant
                           if(vVariant.options.includes(val)){  
                             if ( vVariant.featured_image != null ){
                             	img_variants.push(vVariant.featured_image.src);    
                             }
                           }                           
                         }
                         
                         
                         js_swatch.find(".swatch-element").removeClass('active');
                         js_swatch.find(".swatch-element").removeClass('soldout').find(':radio').removeAttr('disabled','disabled').removeAttr('checked');;
                         for(var i = 0; i < arr_variants.length; i++){
                           var n_item = arr_variants[i];
                           $("[data-value='"+n_item+"']").closest(".swatch").addClass('dp-none');
                          
                           js_swatch.find("[data-value='"+n_item+"']").addClass('active');
                           index++;
                           if(index < response.variants[0].options.length){ 
                             // Tìm kiếm phần tử checked của variant và gán giá trị của variant hiện thời
                             if(jQuery("[data-option-index='"+index+"']").closest(".wrap_swatch").find('.header-swatch span').length > 0){
                               jQuery("[data-option-index='"+index+"']").closest(".wrap_swatch").find('.header-swatch span').text(n_item);
                             }
                             // Đánh dấu option checked của variant
                             jQuery("[data-option-index='"+index+"']").find("[data-value='"+n_item+"']").addClass('checked');
                             jQuery("[data-option-index='"+index+"']").find("[data-value='"+n_item+"']").find(':radio').attr('checked','checked');
                                option[index] = n_item;
                           }
                           
                           //change background image of option
                           if( $("[data-value='"+n_item+"'] [data-js-option-value] div").length > 0){
                             $("[data-value='"+n_item+"']").find("[data-js-option-value] div").attr('data-bgset',img_variants[i]);
                           	 $("[data-value='"+n_item+"']").find("[data-js-option-value] div").attr('background-image','url('+img_variants[i]+')');
                           }                           
                         }
						 
                         id_new = get_pid_variant(option); 
                         
                         js_product_selectors.val(id_new).change(); 
                         js_atc_product.val(id_new).change();                   
                         sticky_atc_a.text(js_atc_product.find("option:selected").text());
                         js_product_selectors.closest(".js_product_single").find("#js_id_product").val(id_new).change();
                         var text_option_id  = js_product_selectors.find("option[value='"+id_new+"']").text();
                         var arr = text_option_id.split(' - ');
                         var new_price = arr[arr.length-1];                     
                        
                         /* Get compare price and set price */
                         //$.getJSON('/products/'+handle_product+'.js', function(response) {                       
                           var variant_compare_price = null;
                           for (var i = 0; i < response.variants.length;i++){
                             if(response.variants[i].id == id_new){
                               variant_compare_price = response.variants[i].compare_at_price;
                               break;
                             }
                           }
                           
                           theme.ProductCurrency.setPrice(js_product_price, new_price, variant_compare_price);
                           theme.ProductCurrency.setPrice(sticky_atc_price, new_price, variant_compare_price);      
                         
                           // Cập nhật giá save
                           var vBuyTogetherButtonSale = $(".js_sale_together_value");
                           var vSalePrice = variant_compare_price - new_price;                           
                           theme.ProductCurrency.setPrice(vBuyTogetherButtonSale, vSalePrice, null);// 
                         //}); 
                         
                         
                          //$.getJSON('/products/'+handle_product+'.js', function(response) {
                            //change thumbnail image and button
                            var variant_img_id = "";
                            for (var i = 0; i < response.variants.length;i++){
                              if(response.variants[i].id == id_new){
                                if(response.variants[i].featured_image != null){
                                	variant_img_id = response.variants[i].featured_image.id;
                                }
                                if(!response.variants[i].available){
                                    $("#js-pr-available").hide();
                                    $("#js-pr-unavailable").css('display','inline-block');
                                    $("div[data-product-meta] .js_add_to_cart_button").hide();
                                    $("div[data-product-meta]  .js-compare").hide();
                                    $("div[data-product-meta]  .js-quantity").hide();
                                    $("div[data-product-meta]  .js-btn-sold-out").css('display','flex');                                   
                                    
                                }else{
                                    $("#js-pr-available").css('display','inline-block');
                                    $("#js-pr-unavailable").hide();
                                    $("div[data-product-meta]  .js_add_to_cart_button").css('display','flex');
                                    $("div[data-product-meta]  .js-compare").css('display','inherit');
                                    $("div[data-product-meta]  .js-quantity").css('display','inline-block');
                                    $("div[data-product-meta]  .js-btn-sold-out").hide();
                                }
                                break;
                              }
                            }                                       
                            if(variant_img_id !=""){    
                              interact_main_product =false;
                              $("#thumb_img_"+variant_img_id).trigger("click");  
                              if($("#quick-view-modal").length > 0){                              	
                                var img = $(".full-item.slick-active img").attr('src');                                
                                if($("#quick-view-modal .full-item.slick-active .bg_img_full").length > 0){
                                  $("#quick-view-modal .full-item.slick-active .bg_img_full").css('background-image','url('+img+')');
                                }
                              }
                              var data_image = $("#thumb_img_"+variant_img_id).attr("data-image");
                              var data_z_image = $("#thumb_img_"+variant_img_id).attr("data-z-image");
                              theme.ProductGallery.create(data_image,data_z_image);
                            }                             
                          //});         
                       })
                    }
                 }) 
                jQuery(document).on("change", ".swatch :radio", function() {
                   
                    var option = [],
                        index = 0,
                        js_product_selectors = jQuery("#js-product-selectors"),
                        js_product_price = $("#js-product-price"),
                        js_handle_product = $("#js-handle-product"),
                        js_atc_product = $(".js_sticky_sl"),
                        sticky_atc_a = $(".sticky_atc_a"),
                        sticky_atc_price = $(".sticky_atc_price"),
                        handle_product  = js_handle_product.val();
                  
                    if($(this).closest(".wrap_swatch").find(".header-swatch span").length > 0){
                      var val = $(this).val();
                      var vSpanLabelHeader = $(this).closest(".wrap_swatch").find(".header-swatch span");
                      vSpanLabelHeader.text(val);
                    }        
                    if($(this).closest(".wrap_swatch").find(".swatch-element").length > 0){                      	
                    	$(this).closest('.wrap_swatch').find(".swatch-element").removeClass('checked');                    
                    	$(this).closest('.swatch-element').addClass('checked');   
                    }
                   
                    $(".swatch-element.checked input").each(function(){
                     option[index] = $(this).attr("value");  
                     index++;
                    });     
                    
                    id_new = get_pid_variant(option);                     
                    js_product_selectors.val(id_new).change();   
                    js_atc_product.val(id_new).change();                   
                    sticky_atc_a.text(js_atc_product.find("option:selected").text());
                    js_product_selectors.closest(".js_product_single").find("#js_id_product").val(id_new).change();
                    
                   
                     var text_option_id  = js_product_selectors.find("option[value='"+id_new+"']").text();
                     var arr = text_option_id.split(' - ');
                     var new_price = arr[arr.length-1];    
                   
                     /* Get compare price and set price */
                     $.getJSON('/products/'+handle_product+'.js', function(response) {                       
                       var variant_compare_price = null;
                       for (var i = 0; i < response.variants.length;i++){
                         if(response.variants[i].id == id_new){
                           variant_compare_price = response.variants[i].compare_at_price;
                           break;
                         }
                       }                       
                       theme.ProductCurrency.setPrice(js_product_price, new_price, variant_compare_price); // Cập nhật giá tại trang chi tiết sản phẩm cho price và compare price
                       theme.ProductCurrency.setPrice(sticky_atc_price, new_price, variant_compare_price); // Cập nhật giá tại sticky bar cho price và compare price  
                       
                       // Cập nhật giá save
                       var vBuyTogetherButtonSale = $(".js_sale_together_value");
                       var vSalePrice = variant_compare_price - new_price;                       
                       theme.ProductCurrency.setPrice(vBuyTogetherButtonSale, vSalePrice, null);// 
                       
                     }); 
                     
                   
                     $.getJSON('/products/'+handle_product+'.js', function(response) {                       
                       var variant_img_id = "";
                       for (var i = 0; i < response.variants.length;i++){
                         if(response.variants[i].id == id_new){   
                           if(response.variants[i].featured_image != null){
                           		variant_img_id = response.variants[i].featured_image.id;
                           }
                           break;
                         }
                       }
                       //Change main product image and zoom image                       
                       if(variant_img_id !=""){   
                         interact_main_product =false;
                         $("#thumb_img_"+variant_img_id).trigger("click");     
                         if($("#quick-view-modal").length > 0){                              	
                           var img = $(".full-item.slick-active img").attr('src');                                
                           if($("#quick-view-modal .full-item.slick-active .bg_img_full").length > 0){
                             $("#quick-view-modal .full-item.slick-active .bg_img_full").css('background-image','url('+img+')');
                           }
                         }
                       }           
                     });         

                }); 
              // Click on thumbnail image of slick slider
              $(document).on('click','[id^="thumb_img_"]',function(){
                var vVideo = $(this).find(".js-video-area");
                var v360 = $(this).find(".js-360-area");
                var vClick = true;
                if(vVideo.length > 0){
                  	$("a[data-video-open-popup]").show();      
                  	$("a[data-360-open-popup]").hide();       
                }else{ 
                  	if(v360.length > 0){
                      	$("a[data-video-open-popup]").hide();      
                        $("a[data-360-open-popup]").show();                    
                    }else{
                        $("a[data-video-open-popup]").hide();      
                        $("a[data-360-open-popup]").hide();                      	
                    }
                }                
                
              })  
              
              // Click on video button
              $(document).on('click','.js-append-area [data-video-open-popup]',function(){
                $("div[data-slide-nav] .js-video-area [data-video-open-popup]").trigger("click");                
              })
              // Click on 360 button
              $(document).on('click','.js-append-area [data-360-open-popup]',function(){
                $("div[data-slide-nav] .js-360-area [data-360-open-popup]").trigger("click");                
              })
            },
            checkSlide: function(){
              $("div[data-slide-main]").on("mouseover",function(){
                interact_main_product = true;               
              })
              $("div[data-slide-nav]").on("mouseover",function(){
                //interact_main_product = true;
              })             
              $('div[data-slide-main]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
              });
              $('div[data-slide-main]').on('afterChange', function(event, slick, currentSlide){
                event.preventDefault();
                $(this).show();                
                if(interact_main_product==true && $(this).closest('.js_product_single').find("#js-product-selectors").length > 0){
                  var pr_id,
                      img_id,
                      js_handle_product = $("#js-handle-product"), 
                      arr_variants = new Array(),
                      js_product_selectors = $("#js-product-selectors"), 
                      js_product_price = $("#js-product-price"),
                      js_swatch = $('.swatch'),
                      js_atc_product = $(".js_sticky_sl"),
                      sticky_atc_a = $(".sticky_atc_a"),
                      sticky_atc_price = $(".sticky_atc_price"),
                      handle_product  = js_handle_product.val();

                  img_id = $(this).find('.slick-active').data("image-id");
                  var data_image = $("#thumb_img_"+img_id).attr("data-image");
                  var data_z_image = $("#thumb_img_"+img_id).attr("data-z-image");
                  theme.ProductGallery.create(data_image,data_z_image);
                  
                  $.getJSON('/products/'+handle_product+'.js', function(response) {
                    for (var i = 0; i < response.variants.length;i++){
                      if(response.variants[i].featured_image != null)
                        if(response.variants[i].featured_image.id == img_id){
                          pr_id = response.variants[i].id;
                          arr_variants =  response.variants[i].options;
                          if(!response.variants[i].available){
                            $("#js-pr-available").hide();
                            $("#js-pr-unavailable").css('display','inline-block');
                            $("div[data-product-meta] .js_add_to_cart_button").hide();
                            $("div[data-product-meta] .js-compare").hide();
                            $("div[data-product-meta] .js-quantity").hide();
                            $("div[data-product-meta] .js-btn-sold-out").css('display','flex');
                          }else{
                            $("#js-pr-available").css('display','inline-block');
                            $("#js-pr-unavailable").hide();
                            $("div[data-product-meta] .js_add_to_cart_button").css('display','flex');
                            $("div[data-product-meta] .js-compare").css('display','inline-flex');
                            $("div[data-product-meta] .js-quantity").css('display','inline-block');
                            $("div[data-product-meta] .js-btn-sold-out").hide();
                          }
                          break;
                        }
                    }                  
                    var val = arr_variants[0];
                    for (var i = 0; i < response.variants.length;i++){
                      var arr_item_options = response.variants[i].options;
                      if(arr_item_options.includes(val)){  
                        for (var j = 0; j < arr_item_options.length;j++){
                          if(!arr_variants.includes(arr_item_options[j])&&(arr_item_options[j] != val)){ 
                            arr_variants.push(arr_item_options[j]);
                          }
                        }
                      }
                    } 

                    if(arr_variants.length > 0){
                      var number_variant_style = response.variants[0].options.length;                    
                      js_swatch.find(".swatch-element").removeClass('checked');                            
                      js_swatch.find(':radio').removeAttr('checked');
                      var index = 0;
                      $("[data-option-index='"+index+"']").find(".swatch-element").addClass('active');
                      for(var i = 0; i < arr_variants.length; i++){
                        var n_item = arr_variants[i];                      
                        index++;
                        if(index < number_variant_style) $("[data-option-index='"+index+"']").find(".swatch-element").removeClass('active');
                        js_swatch.find("[data-value='"+n_item+"']").addClass('active');                      
                        $("[data-option-index='"+i+"']").find("[data-value='"+n_item+"']").addClass('checked');
                        $("[data-option-index='"+i+"']").find("[data-value='"+n_item+"']").find(':radio').attr('checked','checked'); 
                      } 
                      id_new = pr_id;
                      js_product_selectors.val(id_new).change();
                      js_atc_product.val(id_new).change();                   
                      sticky_atc_a.text(js_atc_product.find("option:selected").text());
                      js_product_selectors.closest(".js_product_single").find("#js_id_product").val(id_new).change();
                      var text_option_id  = js_product_selectors.find("option[value='"+pr_id+"']").text();
                      var arr = text_option_id.split(' - ');
                      var new_price = arr[arr.length-1];   
                      
                      /* Get compare price and set price */
                      $.getJSON('/products/'+handle_product+'.js', function(response) {                       
                        var variant_compare_price = null;
                        for (var i = 0; i < response.variants.length;i++){
                          if(response.variants[i].id == id_new){
                            variant_compare_price = response.variants[i].compare_at_price;
                            var vThumbnail_img_active = response.variants[i].featured_image.id;
                            console.log(vThumbnail_img_active);
                            interact_main_product = false;
                            $("div[data-thumb-id="+vThumbnail_img_active+"]").trigger("click");                            
                            break;
                          }
                        }
                        theme.ProductCurrency.setPrice(js_product_price, new_price, variant_compare_price);
                        theme.ProductCurrency.setPrice(sticky_atc_price, new_price, variant_compare_price);  
                        
                        // Cập nhật giá save
                       var vBuyTogetherButtonSale = $(".js_sale_together_value");
                       var vSalePrice = variant_compare_price - new_price;                       
                       theme.ProductCurrency.setPrice(vBuyTogetherButtonSale, vSalePrice, null);
                       
                      }); 
                    }

                  });
                }
              });            
            },
            quantity: function(){
              /* Xử lý sự kiện khi click vào nút thêm hoặc bớt số lượng sản phẩm */
              jQuery(document).on('click', '.js-quantity .js_minus, .js-quantity .js_plus', function (e) {
                // Get values
                var $qty = $(this).closest(".js-quantity").find('.js_qty'),
                    currentVal = parseFloat($qty.val()),
                    max = parseFloat($qty.data('max')),
                    min = parseFloat($qty.data('min')),
                    step = $qty.data('step');
                
                // Format values
                if (!currentVal || currentVal === '' || currentVal === 'NaN') currentVal = 0;
                if (max === '' || max === 'NaN') max = '';
                if (min === '' || min === 'NaN') min = 0;
                if (step === 'any' || step === '' || step === undefined || parseFloat(step) === 'NaN') step = 1;
                // Change the value
                if ($(this).is('.js_plus')) {
                  if (max && ( max == currentVal || currentVal > max )) {
                    $qty.val(max);
                  } else {
                    $qty.val(currentVal + parseFloat(step));
                  }
                } else {
                  if (min && ( min == currentVal || currentVal < min )) {
                    $qty.val(min);
                  } else if (currentVal > 0) {
                    $qty.val(currentVal - parseFloat(step));
                  }
                }
                /*Hiển thị số 0 ở trước số lượng sản phẩm nhỏ hơn 10*/
                if( $qty.val() < 10 && $qty.val() > 0){
                  $qty.val("0" + $qty.val()); 
                }
                // Trigger change event
                $qty.trigger('change');
                e.preventDefault();
                
                /* Xử lý khi click nút thêm và bớt số lượng sản phầm trong cart popup thì tự động cập nhật lại giá */
                var vParentPopup = $(this).closest("#js_cart_popup"); // Truy xuất đến đối tượng cart popup
                if(vParentPopup.length > 0){ // Nếu đang click tăng giảm số lượng trong cart popup
                  var vIdProduct = $qty.data("id"); // Lấy id của sản phẩm trong cart popup
                  var vQuantity = $qty.val(); // Lấy số lượng sản phẩm
                  var vItemProduct = $qty.closest("li[data-item-product]");
                  if (typeof vIdProduct !== 'undefined' && vIdProduct !== false) { // Kiểm tra tồn tại id của sản phẩm tại cart popup
                   	 changeItem(vIdProduct, vQuantity, vItemProduct);
                  }
                  
                }
                
              });
            },
            addItemCart : function() {              
                  jQuery(document).on('click', '.js_add_to_cart_button', function(e) {
                      e.preventDefault();     
                      // Nếu click nút add to cart tại popup wishlist full thì không đóng maginic popup
                      var vAddToCart = $(this).closest(".popup-wishlist-full");
                      if(vAddToCart.length > 0){
						
                      }else{
                      	$.magnificPopup.close();
                      }
                      var id= jQuery(this).data('pid'); 
                      if(jQuery("#Quantity").length){
                        var quantity= jQuery("#Quantity").val();
                      }else{
                        var vParent = $(this).closest(".js-quantity"); // Truy xuất đến phần tử cha chưa nút add to cart
                        var vQuantityElementRelated = vParent.find(".js_qty"); // Tìm phần tử input quantity bên cạnh nút add to cart
                        if(vQuantityElementRelated.length > 0){ // Kiểm tra nều tồn tài quantity input bên cạnh add to cart
                          	var quantity= vQuantityElementRelated.val(); // Lấy giá trị
                        }else{
                        	var quantity= 1;             
                        }
                      }
                      if ($(this).closest(".js_product_single").find("#js_id_product").length > 0){
                        id = $(this).closest(".js_product_single").find("#js_id_product").val();
                      }
                    
                      var array_items= [];                        
                      array_items.push({
                            id: id,
                            quantity: quantity
                         });      
                      addProduct(array_items,this);
                      
                  });

                  jQuery(document).on('click', '.sticky_atc_js', function(e) {                 
                    e.preventDefault();
                    var quantity = parseInt($('.js_sticky_qty').val());
                    var data_max = parseInt($(this).closest(".js_sticky_atc_wrapper").find(".js_sticky_qty").data("max"));
                    var data_min = parseInt($(this).closest(".js_sticky_atc_wrapper").find(".js_sticky_qty").data("min"));
                    
                    if(quantity > data_max){
                      $(this).closest(".js_sticky_atc_wrapper").find(".js_sticky_qty").val(data_max);
                      quantity = data_max
                    }
                    if(quantity < data_min){
                      $(this).closest(".js_sticky_atc_wrapper").find(".js_sticky_qty").val(data_min);
                      quantity = data_min
                    }
                      var _this = $(this),
                        vid = jQuery(this).data('pid'),
                        qty = quantity || 1,
                        array_items= [];                        
                       array_items.push({
                          id: vid,
                          quantity: qty
                       });       
                    try{
                       addProduct(array_items,this);
                    }catch(paramErr){                      
                      $(".sticky_atc_js").find(".txt_add").text("Sold Out");
                    }
                  });
				  
              	  jQuery(document).on('click', 'button[data-buyItNow]', function(e) {                 
                    e.preventDefault();
                     var isDisabled = $(this).prop('disabled'); 
                     
                    if(isDisabled == false){
                      var _this = $(this),
                          vid = jQuery(this).data('pid'),
                          qty = parseInt($('.js_sticky_qty').val()) || 1,
                          array_items= [];                        
                      array_items.push({
                        id: vid,
                        quantity: qty
                      });                      
					  /*console.log(array_items);*/                      
                      buyItNow(array_items,this);
                     
                    }
                      
                  });
              	  jQuery(document).on('click', '.js_add_group', function(e) {
                    e.preventDefault();
                    var _this = $(this),
                       frmId = _this.closest('div[data-js-product]').find("form[data-form-group]");  
                    
                    var array_items = [];
                    frmId.find(".js_qty").each(function(){
                        var vId = $(this).data("id");
                        var vQuantity = parseInt($(this).val()) || 0;
                        array_items.push({
                          id:vId, 
                          quantity : vQuantity
                        })
                    })                    
                    
                     addItemFrom(array_items,this);
                  });
                  jQuery(document).on('click', '.js_buy_together', function(e) {
                      e.preventDefault();
                      var _this = $(this),
                         frmId = _this.closest('div[data-js-product]').find("form[data-form-group]");  

                      var array_items = [];                      
                      frmId.find(".js_item_pr").each(function(){
                          
                          var vId = $(this).data("id");
                          var vQuantity = 1;
                          if($(this).is(':checked')){
							array_items.push({
                              id:vId, 
                              quantity : vQuantity
                            })
                          }
                          
                      })    
                      console.log(array_items.length);
                      if(array_items.length > 0){
                      	addItemFrom(array_items,this);
                      }
                    });
                 
                 jQuery(document).on('click',".js-remove-item",function(event){
                    event.preventDefault();
                    var id = $(this).data('id');
                    $.ajax({
                      url:'/cart/update.js',
                      type: 'POST', 
                      dataType: 'json',
                      data:"updates["+id+"]=0",
                      success: function(data) {
                        $(".js-cart-count").text(data.item_count);
                        //$("#item-"+id).remove();
                        var vAction = "remove";
                        ShowCart(vAction);
                        $(".js-total-price").text(convert_currency_andy(data.total_price));
                        $(".js-total-price").attr('data-total-price-cart',data.total_price);
                        updateShipping(data.total_price);
                      }
                    });     
                 });
                 jQuery(document).on('change',"[id^='updates_']",function(event){
                    event.preventDefault();
                    var id = $(this).attr('id');
                    var first_pos = id.indexOf('_')+1;
                    var last_pos  = id.length;
                    var val_id  =   id.substr(first_pos, last_pos);
                    var quanlity =  $(this).val();
					
                   $.ajax({
                      url:'/cart/update.js',
                      type: 'POST', 
                      dataType: 'json',
                      data:"updates["+val_id+"]="+quanlity+"", 
                      success: function(data) {
                        /*console.log(data);*/
                        $(".js-total-price").html(convert_currency_andy(data.total_price));
                        $(".js-total-price").attr('data-total-price-cart',data.total_price);
                        updateShipping(data.total_price);
                        $(".js-cart-count").text(data.item_count);
                        var vAction = "update";
                        ShowCart(vAction);
                      }
                    });
                  });
            },
            stAddCart : function() {
              var $trigger = $('.details-info .group-button');
              var $stickyBtn = $('.js_sticky_atc_wrapper');

              if ($stickyBtn.length <= 0 || $trigger.length <= 0 || (window_w < 768 && $stickyBtn.hasClass('mobile_false'))) return;

              var summaryOffset = $trigger.offset().top + $trigger.outerHeight(),
                  $selector = $('.js_sticky_atc_wrapper, #nt_backtop'),
                  slpr_wrap = $('div[data-popup-crossell]'),
                  _footer = $('footer'),
                  off_footer = 0,
                  ck_footer = _footer.length > 0;
			  
              var stickyAddToCartToggle = function () {
                var windowScroll = $(window).scrollTop(),
                    windowHeight = $(window).height(),
                    documentHeight = $(document).height(),
                    stickyHeight = _footer.height();
                if (ck_footer) {
                  off_footer = _footer.offset().top - _footer.height();
                } else {
                  off_footer = windowScroll;
                }
               
               if (windowScroll + windowHeight == documentHeight || summaryOffset > windowScroll || windowScroll + stickyHeight > off_footer ) {
                  $selector.removeClass('sticky_atc_shown');
                  slpr_wrap.removeClass('sticky_atc_shown');
                } else if (summaryOffset < windowScroll && windowScroll + windowHeight != documentHeight) {
                  $selector.addClass('sticky_atc_shown');
                  slpr_wrap.addClass('sticky_atc_shown');
                }
              };

              stickyAddToCartToggle();

              $(window).scroll(stickyAddToCartToggle);

             
              // Quantity.
              $('.js_sticky_atc_wrapper .js_sticky_qty').on('change', function(){
                $('#Quantity .js_qty').val($(this).val())
                //.trigger('change');
              });

              $('#Quantity .js_sticky_qty').on('change', function(){
                $('.js_sticky_atc_wrapper .js_qty').val($(this).val());
              });
            },
          recently_viewed : function (sl) {
            var el = sl || $('#js_recently_wrapper');
            if (el.length == 0 ) return;

            var ls = localStorage.getItem('product_recent'),
                id = (type_name == "product") ? el.data('id') : '19041994',
                
                get = el.data('get'),
                unpr = el.data('unpr'), 
                limit = el.data('limit');

            if (ls != null) { 
               var arrls = ls.split(','),
               
               index = arrls.indexOf(id);

               
               if (index > -1) { 
                  arrls = arrls.splice(0,limit+1); 
                  arrls.splice(index, 1); 
               } else {
                  arrls = arrls.splice(0,limit);
               }              

               if(arrls.length == 0) {
                el.slideUp();
                return false;
               }

               var arr_list = arrls.toString(),
                  uri = arr_list.replace(/,/g, ' OR '),
                  res = encodeURI(uri);
                
                  $.ajax({
                    url: get+'?view=recently_viewed&type=product&options[unavailable_products]='+unpr+'&q='+res,
                    dataType: 'html',
                    type: 'GET',
                    success: function(section) {                 
                     var recentlyMarkup = $(section).html();
                     if (recentlyMarkup.trim() !== '') {
                       el.html(recentlyMarkup);
                       $('.gg-recent-container').addClass($('#data-recently').attr('data-layout'));                       
                       var data_recently = $('#data-recently');
                       var ttl = data_recently.attr("data-title")
                       $('.col-recent-products .title').text(ttl);
                       $('.col-recent-products').addClass(data_recently.attr("data-position"))
                       $('.js-recently-viewed-slider').attr('data-number', data_recently.attr('data-forcol'));                       
                       var sl_col = data_recently.attr('data-forcol'), 
                           sl_scroll =	data_recently.attr('data-scroll'),
                           sl_infi = data_recently.attr('data-infinite'),
                           sl_auto =  data_recently.attr('data-autoplay'),
                           sl_speed =  data_recently.attr('data-speed'),
                           sl_arrow =  data_recently.attr('data-arrow'),
                       	   sl_dots = data_recently.attr('data-dots');
                       sl_infi = (data_recently.attr('data-infinite') == 'true') ? true : false;
                       sl_auto = (data_recently.attr('data-autoplay') == 'true') ? true : false;
                       sl_arrow = (data_recently.attr('data-arrow') == 'true') ? true : false;
                       sl_dots = (data_recently.attr('data-dots') == 'true') ? true : false;
                       $(".js-recently-viewed-slider").slick({
                         slidesToShow: parseInt(sl_col), 
                         slidesToScroll: parseInt(sl_scroll),
                         infinite: sl_infi,
                         lazyLoad: "ondemand",
                         autoplay: sl_auto,
                         autoplaySpeed: parseInt(sl_speed),
                         arrows: true,
                         dots:  sl_dots,
                         responsive: [
                           {
                             breakpoint: 1200,
                             settings: {
                               slidesToShow: 3,
                               slidesToScroll: 2                       
                             }
                           },
                           {
                             breakpoint: 992,
                             settings: {
                               slidesToShow: 3,
                               slidesToScroll: 1
                             }
                           },
                           {
                             breakpoint: 767,
                             settings: {
                               slidesToShow: 3,
                               slidesToScroll: 1
                             }
                           },
                           {
                             breakpoint: 650,
                             settings: {
                               slidesToShow: 2,
                               slidesToScroll: 1
                             }
                           },
                           {
                             breakpoint: 480,
                             settings: {
                               slidesToShow: 1,
                               slidesToScroll: 1
                             }
                           }
                         ]
                       })
                     }
                    },
                    error: function() {},
                    complete: function() {
                      if($('.spr-badge-starrating').length > 0){
                        SPR.registerCallbacks();
                        SPR.initRatingHandler();
                        SPR.initDomEls();
                        SPR.loadProducts();
                        SPR.loadBadges();
                      }
                      
                     
                        setTimeout(function(){ 
                          tippy('.js-recently-viewed-slider .small .js_add_to_cart_button, .js-recently-viewed-slider .js-compare, .js-recently-viewed-slider .js-wishlist, .js-recently-viewed-slider .js_quick_view:not(.no-icon)', {
                            placement: 'top',
                            animation: 'scale',
                            arrow: true
                          })
                        }, 500)
                      
                    }
                  }); 

            } else {
              el.html('');
              var arrls = new Array();
            }

            if ( arrls.indexOf(id) < 0 && id != '19041994' ) {         
               if ( arrls.length > limit){ arrls = arrls.splice(0,limit) }        
               arrls.unshift(id);
               localStorage.setItem('product_recent', arrls.toString());
               //console.log("Product was added to localStorage!.")
            }else{
            	//console.log("Couldn't add product to localStorage!.")
            }
            
            
          },
           /*
          recently_viewed1 : function (sl) {
            var el = sl || $('#js_recently_wrapper1');
            if (el.length == 0 ) return;

            var ls = localStorage.getItem('product_recent'),
                id = (type_name == "product") ? el.data('id') : '19041994',
                get = el.data('get'),
                unpr = el.data('unpr'), 
                limit = el.data('limit');

            if (ls != null) { 
               var arrls = ls.split(','),
               index = arrls.indexOf(id);
               
               if (index > -1) { 
                  arrls = arrls.splice(0,limit+1); 
                  arrls.splice(index, 1); 
               } else {
                  arrls = arrls.splice(0,limit);
               }              

               if(arrls.length == 0) {
                el.slideUp();
                return false;
               }

               var arr_list = arrls.toString(),
                  uri = arr_list.replace(/,/g, ' OR '),
                  res = encodeURI(uri);
                
                  $.ajax({
                    url: get+'?view=recently_viewed1&type=product&options[unavailable_products]='+unpr+'&q='+res,
                    dataType: 'html',
                    type: 'GET',
                    success: function(section) {
                     var recentlyMarkup = $(section).html();
                     if (recentlyMarkup.trim() !== '') {
                       el.html(recentlyMarkup); 
                       var data_recently = $('#data-recently');
                       var ttl = data_recently.attr("data-title")
                       $('.product_recently_viewed1 .section-title').text(ttl);
                       $('.js-recently-viewed-slider').attr('data-number', data_recently.attr('data-forcol')); 
                       $(".js-recently-viewed-slider").slick({
                         slidesToShow: data_recently.attr('data-forcol'), 
                         slidesToScroll: data_recently.attr('data-scroll'),
                         infinite: data_recently.attr('data-infinite'),
                         lazyLoad: "ondemand",
                         autoplay: data_recently.attr('data-autoplay'),
                         autoplaySpeed: data_recently.attr('data-speed'),
                         arrows: data_recently.attr(' data-arrow'),
                         dots:  data_recently.attr('data-dots'),
                         responsive: [
                           {
                             breakpoint: 1200,
                             settings: {
                               slidesToShow: 3,
                               slidesToScroll: data_recently.attr('data-scroll'),
                               dots: false,
                               arrows: true,
                               infinite: true                          
                             }
                           },
                           {
                             breakpoint: 992,
                             settings: {
                               dots: false,
                               arrows: true,  
                               infinite: true,
                               slidesToShow: 3,
                               slidesToScroll: 3
                             }
                           },
                           {
                             breakpoint: 767,
                             settings: {
                               arrows: true,  
                               infinite: true,
                               slidesToShow: 2,
                               slidesToScroll: 2
                             }
                           },
                           {
                             breakpoint: 650,
                             settings: {
                               arrows: true,  
                               infinite: true,
                               slidesToShow: 2,
                               slidesToScroll: 2
                             }
                           },
                           {
                             breakpoint: 480,
                             settings: {
                               arrows: true,  
                               infinite: true,
                               slidesToShow: 1,
                               slidesToScroll: 1
                             }
                           }
                         ]
                       })
                     }
                    },
                    error: function() {},
                    complete: function() {
                      if($('.spr-badge-starrating').length > 0){
                        SPR.registerCallbacks();
                        SPR.initRatingHandler();
                        SPR.initDomEls();
                        SPR.loadProducts();
                        SPR.loadBadges();
                      }
                      
                     
                        setTimeout(function(){ 
                          tippy('.js-recently-viewed-slider .small .js_add_to_cart_button, .js-recently-viewed-slider .js-compare, .js-recently-viewed-slider .js-wishlist, .js-recently-viewed-slider .js_quick_view', {
                            placement: 'top',
                            animation: 'scale',
                            arrow: true
                          })
                        }, 500)
                      
                    }
                  }); 

            } else {
              el.html('');
              var arrls = new Array();
            }

            if ( arrls.indexOf(id) < 0 && id != '19041994' ) {         
               if ( arrls.length > limit){ arrls = arrls.splice(0,limit) }        
               arrls.unshift(id);
               localStorage.setItem('product_recent', arrls.toString());
            }
            
            
          },*/
          initSlick: function(){  
            
            /* General slider */
              if($("div[data-js-all]").length > 0){
                $("div[data-js-all]").each(function(){
                  var vParent = $(this).parent();
                  var vIdParent = vParent.attr("id");

                  var number_desktop = $("#" + vIdParent + " div[data-js-all]").data("numberdesktop");
                  var number_tablet = $("#" + vIdParent + " div[data-js-all]").data("numbertablet");
                  var number_mobile = $("#" + vIdParent + " div[data-js-all]").data("numbermobile");
                  var slidesToScroll = $("#" + vIdParent + " div[data-js-all]").data("slidestoscroll");                  
                  if (slidesToScroll == null){
                      slidesToScroll = 1;
                  }
                 
                  $("#" + vIdParent + " div[data-js-all]").not('.slick-initialized').slick({
                    slidesToShow: number_desktop,
                    slidesToScroll: slidesToScroll,
                    responsive: [
                      {
                        breakpoint: 1200,
                        settings: {
                          slidesToShow: number_desktop,
                          slidesToScroll: slidesToScroll                        
                        }
                      },
                      {
                        breakpoint: 992,
                        settings: {                        
                          slidesToShow: number_tablet,
                          slidesToScroll: number_tablet
                        }
                      },
                      {
                        breakpoint: 768,
                        settings: {                       
                          slidesToShow: number_tablet,
                          slidesToScroll: number_tablet
                        }
                      },
                      {
                        breakpoint: 557,
                        settings: {                        
                          slidesToShow: number_mobile,
                          slidesToScroll: number_mobile
                        }
                      },
                      {
                        breakpoint: 481,
                        settings: {                        
                          slidesToShow: number_mobile,
                          slidesToScroll: number_mobile
                        }
                      }
                    ]       
                  })  
                })
              }         
            
            if($("div[data-js-all1]").length > 0){    
                var number_desktop = $("div[data-js-all1]").data("numberdesktop");
                var number_tablet = $("div[data-js-all1]").data("numbertablet");
                var number_mobile = $("div[data-js-all1]").data("numbermobile");
                $("div[data-js-all1]").not('.slick-initialized').slick({
                  responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: number_desktop,
                        slidesToScroll: number_desktop                        
                      }
                    },
                    {
                      breakpoint: 992,
                      settings: {                        
                        slidesToShow: number_tablet,
                        slidesToScroll: number_tablet
                      }
                    },
                    {
                      breakpoint: 768,
                      settings: {                       
                        slidesToShow: number_tablet,
                        slidesToScroll: number_tablet
                      }
                    },
                    {
                      breakpoint: 557,
                      settings: {                        
                        slidesToShow: number_mobile,
                        slidesToScroll: number_mobile
                      }
                    },
                    {
                      breakpoint: 481,
                      settings: {                        
                        slidesToShow: number_mobile,
                        slidesToScroll: number_mobile
                      }
                    }
                  ]       
                })  

              }      
            /* End general*/
            
            //Init slick for suggest product section
            if($(".js_suggest_product").length > 0){
              if($(window).width() > 480){
                var count = $(".js_suggest_product").data("slidetoshow");
              }else{
                var count = 1;
              }

              $(".js_suggest_product").not('.slick-initialized').slick({   
                slidesToShow: count,
                slidesToScroll: count,
                dots: false,
                arrows: true,
                infinite: false,       
                responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: count,
                      slidesToScroll: count,
                      dots: false,
                      arrows: true,
                      infinite: false                      
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: false,
                      slidesToShow: count,
                      slidesToScroll: count
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 575,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]

              }) 
            }
            //Init slick for carousel product section
            if($(".js_carousel_product").length > 0){
              if($(window).width() > 480){
              	var count = $(".js_carousel_product").data("slidetoshow");
              }else{
                var count = 1;
              }
              $(".js_carousel_product").not('.slick-initialized').slick({   
                slidesToShow: count,
                slidesToScroll: count,
                dots: false,
                arrows: true,
                infinite: false,       
                responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: count,
                      slidesToScroll: count,
                      dots: false,
                      arrows: true,
                      infinite: false                      
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: false,
                      slidesToShow: count,
                      slidesToScroll: count
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 575,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]

              }) 
            }
            $( window ).resize(function() {
              if($(".js_carousel_product").length > 0){
                if($(window).width() > 480){
                  var count = $(".js_carousel_product").data("slidetoshow");
                }else{
                  var count = 1;
                }
                $(".js_carousel_product").not('.slick-initialized').slick({   
                  slidesToShow: count,
                  slidesToScroll: count,
                  dots: false,
                  arrows: true,
                  infinite: false,       
                  responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: count,
                        slidesToScroll: count,
                        dots: false,
                        arrows: true,
                        infinite: false                      
                      }
                    },
                    {
                      breakpoint: 992,
                      settings: {
                        dots: false,
                        arrows: true,  
                        infinite: false,
                        slidesToShow: count,
                        slidesToScroll: count
                      }
                    },
                    {
                      breakpoint: 767,
                      settings: {
                        arrows: true,  
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        arrows: true,  
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                  ]

                }) 
              }
              
            })
            
            //Init slider on product detail
            if(type_name == "product"){ 
              if($("div[data-slide-main]").length > 0){
                $("div[data-slide-main]:not(.large-gallery-slider):not(.slider)").not('.slick-initialized').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    fade: true,
                    lazyLoad: 'ondemand'
                })       
                  
                $(" div[data-slide-main].large-gallery-slider").not('.slick-initialized').slick({     

                }) 
                $(" div[data-slide-main].slider").not('.slick-initialized').slick({    
					centerPadding: '20%',  
                  	responsive: [
                      {
                        breakpoint: 1200,
                        settings: {
                          centerPadding: '20%'
                        }
                      },
                      {
                        breakpoint: 992,
                        settings: {
                          centerPadding: '20%',
                        }
                      },
                      {
                        breakpoint: 767,
                        settings: {
                         centerPadding: '15%',
                        }
                      },
                      {
                        breakpoint: 480,
                        settings: {
                          centerPadding: '15%',
                        }
                      }
                   ]
                })
              }  
               if($("div[data-slide-nav]").length > 0){
                 var number_desktop = 6;
                 if($("div[data-slide-nav]").length > 0){
					number_desktop = $("div[data-slide-nav]").data("numberdesktop");
                 }
                 var number_tablet = 5;                     
                 if($("div[data-slide-nav]").length > 0){
                   number_tablet = $("div[data-slide-nav]").data("numbertablet");
                 }
                 var number_mobile = 4;                    
                 if($("div[data-slide-nav]").length > 0){
                   number_mobile =  $("div[data-slide-nav]").data("numbermobile");
                 }
                 
                  $("div[data-slide-nav]").not('.slick-initialized').slick({    
                    asNavFor: 'div[data-slide-main]',
                    slidesToShow: number_desktop,
                    slidesToScroll: 1,
                    dots: false,
                    arrows: true,
                    loop: false,
                    autoplay: false,
                    responsive: [
                      {
                        breakpoint: 1800,
                        settings: {
                          slidesToShow: number_desktop,
                          slidesToScroll: 1,
                          dots: false,
                          arrows: true,
                          centerMode: true,
                          focusOnSelect: true                      
                        }
                      },
                      {
                        breakpoint: 1400,
                        settings: {
                          slidesToShow: number_desktop,
                          slidesToScroll: 1,
                          dots: false,
                          arrows: true,
                          centerMode: true,
                          focusOnSelect: true                   
                        }
                      },
                      {
                        breakpoint: 1200,
                        settings: {
                          slidesToShow: number_tablet,
                          slidesToScroll: 1,
                          dots: false,
                          arrows: true,
                          centerMode: true,
                          focusOnSelect: true                      
                        }
                      },
                      {
                        breakpoint: 1025,
                        settings: {
                          slidesToShow: number_tablet,
                          dots: false,
                          arrows: true,  
                          infinite: true,
                          vertical:false,
                          verticalswiping:false
                        }
                      },
                      {
                        breakpoint: 767,
                        settings: {
                          slidesToShow: number_mobile,
                          arrows: true,  
                          infinite: false,
                          vertical:false,
                          verticalswiping:false
                        }
                      },
                      {
                        breakpoint: 480,
                        settings: {
                          slidesToShow: number_mobile,
                          arrows: true,  
                          infinite: false,
                          vertical:false,
                          verticalswiping:false
                        }
                      }
                   ]
                  }); 
               }
              
            
            }
            
            
            $(document).ready(function(){
              if($("div[slick-collections]").length > 0){  
                var number = $("div[slick-collections]").attr("data-col");
                $("div[slick-collections]").not('.slick-initialized').slick({
                  slidesToShow: number,
                  slidesToScroll: 1,
                  responsive: [
                  {
                    breakpoint: 1400,
                    settings: {
                      slidesToShow: number,
                      slidesToScroll: 1,
                      dots: false,
                      arrows: true,
                      infinite: true                          
                    }
                  },
                  {
                    breakpoint: 1200,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: true,
                      slidesToShow: 4,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      arrows: false,  
                      infinite: false,
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: false,  
                      infinite: true,
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,  
                      infinite: true,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]      
                })  

              }
            })
            
             if($(".js-carousel-products").length > 0){                
                $(".js-carousel-products").each(function(){
                  var vParent = $(this).closest("section");
                  var vIdParent = vParent.attr("id");

                  var number =  $("#" + vIdParent + " .js-carousel-products").data("number");
                 
                  $("#" + vIdParent + " .js-carousel-products").not('.slick-initialized').slick({
                  slidesToShow: number,
                  slidesToScroll: number,
                  responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: number - 1,
                      slidesToScroll: number - 1,
                      dots: false,
                      arrows: true,
                      infinite: false                          
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 650,
                    settings: {
                      arrows: true, 
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]});
              });
            }
              if($(".js-carousel-products-home13").length > 0){                
                var number = $(".js-carousel-products-home13").data("number");
                $(".js-carousel-products-home13").not('.slick-initialized').slick({
                  slidesToShow: number,
                  slidesToScroll: number,
                  responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: number - 1,
                      slidesToScroll: number - 1,
                      dots: false,
                      arrows: true,
                      infinite: false                          
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 650,
                    settings: {
                      arrows: true, 
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll:1
                    }
                  }
                ]});
              }
            //Init slider for related product
              if($(".js-related-product").length > 0){                
                var number = $(".js-related-product").data("number");
                $(".js-related-product").not('.slick-initialized').slick({
                  slidesToShow: number,
                  slidesToScroll: number,
                  responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: number - 1,
                      slidesToScroll: number - 1,
                      dots: false,
                      arrows: true,
                      infinite: false                          
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 650,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]});
              }
            /* Init slider for tab collection */
            if($("div[data-js-collection-tab] .js-sorting-collection-tab").length > 0){
              $("div[data-js-collection-tab] .js-sorting-collection-tab").each(function(){
                var _this = $(this);
                var id = _this.closest("div[data-js-collection-tab]").attr("id");
                var count = _this.closest("div[data-sorting-collections-items]").data("number");

                $("#"+id+" .js-sorting-collection-tab").not('.slick-initialized').slick({                
                  responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: count,
                        slidesToScroll: count,
                        dots: false,
                        arrows: true,
                        infinite: false                          
                      }
                    },
                    {
                      breakpoint: 992,
                      settings: {
                        dots: false,
                        arrows: true,  
                        infinite: false,
                        slidesToShow: count-1,
                        slidesToScroll: count-1
                      }
                    },
                    {
                      breakpoint: 767,
                      settings: {
                        arrows: true,  
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    },
                    {
                      breakpoint: 650,
                      settings: {
                        arrows: true,  
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        arrows: true,  
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                  ]});
              })
              
            }
            if($("div[data-js-team]").length > 0){
              $("div[data-js-team]").not('.slick-initialized').slick(
                {responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 4,
                      dots: false,
                      arrows: true,
                      infinite: false                          
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 3,
                      slidesToScroll: 3
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,  
                      infinite: true,
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },              
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]});   
            }
            /*$("div[data-js-team]").slick('slickGoTo', 1, true);*/
            /*short-code slider*/
            if($(".blog-post-slider").length > 0){
             $(".blog-post-slider").not('.slick-initialized').slick({
               lazyLoad: 'ondemand',
               slidesToShow: 2,
               slidesToScroll: 1,
               infinite: true,              
               responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      dots: false,
                      arrows: true,
                      infinite: false
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
               ]

             }) 
            }
            // Blog section slider
            if($(".blog-slider").length > 0){
              var number = $(".blog-slider").data("number");
              $(".blog-slider").not('.slick-initialized').slick({                           
               responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: number-1,
                      slidesToScroll: number-1,
                      dots: false,
                      arrows: false,
                      infinite: false
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: false,  
                      infinite: false,
                      slidesToShow: number - 1,
                      slidesToScroll: number -1
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: false,  
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: false,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
               ]
             }) 
            }
            if($(".js_instagram_lookbook").length > 0){
              
              var number = $(".js_instagram_lookbook").data('slide-to-show');              
              $(".js_instagram_lookbook").not('.slick-initialized').slick({
               lazyLoad: 'ondemand',
               slidesToShow: number,
               slidesToScroll: number,
               infinite: false,               
               responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: number,
                      slidesToScroll: number,
                      dots: false,
                      arrows: true,
                      infinite: false
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: false,
                      slidesToShow: number,
                      slidesToScroll: number
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
               ]
             }) 
            }
            /* Init section daily slick */
            if($("div[data-js-slick-daily]").length > 0){     
              $("div[data-js-slick-daily]").not('.slick-initialized').slick({
                lazyLoad: 'ondemand',
                slidesToShow: 4,
                slidesToScroll: 4,
                infinite: true,     
                responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 4,
                      dots: false,
                      arrows: true,
                      infinite: false
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 4,
                      slidesToScroll: 4
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 3,
                      slidesToScroll: 3
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
              })      
            }
            if($("div[data-js-slick-slider-article]").length > 0){     
              $("div[data-js-slick-slider-article]").not('.slick-initialized').slick({
                lazyLoad: 'ondemand',
                infinite: true,     
                slidesToShow: 1,
                slidesToScroll: 1,
                dots: true,
                arrows: false
              } )
            }
            /* Init section lookbook slider slick */
            if($("[data-js-slider-lookbook]").length > 0){   
              $("[data-js-slider-lookbook]").not('.slick-initialized').slick({
                lazyLoad: 'ondemand',
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,       
                responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      dots: false,
                      arrows: true,
                      infinite: true
                    }
                  },
                  
                  {
                    breakpoint: 1025,
                    settings: "unslick"
                  }
                ]
              })     
            }
             /* Init section brand slider slick */
            if($("div[data-js-slick-brand]").length > 0){    
              var number = $("div[data-js-slick-brand]").data("number");
              $("[data-js-slick-brand]").not('.slick-initialized').slick({              
                responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: number,
                      slidesToScroll: number,
                      dots: false,
                      autoplay: true,
                      arrows: true,
                      infinite: true
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: true,
                      autoplay: true,
                      slidesToShow: number,
                      slidesToScroll: number
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: true,
                      autoplay: true,
                      slidesToShow: 2,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: true,
                      autoplay: true,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]

              })  
              
              
                var vMaxHeight = 0 ;
                $("div[data-js-slick-brand] .brand_list").each(function(){
                    var bHeight = $(this).find("img").height();
                    if(bHeight > vMaxHeight){
                      vMaxHeight = bHeight;
                    }                  
                })   
                if(vMaxHeight > 1){
                	$("div[data-js-slick-brand] .brand_list").css('height',vMaxHeight + "px");
                }
              
              
            }
            
            if($("div[data-js-brand-style2]").length > 0){     
              $("div[data-js-brand-style2").not('.slick-initialized').slick({
              	responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 4,
                      slidesToScroll: 4,
                      dots: false,
                      arrows: true,
                      infinite: false
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 4,
                      slidesToScroll: 4
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 3,
                      slidesToScroll: 3
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,  
                      infinite: false,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]
              })  
            }
            
           if($(".js-carousel-product-banner").length > 0){  
             var vAutoPlay = $(".js-carousel-product-banner").data("autoplay");
             var vDots = $(".js-carousel-product-banner").data("dots");
              $(".js-carousel-product-banner").not('.slick-initialized').slick({
                 slidesToShow: 1,
                 slidesToScroll: 1,                 
                 arrows:false,
                 autoplay: vAutoPlay,
                 dots: vDots,
                 appendDots: ".appendDotsBanner"
              });
           }

           if($(".js-list-category").length > 0){  
              $(".js-list-category").not('.slick-initialized').slick({
                 slidesToShow: 4,
                 slidesToScroll: 4,                 
                 arrows:true,
                 variableWidth: true,
                 appendArrows: ".appendArrorsList",
                  responsive: [
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 4,
                        dots: false,
                        arrows: true,
                        infinite: false
                      }
                    },
                    {
                      breakpoint: 992,
                      settings: {
                        dots: false,
                        arrows: true,  
                        infinite: false,
                        slidesToShow: 3,
                        slidesToScroll: 3
                      }
                    },
                    {
                      breakpoint: 767,
                      settings: {
                        arrows: true,  
                        infinite: false,
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    },
                    {
                      breakpoint: 480,
                      settings: {
                        arrows: true,  
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                    ]
              });
           }
            
            $("[data-lazy-product-load]").on('DOMNodeInserted', function(e) {
              if ( $(e.target).hasClass('product-item') || $(e.target).hasClass('product-item-style2') || $(e.target).hasClass('product-item-style3') ) {
                if($('.shopify-product-reviews-badge').length > 0){
                  SPR.registerCallbacks();
                  SPR.initRatingHandler();
                  SPR.initDomEls();
                  SPR.loadProducts();
                  SPR.loadBadges();
                }
				
                setTimeout(function(){ 
                  tippy('.product-item .js-compare, .product-item .js-wishlist, .product-item .js_quick_view:not(.no-icon),.product-item.small .js_add_to_cart_button, .product-item-style2 .js-compare, .product-item-style2 .js-wishlist, .product-item-style2 .js_quick_view', {
                    placement: 'top',
                    animation: 'scale',
                    arrow: true
                  })
                },500)  
                
                var pctl = new ProductTextCountdown();
              }

            });
            
            /* Testimonial slider */
            if($("div[data-js-testimonial-thumbnail]").length > 0){   
              $("div[data-js-testimonial-thumbnail]").each(function(){
				var _this = $(this);                
                var vSid = _this.data("sid");
                $("#cms_testimonial_thumb_" + vSid + " .thumbs").not('.slick-initialized').slick({
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  arrows: false,     
                  lazyLoad: 'ondemand',
                  centerMode: true,
                  asNavFor: '#cms_testimonial_'+vSid
                })     

                if($('#cms_testimonial_'+vSid).length > 0){     
                  $('#cms_testimonial_'+vSid).not('.slick-initialized').slick({
                    asNavFor: '#cms_testimonial_thumb_' + vSid + ' .thumbs',
                    focusOnSelect: true
                  })                
                }
              })             
            }
            /* End testimonial slider */
            
            /* Benefit footer slider */
            if($("div[data-js-benefit-footer]").length > 0){    
              	var count = $("div[data-js-benefit-footer]").data("toshow");
                $("div[data-js-benefit-footer]").not('.slick-initialized').slick({
                  responsive: [
                    {
                      breakpoint: 1400,
                      settings: {
                        slidesToShow: count,
                        slidesToScroll: count,
                        dots: false,
                        arrows: false,
                        infinite: false
                      }
                    },
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        dots: false,
                        arrows: false,
                        infinite: false
                      }
                    },
                    {
                      breakpoint: 992,
                      settings: {
                        dots: false,
                        arrows: true,  
                        infinite: true,
                        autoplay:true,
                        slidesToShow: 2,
                        slidesToScroll: 2
                      }
                    },
                    {
                      breakpoint: 767,
                      settings: {
                        arrows: true,  
                        infinite: true,
                        autoplay:true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    },
                    {
                      breakpoint: 481,
                      settings: {
                        arrows: true,  
                        infinite: true,
                        autoplay:true,
                        slidesToShow: 1,
                        slidesToScroll: 1
                      }
                    }
                  ]       
                })  
              
            }         
            /* End benefit footer slider */
            
             /* Testimonial list slider */
            if($("div[data-js-testimonial-list]").length > 0){    
              	var count = $("div[data-js-testimonial-list]").data("toshow");
                var ar = $("div[data-js-testimonial-list]").data("arrows");
              	var dot = $("div[data-js-testimonial-list]").data("dots");
                $("div[data-js-testimonial-list]").not('.slick-initialized').slick({
                  responsive: [
                    {
                      breakpoint: 1400,
                      settings: {
                        slidesToShow: count,
                        slidesToScroll: 1,
                        dots: dot,
                        arrows: ar,
                        infinite: true
                      }
                    },
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false,
                        infinite: true
                      }
                    },     
                    {
                      breakpoint: 992,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false,
                        infinite: true
                      }
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        autoplay:true,
                        dots: false,
                        arrows: false,
                        infinite: true
                      }
                    },
                    {
                      breakpoint: 481,
                      settings: {
                       slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay:true,
                        dots: false,
                        arrows: true,
                        infinite: true
                      }
                    }
                  ]       
                })  
              
            }         
            
            
            /* Collection list slider */
            if($("div[data-js-collection-list]").length > 0){    
              	var count = $("div[data-js-collection-list]").data("toshow");
                $("div[data-js-collection-list]").not('.slick-initialized').slick({
                  responsive: [
                    {
                      breakpoint: 1400,
                      settings: {
                        slidesToShow: count-1,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false,
                        infinite: false
                      }
                    },
                    {
                      breakpoint: 1200,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false,
                        infinite: false
                      }
                    },     
                    {
                      breakpoint: 992,
                      settings: {
                        slidesToShow: 3,
                        slidesToScroll: 1,
                        dots: false,
                        arrows: false,
                        infinite: false
                      }
                    },
                    {
                      breakpoint: 768,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                        autoplay:true,
                        dots: false,
                        arrows: false,
                        infinite: false
                      }
                    },
                    {
                      breakpoint: 481,
                      settings: {
                       slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay:true,
                        dots: false,
                        arrows: true,
                        infinite: false
                      }
                    }
                  ]       
                })  
              
            }         
            /* End collection slider */
            
            /* Banner section slider */
            if($(".js-banner-slider").length > 0){  
              var count = $(".js-banner-slider").data("toshow");
              $(".js-banner-slider").not('.slick-initialized').slick({
                responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: count-1,
                      slidesToScroll: count-1,
                      dots: false,
                      arrows: false,
                      infinite: false
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {
                      dots: false,
                      arrows: true,  
                      infinite: true,
                      autoplay:true,
                      slidesToShow: count-1,
                      slidesToScroll: count-1
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {
                      arrows: true,  
                      infinite: true,
                      autoplay:true,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {
                      arrows: true,  
                      infinite: true,
                      autoplay:true,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                ]       
                
              })
              
            }
            /* End Banner section slider */
            
            /* Recent post slider */
            if($("ul[data-js-recent-post]").length > 0){  
              $("ul[data-js-recent-post]").not('.slick-initialized').slick({

              })
            }
            /* Related article slider */
            if($("div[data-js-related-article]").length > 0){  
              $("div[data-js-related-article]").not('.slick-initialized').slick({
				 responsive: [
                  {
                    breakpoint: 1200,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 2,
                      dots: false,
                      arrows: true,
                      infinite: false
                    }
                  },
                  {
                    breakpoint: 992,
                    settings: {                     
                      autoplay:true,
                      slidesToShow: 2,
                      arrows: true,
                      slidesToScroll: 2
                    }
                  },
                  {
                    breakpoint: 767,
                    settings: {                    
                      autoplay:true,
                      slidesToShow: 1,
                      arrows: true,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 480,
                    settings: {                                      
                      autoplay:true,
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
                 ]
              })
            }
            /* End recent post slider */
          },
          back_to_top: function(){
            $(window).scroll(function(){
                if ($(this).scrollTop() > 300) {
                    $('.back-to-top').fadeIn();
                    $('.back-to-top').addClass('show');
                } else {
                    $('.back-to-top').fadeOut();
                    $('.back-to-top').removeClass('show');
                }
            });
            $(document).on('click','.back-to-top',function(){
                $('html, body').animate({scrollTop : 0},800);
                return false;
            });
          },          
          filtersAJX : function () {                        
            if ( $('.js_container_cat').length == 0 || typeof ($.fn.pjax) == 'undefined' ) return;
            
            var area_filter_size = '.widget_filter_size',
                area_filter_color = '.widget_filter_color', 
                area_filter_brand = '.widget-brand', 
                area_filter_sortby = '.js_cat_sortby', 
                area_filter = '.js_filter', 
                area_filter_container = '.js_container_cat ';
	
            
            jQuery(document).pjax(ajaxSelector, '.js_container_cat', {
              fragment: '.js_container_cat',
              timeout: 650,
              scrollTo: false
            });
            
            jQuery(document).on('pjax:clicked', function(options) {    
              if ( $(area_filter_container).length != 0 ) {
                $.pjax.reload(area_filter_container, {               
                   fragment: area_filter_container,
                   timeout: 100                  
                })
              }             
            });
            
            jQuery(document).on('pjax:beforeSend', function(xhr,options) { });
            jQuery(document).on('pjax:timeout', function(e) {
              // Prevent default timeout redirection behavior
              e.preventDefault()
            });

            jQuery(document).on('pjax:error', function (xhr, textStatus, error, options) {           
               //console.log('pjax error ' + error);               
            });

            jQuery(document).on('pjax:start', function (xhr, textStatus, options) {           
              jQuery("body").addClass('ajax_loading');              
              jQuery.magnificPopup.close();                         
            });

            jQuery(document).on('pjax:beforeReplace', function (contents, options) { });

            jQuery(document).on('pjax:complete', function (xhr, textStatus, options) { });

            jQuery(document).on('pjax:end', function (xhr, textStatus, options) {           
              var holder = jQuery('.js_container_cat .js_products_holder'),
                  fragment = options.fragment;              
              if ( holder.hasClass('nt_packery') ) {
                //cmsheroShopify.refresh_packery(holder);
              } else if ( holder.hasClass('js_isotope') ) {
                cmsheroShopify.refresh_masonry(holder);               
              } 
              if (typeof theme.ProductCurrency != "undefined") {
                theme.ProductCurrency.update(); 
              }
              var handle_current_collection =  $("ul[data-list-categories]").find("[data-current] [data-handle-collection]").attr("data-handle-collection");
              
              $("div[data-filter-sorting]").attr("data-include","/collections/"+handle_current_collection+"?view=header-sorting");
              $("div[data-filter-sorting]").addClass("lazyload").on("lazyincluded",function(){
                
              })
              jQuery("body").removeClass('ajax_loading');
        
              /*Reinit product review */
              SPR.registerCallbacks();
              SPR.initRatingHandler();
              SPR.initDomEls();
              SPR.loadProducts();
              SPR.loadBadges();              
             
              setTimeout(function(){ 
                tippy('.product-item .js-compare, .product-item .js-wishlist, .product-item .js_quick_view:not(.no-icon)', {
                  placement: 'top',
                  animation: 'scale',
                  arrow: true
                })
              },500)
              
              $("span[data-show-filter]").on("click",function(){    
                $("div[data-top-content-filter]").toggleClass('opened');
              })
              
            })
          },
          refresh_masonry: function (el) {            
             var option = el.attr("data-isotope") || '{}';
             el.isotope(JSON.parse(option));
          },
          pin_lookbook : function () {
            if ( window_w < 1024 ) return;

            jQuery("body").on('click', '.pin_tt_js', function (e) {
               e.preventDefault();
               e.stopPropagation();

                 var ck = 0,
                     cl = 'pin__opened',
                     _this = $( this ).parent('.pin__type');
                 if (_this.hasClass('pin__opened')) { ck = 1}
                 $('.pin__type.pin__opened').removeClass('pin__opened');
                 $('.pin__slider.pin_slider_opened').removeClass('pin_slider_opened');              
                 if ( ck ) return;

                 var sp_section = $( this ).closest('.shopify-section');
                 _this.addClass('pin__opened');
                 sp_section.find('.pin__slider').addClass('pin_slider_opened');

                 if ( _this.hasClass('has_calc_pos') ) return;

                 var pos = _this.offset(),
                     pin_pp = _this.find('.pin__popup'),
                     pin_parent = _this.find('.pin_lazy_js');

                  if (pin_parent.length == 0) {pin_parent = pin_pp;}
                  if (pin_parent.hasClass('pin__popup--left')) {
                     var w_popup = pin_pp.width() + 20;
                     if ( pos.left < w_popup ) {                      
                        var mrRight = w_popup - pos.left + 10;
                        pin_pp.css("margin-right", '-' + mrRight + 'px');
                     }
                  } else if (pin_parent.hasClass('pin__popup--right')) {
                     var w_popup = pin_pp.width() + 20,
                         posRight = $(window).width() - pos.left - _this.width();
                     if ( posRight < w_popup ) {                        
                        var mrLeft = w_popup - posRight + 10;
                        pin_pp.css("margin-left", '-' + mrLeft + 'px');
                     }
                  }
              
              if($(".pin__popup .product-item").length){
                SPR.registerCallbacks();
                SPR.initRatingHandler();
                SPR.initDomEls();
                SPR.loadProducts();
                SPR.loadBadges();
              }

            });
            jQuery("body").on('click', function (e) {
              var target = $(e.target);
              if (target.closest('.pin__type').length > 0 || target.closest('.mfp-wrap').length > 0) return;
              $('.pin__type.pin__opened').removeClass('pin__opened');
              $('.pin__slider.pin_slider_opened').removeClass('pin_slider_opened');
            });

          },
          sc_lazy : function () {
            var $inc_lz = $('.inc_lz');

            if ( $inc_lz.length == 0 && $('.inl_cnt_js').length > 0 ) return;
           
            // collection
            $('.inc_pr_laz').each(function() {
                $(this).addClass('lazyload').one('lazyincluded', function (e) {
                  if (e.detail.content) {
                       var el = $(e.target).find('.js_carousel');
                       if ( el.length == 0 ) return;
                       //cmsheroShopify.refresh_flickity(el);
                   } else {
                         $(e.target).hide().remove();
                   }

                });
            });

            // lookbook
             $('.inc_lb_laz, .inc_cat_laz, .inc_gl_laz, .inc_ins_laz').each(function() {
                 $(this).addClass('lazyload').one('lazyincluded', function (e) {
                       if (e.detail.content) {
                           //cmsheroShopify.popupMFP();
                           var _target = $(e.target),
                               el = _target.find('.js_carousel'),
                               el2 = _target.find('.js_packery');

                           if ( el.length > 0 ) {
                              //cmsheroShopify.refresh_flickity(el);
                           } else if ( el2.length > 0 ) {
                              //cmsheroShopify.refresh_packery(el2);
                           }
                       } else {
                             $(e.target).hide().remove();
                       }
                 });
             })
          },
          initPopup : function () {
            
                jQuery("body").on('click', '[data-opennt]', function (e) {             
                var $this = $(e.currentTarget),
                html = $("html"),
                datas = $this.data(),
                id = datas.opennt,
                color = datas.color,
                bg = datas.bg,
                position = datas.pos,
                ani = datas.ani || 'has_ntcanvas',
                remove = datas.remove,
                cl = datas.class,
                close = datas.close || false,
                focuslast = datas.focuslast || false,
                focus = $this.attr("data-focus"),
                YOffset = window.pageYOffset,
                height = window.height - $('#shopify-section-header_banner').outerHeight() - $('.ntheader_wrapper').outerHeight();              

                var nt_scroll = function () {
                      if( !YOffset) return; 
                      $('html, body').scrollTop(YOffset);
                }
                $this.addClass("current_clicked");
                 $.magnificPopup.open({
                   items: {
                     src: id,
                     type: "inline",
                     tLoading: '<div class="loading-spin dark"></div>'
                   },
                   tClose: "Close (Esc)",
                   removalDelay: 300,
                   closeBtnInside: close,
                   focus: focus,
                   autoFocusLast: focuslast,
                   callbacks: {
                     beforeOpen: function() {
                       this.st.mainClass = ani + " " + color + " " + ani+"_" + position;                     
                     },
                     open: function() {                     
                       html.addClass(ani); 
                       html.addClass(ani+"_" + position); 
                       cl && $(".mfp-content").addClass(cl); 
                       bg && $(".mfp-bg").addClass(bg); 

                       jQuery("body").on('click', '.close_pp', function(e) {
                         e.preventDefault();
                         $.magnificPopup.close();
                       });
                       nt_scroll();
                     },
                     beforeClose: function() {
                       html.removeClass(ani);  
                     },
                     afterClose: function() {
                       html.removeClass(ani+"_" + position);                      
                       $(".current_clicked").removeClass("current_clicked"); 
                       remove && $(id).removeClass("mfp-hide");
                     }
                   }
                 });
                 e.preventDefault()
               })
            
          },
          quickView: function(){
            function kt_get_scrollbar_width() {
              var $inner = jQuery('<div style="width: 100%; height:200px;">test</div>'),
                  $outer = jQuery('<div style="width:200px;height:150px; position: absolute; top: 0; left: 0; visibility: hidden; overflow:hidden;"></div>').append($inner),
                  inner = $inner[0],
                  outer = $outer[0];
              jQuery('body').append(outer);
              var width1 = parseFloat(inner.offsetWidth);
              $outer.css('overflow', 'scroll');
              var width2 = parseFloat(outer.clientWidth);
              $outer.remove();
              return (width1 - width2);
            }
             jQuery(document).on('click','.quick-view, .js_quick_view' , function(event) {
                event.preventDefault();
                
                var url = $(this).attr('href')+"?view=default";
                jQuery("#quick-view-modal").show();
                jQuery("#quick-view-modal").load(url + " #product-single", function() {
                  var window_size = parseFloat(jQuery('body').innerWidth());
                  window_size += kt_get_scrollbar_width();
                  if(window_size >= 320){                  
                    jQuery.magnificPopup.open({
                      items: {
                        src: '#quick-view-modal',
                        type: 'inline'
                      },
                      callbacks: {                       
                        open: function() { 
                          $("#quick-view-modal").removeClass("open")
                          setTimeout(function(){ $("#quick-view-modal").addClass("open")}, 100);
                          var height = $("#quick-view-modal .inner-detail").height() + parseInt($("#quick-view-modal .inner-detail").css('margin-top')) + parseInt($("#quick-view-modal .inner-detail").css('margin-bottom')) + 17;
                          $("#quick-view-modal .full-item .bg_img_full").css('height',height+'px');                          
                          $(".size-chart-open-popup").addClass("open"); /* Thêm class open đến sizeguide để khi click sizeguide thì mở popup*/
                        },
                        close: function(){ 
                          $("a[data-js-tooltip]").each(function(){
                        	$(this).attr("disabled","disabled");
                          })
                        }
                      }
                    });
                    jQuery(document).on("mouseover", "body", function(){ 
                      $("a[data-js-tooltip]").each(function() {
                        $(this).removeAttr("disabled", "disabled"); 
                      })
                    })
                    $("#quick-view-modal div[data-slide-main]").slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: true,
                      dots: true,
                      fade: true,
                      appendArrows: '#quick-view-modal .append-arrow-main',
                      lazyLoad: 'ondemand'
                    })    
                    
                    SPR.registerCallbacks();
                    SPR.initRatingHandler();
                    SPR.initDomEls();
                    SPR.loadProducts();
                    SPR.loadBadges();
                    
                    /*$("#quick-view-modal div[data-slide-nav]").slick({
                      slidesToShow: 3,
                      slidesToScroll: 1,
                      asNavFor: 'div[data-slide-main]',
                      dots: false,
                      centerMode: false,
                      lazyLoad: 'ondemand',
                      focusOnSelect: true
                    }); 
                    
                    cmsheroShopify.checkSlide(); 
                     */
                   $("#quick-view-modal").find("[data-js-gallery]").click(function () {                    
                      var cms_js = jQuery('#cms_js');      
                      // Init fotoraman    
                      $script([cms_js.data('fotorama')],"load_foto");
                      $script.ready('load_foto', function() {      
                        $("[data-js-gallery]").click(function () {                  
                          var fotorama = $('div[data-fotorama]')
                          .fotorama({allowfullscreen: true})
                          .data('fotorama');
                          fotorama.requestFullScreen();
                        });  
                        $('div[data-fotorama]').on('click', function (e, fotorama) {
                          if ($(e.target).hasClass("fotorama__stage__frame")) {
                            $('div[data-fotorama]').data('fotorama').cancelFullScreen();
                            $('div[data-slide-nav]').find(".slick-track").css("transform","none");
                          }
                        });
                      })
                    }); 
                   
                    
                    $("#quick-view-modal").find('[data-page-open-popup]').magnificPopup({
                      type:'inline',
                      midClick: true,
                      callbacks: {                   
                           open: function() {   
                             var id = $(this).attr('href');
                             id = id.substr(1);
                             $("#"+id).removeClass('open');        
                             setTimeout(function(){ $("#"+id).addClass('open');},200);
                           }
                      }
                    });
                    
                    $("#quick-view-modal").find('[data-360-open-popup]').magnificPopup({
                      type:'inline',
                      midClick: true,
                      callbacks: {                   
                           open: function() {   
                             var id = $(this).attr('href');
                             id = id.substr(1);
                             $("#"+id).removeClass('open');
                             setTimeout(function(){ $("#"+id).addClass('open');}, 500);                             
                           }
                      }
                    });
                    $("#quick-view-modal").find('[data-video-open-popup]').magnificPopup({
                      type:'inline',
                      midClick: true,
                      callbacks: {                   
                           open: function() {   
                             var id = $(this).attr('href');
                             id = id.substr(1);
                              $("#"+id).removeClass('open');
                             setTimeout(function(){ $("#"+id).addClass('open');}, 500);
                           }
                      }
                    });
                     
                  }
                  
                  // Link đến trang product detail khi click vào write review nếu có
                  if($("#quick-view-modal .product-name").length > 0){
                    var vUrl = $("#quick-view-modal .product-name").attr("href")+"#tab_product";
                    var vWriteReview = $(".write-review");
                    if(vWriteReview.length > 0){
                    	vWriteReview.prop("href",vUrl);
                    	vWriteReview.removeAttr("onclick");
                    }
                  }
                  // Kiểm tra lại trạng thái wishlist và compare của sản phẩm khi click quickview
                  var $product = $("#quick-view-modal").find('[data-js-product]');                  
                  theme.StoreLists.checkProductStatus($product);
                  
                });
               
               
            });
           

             jQuery(document).on('click','.js_quick_option' , function(event) {
                event.preventDefault();
               
                var url = $(this).attr('href');
                jQuery("#quick-options-modal").show();
                jQuery("#quick-options-modal").load(url + " #product-single", function() {
                  var window_size = parseFloat(jQuery('body').innerWidth());
                  window_size += kt_get_scrollbar_width();
                  if(window_size >= 320){                  
                    jQuery.magnificPopup.open({
                      items: {
                        src: '#quick-options-modal',
                        type: 'inline'
                      },
                      callbacks: {                       
                        open: function() { 
                          $("#quick-options-modal").removeClass("open")
                          setTimeout(function(){ $("#quick-options-modal").addClass("open")}, 500);                          
                        }
                      }
                    });
                    $("#quick-options-modal div[data-slide-main]").slick({
                      slidesToShow: 1,
                      slidesToScroll: 1,
                      arrows: true,
                      dots: true,
                      fade: true,
                      appendArrows: '#quick-options-modal .append-arrow-main',
                      lazyLoad: 'ondemand'
                    })    
                    
                    SPR.registerCallbacks();
                    SPR.initRatingHandler();
                    SPR.initDomEls();
                    SPR.loadProducts();
                    SPR.loadBadges();
                 
                   $("#quick-options-modal").find("[data-js-gallery]").click(function () {                    
                      var cms_js = jQuery('#cms_js');      
                      // Init fotoraman    
                      $script([cms_js.data('fotorama')],"load_foto");
                      $script.ready('load_foto', function() {      
                        $("[data-js-gallery]").click(function () {                  
                          var fotorama = $('div[data-fotorama]')
                          .fotorama({allowfullscreen: true})
                          .data('fotorama');
                          fotorama.requestFullScreen();
                        });  
                        $('div[data-fotorama]').on('click', function (e, fotorama) {
                          if ($(e.target).hasClass("fotorama__stage__frame")) {
                            $('div[data-fotorama]').data('fotorama').cancelFullScreen();
                            $('div[data-slide-nav]').find(".slick-track").css("transform","none");
                          }
                        });
                      })
                    }); 
                   
                    $("#quick-options-modal").find('[data-page-open-popup]').magnificPopup({
                      type:'inline',
                      midClick: true
                    });
                  }
                  
                });               
               
            });
          },
          Sortby : function () {     
             if ($('.js_cat_sortby').length == 0) return;

              jQuery("body").on('click', 'a.js_sortby_pick', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this),
                    pr = $this.closest('.js_cat_sortby');
                    

                 if ($(pr).hasClass('open')) {
                    $(pr).removeClass('open');
                 } else {                    
                    $(pr).addClass('open');
                 }
              });
              
              jQuery("body").click(function (e) {                
                 if ($(e.target).hasClass('js_sortby_pick')) return;
                 $('.js_cat_sortby.opended').removeClass('open');
              });
              jQuery("body").on("click",".js_ajaxsortby a", function(e){
                var val = $(this).text();
                $(".js_cat_sortby .js_sr_txt").text(val);
              })
          },
          Numberby : function () {     
             if ($('.js_num_pagination').length == 0) return;

              jQuery("body").on('click', 'a.js_number_pick', function(e) {
                e.preventDefault();
                e.stopPropagation();

                var $this = $(this),
                    pr = $this.closest('.js_num_pagination');
                    

                 if ($(pr).hasClass('opended')) {
                    $(pr).removeClass('opended');
                 } else {                    
                    $(pr).addClass('opended');
                 }
              });
              
              jQuery("body").click(function (e) {                
                 if ($(e.target).hasClass('js_number_pick')) return;
                 $('.js_num_pagination.opended').removeClass('opended');
              });
              jQuery("body").on("click",".js_ajaxnumby a", function(e){
                var val = $(this).text();
                $(".js_num_pagination .js_sr_txt").text(val);
              })
          },
          changeTagFilter: function(){
            if($("div[data-filter]").length == 0) return;
            
            jQuery("body").on('click', 'div[data-filter] li a', function(e) {
                //e.preventDefault();
                //e.stopPropagation();
                var $this = $(this),
                    pr = $this.closest('li'),
                    parent = $(pr).parent();
                    
               
              	 
                 var attr = $(parent).attr('data-list-categories');
                 if (typeof attr !== typeof undefined && attr !== false) {
                    $(parent).find("li").removeClass('current');
                 }else{
                   	$(pr).find('a').addClass('active');
                 	$this.removeClass('active');
                 }
              
                 if ($(pr).hasClass('current')) {
                    $(pr).removeClass('current');
                 } else {                    
                    $(pr).addClass('current');
                 }
              });
            
          },
          changeView: function(){                
            var _current_col = $(".js_products_holder .product-item").data('col');
            if(_current_col != "2.4"){
              _current_col = parseInt(12 / parseInt(_current_col));
            }
            jQuery(document).on('click', '.js_cat_view:not(.active)', function (e) {
               e.preventDefault();
              
               $("a[data-grid]").attr('data-col',_current_col);
               var _this = $( this ),
                  _col  = _this.data( 'col' ),                  
                  _parent = _this.closest('div'),
                  _products = $('.js_categories_content .product-item'),
                  _container_product = $('#collection-product'),
                  holder = $('div[data-container-cat]');
            
                
               _parent.find('a').removeClass('active');
               _this.addClass('active');

              
              if(_col > 0){ 
                if(_col > 2.4 ){
                  _products.removeClass('col-lg-'+_current_col+' col-md-'+_current_col).addClass('col-lg-'+_col+' col-md-'+_col);
                   _products.removeClass('col-lg-15');
                  holder.removeClass("list-style").addClass('grid-style');
                  _products.attr('data-col',_col);
                    _current_col = _col;
                  //_container_product.attr('data-container-col','large-gutter');
                }else{
                  _products.removeClass('col-lg-'+_current_col).addClass('col-lg-15');
                  holder.removeClass("list-style").addClass('grid-style');
                  _products.attr('data-col',_col);
                    _current_col = _col;
                  //_container_product.attr('data-container-col','small-gutter');
                }
              }else{                
                 /*_products.removeClass('col-lg-15');*/
                holder.removeClass("grid-style").addClass('list-style');
              }      
              // Thay đổi giá trị của product per page khi click vào chọn số lượng sản phẩm là 2, 3, 4, 5
              $("#productPerPage").val(_col).change();  
            })
          },         
          countdownProduct: function(){
            if($('.cms-countdown').length >0){               
                  var labels = ['Years', 'Months', 'Weeks', 'Days', 'Hours', 'Mins', 'Secs'];
                  var layout = '<span class="box-count day"><span class="number">{dnn}</span> <span class="text">Days</span></span><span class="box-count hrs"><span class="number">{hnn}</span> <span class="text">Hours</span></span><span class="box-count min"><span class="number">{mnn}</span> <span class="text">Mins</span></span><span class="box-count secs"><span class="number">{snn}</span> <span class="text">Secs</span></span>';
                  $('.cms-countdown').each(function() {
                      var austDay = new Date($(this).data('y'),$(this).data('m') - 1,$(this).data('d'),$(this).data('h'),$(this).data('i'),$(this).data('s'));
                      $(this).countdown({
                          until: austDay,
                          labels: labels, 
                          layout: layout
                      }).on('finish.countdown', function() {
                             $(this).hide();
                      });
                  });                
              }

          },
          initVideo : function () {
            if ($('[data_js_mfp_video]').length == 0) return;

            $('[data_js_mfp_video]').magnificPopup({
               disableOn: 0,
               type: 'iframe',
               tClose: 'Close',
               iframe: {
                  markup: '<div class="mfp-iframe-scaler pr">'+
                        '<div class="mfp-close"></div>'+
                        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
                      '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button

                  patterns: {
                      youtube: {
                        index: 'youtube.com/', // String that detects type of video (in this case YouTube). Simply via url.indexOf(index).
                        id: 'v=',
                        src: '//www.youtube.com/embed/%id%?autoplay=1' // URL that will be set as a source for iframe.
                      },
                      vimeo: {
                        index: 'vimeo.com/',
                        id: '/',
                        src: '//player.vimeo.com/video/%id%?autoplay=1'
                      }
                  },
                  srcAction: 'iframe_src', // Templating object key. First part defines CSS selector, second attribute. "iframe_src" means: find "iframe" and set attribute "src".
               }
            });
          },
          tab_heading :  function () {
			// click on tab of product detail page
            $(document).on('click','.cms-tab a[data-toggle="pill"]',function(e){ 
              e.preventDefault();
              var tab_id = $(this).attr('href');
              $(this).closest('ul').find("li").removeClass("active");
              $(this).closest('li').addClass("active");
              var class_st = $(tab_id).attr("class");
              $("."+class_st).removeClass("active");
              $(tab_id).addClass("active");
            }) 
            
            if ( $('.sp-tabs .tab-heading').length == 0 ) return;

            $('.sp-tabs .tab-heading').click(function (e) {
               e.preventDefault();

               var _this = $(this),
                  parent = _this.closest('.sp-tab'),
                  parent_top = _this.closest('.sp-tabs'),
                  el = _this.closest('.nt_section'),
                  time = 300,
                  time2 = time+50;

                  if ( el.length == 0) {
                    el = _this.closest('.shopify-section')
                  }      
               if (parent.hasClass('active')) {
                  parent.removeClass('active');
                  parent.find('.sp-tab-content').stop(true, true).slideUp(time);
               } else {
                  parent_top.find('.sp-tab').removeClass('active');
                  parent.addClass('active');
                  parent_top.find('.sp-tab-content').stop(true, true).slideUp(time);
                  parent.find('.sp-tab-content').stop(true, true).slideDown(time);

               }
            });
            
            
          },
          PromotionPopup : function (paramAdmin = false) {
            var pp_version = 1;
            var window_w = $(window).width();   
            
            if(!paramAdmin){
            	if ($('[data-js-lazy-popup]').length == 0 || window_w < 992 || $.cookie('core_theme_' + pp_version) == 'shown') return;
            }
            if ($('[data-js-lazy-popup]').length > 0){
              var popup = $('[data-js-lazy-popup]');
              var showPopup = function () {
                var stt = $('[data-js-lazy-popup]').data('stt');
                $.magnificPopup.open({
                  items: {
                    src: '.type_promotion_popup .js_popup_prpr_wrap'
                  },
                  type: 'inline',
                  removalDelay: 500, //delay removal by X to allow out-animation
                  tClose: "Close",
                  callbacks: {
                    beforeOpen: function () {
                      this.st.mainClass ='mfp-move-horizontal prpr_pp_wrapper';
                    },
                    open:function () {   
                      body.trigger('refresh_currency');
                      $(document).off('mouseleave.registerexit');
                     
                    },
                    close:function () {                      	
                        $.cookie('core_theme_' + pp_version, 'shown', { expires: stt.day_next, path: '/' });                      	
                    }
                   
                  }
                });
              };
              if(paramAdmin){
                var time = 0;
              }else{
              	var time = $('[data-js-lazy-popup]').data('time');
              }
              if ($('[data-js-lazy-popup]').length > 0){
                setTimeout(function() { 
                  showPopup();                
                },time)
              }
            }
             
          },
          pagePopup: function(){          
            $('[data-page-open-popup]').magnificPopup({
              type:'inline',
              midClick: true,
              callbacks: {                   
                   open: function() {   
                     var id = $('[data-page-open-popup]').attr('href');
                     id = id.substr(1);
                     $("#"+id).removeClass('open');
                     setTimeout(function(){ $("#"+id).addClass('open');}, 500);
                   }
              }
            });
            $('[data-360-open-popup]').magnificPopup({
              type:'inline',
              midClick: true,
              callbacks: {                   
                   open: function() {   
                     var id = $('[data-360-open-popup]').attr('href');
                     id = id.substr(1);
                     $("#"+id).removeClass('open');
                     setTimeout(function(){ $("#"+id).addClass('open');}, 500);
                   }
              }
            });
            $('[data-video-open-popup]').magnificPopup({
              type:'inline',
              midClick: true,
              callbacks: {                   
                   open: function() {   
                     var id = $('[data-video-open-popup]').attr('href');
                     id = id.substr(1);
                     $("#"+id).removeClass('open');
                     setTimeout(function(){ $("#"+id).addClass('open');}, 500);
                   }
              }
            });
          },  
          ScrollAnimation: function(){
            if($('.animated').length > 0){
              var $animation_elements = $('.animated');
              var $window = $(window);
              
              function check_if_in_view() {
                var window_height = $window.height();
                var window_top_position = $window.scrollTop();
                var window_bottom_position = (window_top_position + window_height);

                $.each($animation_elements, function() {
                  var $element = $(this);
                  var effect  = $element.data('animate');
                  var element_height = $element.outerHeight();
                  var element_top_position = $element.offset().top;
                  var element_bottom_position = (element_top_position + element_height);

                  //check to see if this current container is within viewport

                  if ((element_bottom_position >= window_top_position) &&
                      (element_top_position <= window_bottom_position)) {
                    if(!$element.hasClass(effect)){
                    	$element.addClass(effect);
                    }
                  } else {
                    // $element.removeClass(effect);
                  }
                });
              }

              $window.on('scroll resize', check_if_in_view);
              $window.trigger('scroll');
            }
          },
          /*
          * Thêm hiệu ứng animate cho slideshow
          	input: không
            Output: Hiệu ứng di chuyển text trên slideshow          
          */
          animateEffect: function(){
            /* Thêm hiệu ưng cho text trong slider */   
            if ($("div[data-slider]").hasClass('slick-current') ){   
              var effect_sub_heading  = $("div[data-slider].slick-current").find(".slide_item_h4").data("animate");
              var effect_heading  = $("div[data-slider].slick-current").find(".slide_item_h3").data("animate");
              var effect_button  = $("div[data-slider].slick-current").find(".buttons").data("animate");
              var effect_txt  = $("div[data-slider].slick-current").find(".slide_item_p").data("animate");

              $("div[data-slider].slick-current").find(".slide_item_h4").addClass("animated");
              $("div[data-slider].slick-current").find(".slide_item_h4").addClass(effect_sub_heading);   
              // Thêm animate cho heading
              $("div[data-slider].slick-current").find(".slide_item_h3").addClass("animated");
              $("div[data-slider].slick-current").find(".slide_item_h3").addClass(effect_heading);  
              // Thêm animate cho button
              $("div[data-slider].slick-current").find(".buttons").addClass("animated");
              $("div[data-slider].slick-current").find(".buttons").addClass(effect_button);  
              // Thêm animate cho text
              $("div[data-slider].slick-current").find(".slide_item_p").addClass("animated");
              $("div[data-slider].slick-current").find(".slide_item_p").addClass(effect_txt);   
            }  

            /* Trước khi thay đổi slide */
            $('[data-js-slideshow]').on('beforeChange', function(event, slick, currentSlide, nextSlide){
              var effect_sub_heading  = $("div[data-slider].slick-current").find(".slide_item_h4").data("animate");
              var effect_heading  = $("div[data-slider].slick-current").find(".slide_item_h3").data("animate");
              var effect_button  = $("div[data-slider].slick-current").find(".buttons").data("animate");
              var effect_txt  = $("div[data-slider].slick-current").find(".slide_item_p").data("animate");

              $("div[data-slider].slick-slide").find(".slide_item_h4").removeClass("animated");  
              $("div[data-slider].slick-slide").find(".slide_item_h4").removeClass(effect_sub_heading);
              // Xoá animate cho heading
              $("div[data-slider].slick-slide").find(".slide_item_h3").removeClass("animated");
              $("div[data-slider].slick-slide").find(".slide_item_h3").removeClass(effect_heading);
              // Xoá animate cho button
              $("div[data-slider].slick-slide").find(".buttons").removeClass("animated");
              $("div[data-slider].slick-slide").find(".buttons").removeClass(effect_button);
              // Xoá animate cho text
              $("div[data-slider].slick-slide").find(".slide_item_p").removeClass("animated");
              $("div[data-slider].slick-slide").find(".slide_item_p").removeClass(effect_txt);
            })
            /* Sau khi thay đổi slide */
            $('[data-js-slideshow]').on('afterChange', function(event, slick, currentSlide){
              if ($("div[data-slider]").hasClass('slick-active')){
                var effect_sub_heading  = $("div[data-slider].slick-current").find("h4").data("animate");      
                var effect_heading  = $("div[data-slider].slick-current").find(".slide_item_h3").data("animate");
                var effect_button  = $("div[data-slider].slick-current").find(".buttons").data("animate");
                var effect_txt  = $("div[data-slider].slick-current").find(".slide_item_p").data("animate");

                $("div[data-slider].slick-current").find(".slide_item_h4").addClass("animated");
                $("div[data-slider].slick-current").find(".slide_item_h4").addClass(effect_sub_heading);     
                // Thêm animate cho heading
                $("div[data-slider].slick-current").find(".slide_item_h3").addClass("animated");
                $("div[data-slider].slick-current").find(".slide_item_h3").addClass(effect_heading);    
                // Thêm animate cho button
                $("div[data-slider].slick-current").find(".buttons").addClass("animated");
                $("div[data-slider].slick-current").find(".buttons").addClass(effect_button);   
                // Thêm animate cho text
                $("div[data-slider].slick-current").find(".slide_item_p").addClass("animated");
                $("div[data-slider].slick-current").find(".slide_item_p").addClass(effect_txt);   
              }
            });
          },
          checkEmail: function(){
            var initialsubj="Hay buddy, take a look at this"
            var initialmsg="Hi:\n You may want to check out this site: "+window.location
            var good;
            function checkEmailAddress(field) {

              var goodEmail = field.value.match(/\b(^(\S+@).+((\.com)|(\.net)|(\.edu)|(\.mil)|(\.gov)|(\.org)|(\.info)|(\.sex)|(\.biz)|(\.aero)|(\.coop)|(\.museum)|(\.name)|(\.pro)|(\..{2,2}))$)\b/gi);
              if (goodEmail) {
                good = true;
              }
              else {
                alert('Please enter a valid address.');
                field.focus();
                field.select();
                good = false;
              }
            }
            var u = window.location;
            function mailThisUrl() {
              good = false
              checkEmailAddress(document.eMailer.email);
              if (good) {
                window.location = "mailto:"+document.eMailer.email.value+"?subject="+initialsubj+"&body="+initialmsg
              }
            }   
          },
          loadMoreProduct: function(){
            var limitPr 	= $("#limitProductPage").val();
            var sumPr 	= $("#sum_product_on_collection").val();

            function loadMorePr(paramLimit, paramTotal){
              var size_pr = parseInt(paramTotal);
              var x = parseInt(paramLimit);
              var number = parseInt(paramLimit);
              if(x < size_pr){
                $('.load_more_pr .product-item:lt('+x+')').show();  
                $('#loadMore').click(function () {                     
                    // ajax call get data from server and append to the div     
                    x = (x + number <= size_pr) ? x + number : size_pr;                    
 					$('.load_more_pr .product-item:lt('+x+')').show().fadeIn("slow"); 
                  	$('.load_more_pr .product-item:lt('+x+')').addClass('lm_item');
                    if(x == size_pr){
                      $('#loadMore').hide();
                    }
                })
              }else{
                $('.load_more_pr .product-item:lt('+x+')').show();  
                $('#loadMore').hide();
              }
            }
            if($('.load_more_pr').length > 0){
            	loadMorePr(limitPr, sumPr);
            }else{
              	return;
            }
          },
          lightBox: function(){            
              $(document).on("click", '[data-toggle="lightbox"]', function(event) {
                event.preventDefault();
                $(this).ekkoLightbox();
              });           
          },
          buyTogether: function(){
              $(document).on("change", '[id^="js-product-selector"]', function(event) {
                var vVal = $(this).val();
                $(this).closest("div[data-buy-together-item]").find(".js_item_pr").data("id",vVal);
                
                // Get set price 
                var vHandleProduct = $(this).closest("div[data-buy-together-item]").find(".js_item_pr").val();                
                var vObjectPrice = $(this).closest("div[data-buy-together-item]").find("[data-together-item-price]");
                var vBuyTogetherButton = $(".js_total_together_price");
                var vBuyTogetherButtonCompare = $(".js_sale_together_price");
                var vBuyTogetherButtonSale = $(".js_sale_together_value");
                if (typeof vHandleProduct != "undefined") {
                  $.getJSON('/products/'+vHandleProduct+'.js', function(response) {                       
                    var vPrice = null;
                    var vComparePrice = null;
                    for (var i = 0; i < response.variants.length;i++){
                      if(response.variants[i].id == vVal){
                        vPrice = response.variants[i].price;
                        vComparePrice = response.variants[i].compare_at_price;
                        break;
                      }
                    }
                    vObjectPrice.data('withoutunit',vPrice); // Change withouUnit dataset
                    vObjectPrice.data('comparewithoutunit',vComparePrice); // Change compare price withouUnit dataset
                    theme.ProductCurrency.setPrice(vObjectPrice, vPrice, null);// convert to money format
                    var vSumWithoutUnitPrice = 0;
                    var vSumWithoutUnitComparePrice = 0;
                    var vSalePrice = 0;
                    $('.js_together_item').each(function(e){    
                      var vCheck = $(this).closest("[data-buy-together-item]").find(".js_item_pr").is(':checked');
                      if(vCheck == true){
                        vSumWithoutUnitPrice += parseInt($(this).data("withoutunit")); // calculate sum of without unit price 
                        vSumWithoutUnitComparePrice += parseInt($(this).data("comparewithoutunit"));
                        vSalePrice = vSumWithoutUnitComparePrice - vSumWithoutUnitPrice;
                      }                      
                    })                  
                    theme.ProductCurrency.setPrice(vBuyTogetherButton, vSumWithoutUnitPrice, null);// convert price to money format
                    theme.ProductCurrency.setPrice(vBuyTogetherButtonCompare, vSumWithoutUnitComparePrice, null);// convert compare price to money format
                    theme.ProductCurrency.setPrice(vBuyTogetherButtonSale, vSalePrice, null);// convert sale price to money format
					//$(".js_sale_together_price").hide();
                    //$(".js_sale_together_value").hide();
                  });    
                }
                
              })
              
              $(document).on("change", 'form[data-form-group] .js_item_pr', function(event) {
                var vCheck = $(this).is(':checked');                
                var vSumWithoutUnitPrice = 0;
                var vSumWithoutUnitComparePrice = 0;
                var vSalePrice = 0;
                var vBuyTogetherButton = $(".js_total_together_price");
                var vBuyTogetherButtonCompare = $(".js_sale_together_price");
                var vBuyTogetherButtonSale = $(".js_sale_together_value");
                var vName = $(this).attr('name');
                if(vCheck == true){
					$("div[data-left-hover] input[name^="+vName+"]").prop('checked', true);
                }else{
					$("div[data-left-hover] input[name^="+vName+"]").removeAttr("checked");
                }
                $('.js_together_item').each(function(e){    
                  var vCheck = $(this).closest("[data-buy-together-item]").find(".js_item_pr").is(':checked');
                  if(vCheck == true){
                    vSumWithoutUnitPrice += parseInt($(this).data("withoutunit")); // calculate sum of without unit price   
                    vSumWithoutUnitComparePrice += parseInt($(this).data("comparewithoutunit"));
                    vSalePrice = vSumWithoutUnitComparePrice - vSumWithoutUnitPrice;
                  }else{
                    
                  }
                })                  
                theme.ProductCurrency.setPrice(vBuyTogetherButton, vSumWithoutUnitPrice, null);// convert to money format
                theme.ProductCurrency.setPrice(vBuyTogetherButtonCompare, vSumWithoutUnitComparePrice, null);// convert compare price to money format
                theme.ProductCurrency.setPrice(vBuyTogetherButtonSale, vSalePrice, null);// convert sale price to money format
                //$(".js_sale_together_price").hide();
                //$(".js_sale_together_value").hide();
              })
              
              $(document).on("click", 'div[data-left-hover] .js_item_pr', function(event) {
                	var vName = $(this).attr('name');
                	$("form[data-form-group] input[name^="+vName+"]").trigger("click");
              })
          },
          outSideElement: function(){   
             
              $(document).mouseup(function(e){
                var container = $("div[data-prs-search]");

                // if the target of the click isn't the container nor a descendant of the container
                if (!container.is(e.target) && container.has(e.target).length === 0) 
                {
                  container.hide();
                  $("div[data-wrap-prs-search]").hide();
                  if($("div[data-js-top-search]").length > 0){
                    $("div[data-js-top-search]").show();
                  }
                }
              });             	             
          },
          checkOrderTrackingPage: function(){
			$(document).ready(function() {   
              	var vHeaderLogin = $(".cms-header-account a");
              	var vLinkLogin = vHeaderLogin.attr("href");
              	var vCheck = vLinkLogin.includes("login");
                if(vCheck == false){
					$(".order-tracking-user-press-footer").hide();
                  	$(".order-tracking-user-press-footer").parent().addClass("closed-footer-tracking");
                }
              
            })
          },
          sidebarMenu: function(){
            $(document).ready(function() {    
              var btnSearch = $('.collection-top-filters .cms_search .button-search');
              var ipts = $('.collection-top-filters .cms_search_input.js_iput_search');
              $(btnSearch).click(function(e){ 
                  e.preventDefault()
                  location.href = '/search?type=product&q='+ipts.val();
              })        
	          $(document).on('click', function (e) {
                if (!$(e.target).closest("#collection_icon").length && $(".mega-menu-homepage.open").length >0 ) {   
                  if (($(e.target).closest(".mega-menu-homepage").length === 0 && $(e.target).closest("#btn-filter-canvas").length != 1) ) {           
                      $('#overlay-filter2').css('display','none');   
                      $('.mega-menu-homepage').removeClass("open");
                  }      
                }
              })  
              
              $(document).on('click','#btn-filter-canvas', function(e){     
                e.preventDefault();      
                $('.mega-menu-homepage').addClass("open");
                $('#overlay-filter2').css('display','block');    
              })
              
              $(document).on('click','.mega-menu-homepage.open .cms-close-btn', function(){ 
                $('#overlay-filter2').css('display','none');   
                $('.mega-menu-homepage').removeClass("open");    
              })
              
              $(document).on("click","a[data-collection]",function(){
                $("#btn-filter-canvas").trigger("click");
              })                  
              $("[mega-menu-open]").click(function(){      
                if( $(this).closest(".parent-menu").hasClass("active") ){
                   $(this).closest(".parent-menu").children("ul").slideUp();         
                }else {
                  $(this).closest(".parent-menu").children("ul").slideDown();
                  $(this).closest(".parent-menu").siblings(".parent-menu").removeClass("active");
                  $(this).closest(".parent-menu").siblings(".parent-menu").children("ul").slideUp(); 
                }
                $(this).closest(".parent-menu").toggleClass("active");      
                if ($(".parent-menu.active").length  == 0){
                  $(".parent-menu:not(.active)").children(".title").css("color","var(--body_text_color)");
                }else
                {
                  $(".parent-menu.active").siblings(".parent-menu").children(".title").css("color","var(--secondary_color_2)");
                  $(".parent-menu.active").children(".title").css("color","var(--body_text_color)");        
                }
              });


              // Bubble button
              /*$(".bubble").draggable({      
                containment: "window"
              });
              var isMoving = false;
              var isdragging = false;
              var chatMode = false;

              function closeChat(posX, posY){
                var wwidth = $( window ).width();

                if(posX < wwidth/2){
                  $(".bubble").css("left", "0").css("transform", 'scale(1)').css("transition", "all 0.3s");
                  $(".bubble").removeClass('open1');
                }else{
                  $(".bubble").css("left", (wwidth-45) +'px').css("transform", 'scale(1)').css("transition", "all 0.3s");
                  $(".bubble").removeClass('open2');
                }
              }

              $(".bubble").on("click", function(){
                var posX = $(this).position().left,
                    posY = $(this).position().top;
                var wwidth = $( window ).width();
                if(chatMode){
                  closeChat(posX, posY);
                  chatMode = false;
                }else{
                  if(posX < wwidth/2){        
                    $(".bubble").css("left", "15px").css("transform", 'scale(1.1)').css("transition", "all 0.3s");
                    $(".bubble").addClass('open1');
                    $(".bubble").removeClass('open2');
                  }else{
                    $(".bubble").css("left", (wwidth-60) +'px').css("transform", 'scale(1.1)').css("transition", "all 0.3s");
                    $(".bubble").addClass('open2');
                    $(".bubble").removeClass('open1');
                  }      
                  chatMode = true;
                }
              });

              $(".bubble").mousedown(function(){
                isdragging = false;
              });

              $(".bubble").mousemove(function(){
                isdragging = true;
                $(this).css("transition", "all 0s");
              });

              $(".bubble").mouseup(function(e){
                e.preventDefault();
                var lastY = window.event.clientY;
                var lastX = window.event.clientX;
                var swidth = $( window ).width();

                if(isdragging){
                  if(chatMode){
                    chatMode = false;
                    closeChat(lastX, lastY);
                  }
                  if(lastX > (swidth/2) || lastX > swidth){
                    $(this).css("top", lastY).css("left", (swidth-45) + "px").css("transition", "all 0.4s");
                  }else{
                    $(this).css("top", lastY).css("left", "0px").css("transition", "all 0.4s");
                  }
                }
              });  

              var activeAnimated = function(e){
                $(e).hover(function(){
                  var icon = $(this).find('svg');
                  var data_animated = icon.attr('data-animated');
                  icon.toggleClass(data_animated);  
                });
              }

              var listItem = $('.bubble_list-item li a');
              listItem.each(function(){
                activeAnimated(this);
              })    */

            });  
        },
          groupProduct: function(){            
            $(document).on("change", '#frm_group_product .js_qty', function(event) {
               var vSumPrice = 0;
               var vSumComparePrice = 0;
               var vSalePrice = 0;
               var vGroupProductPriceElement = $("div[data-group-price] #js-product-price");
               var vGroupCompareProductPriceElement = $("div[data-group-price] #js-compare-product-price");
               var vSalePriceElement = $("div[data-group-price] #js-sale-price");
               $('#frm_group_product .js_qty').each(function(e){    
                 var vVal = parseInt($(this).val());
                 var vPrice = parseInt($(this).data("withoutunit"));     
                 var vComparePrice = parseInt($(this).data("comparewithoutunit"));           
                 if(vVal > 0){
                   vSumPrice += (vPrice * vVal);
                   vSumComparePrice += (vComparePrice*vVal);
                 }
               })
               vSalePrice = vSumComparePrice - vSumPrice;
              if(vGroupProductPriceElement.length > 0){
               	theme.ProductCurrency.setPrice(vGroupProductPriceElement, vSumPrice, null);// convert to money format
              }
              if(vGroupCompareProductPriceElement.length > 0){
                theme.ProductCurrency.setPrice(vGroupCompareProductPriceElement, vSumComparePrice, null);// convert to money format
              }
              if(vSalePriceElement.length > 0){
                theme.ProductCurrency.setPrice(vSalePriceElement, vSalePrice, null);// convert to money format
                vSalePriceElement.text(vSalePriceElement.text().replace(".00", ""));
                vSalePriceElement.prepend("Save ");
              }
            })
          }                    
        }
        
   }());   
})( jQuery );
$(document).ready(function() {
  $script.ready('load_basic', function() {
   cmsheroShopify.init(); 
   cmsheroShopify.clone_main_menu();
   cmsheroShopify.popupSidebar();
   cmsheroShopify.searchProduct();
   cmsheroShopify.ajaxSwatch();
   cmsheroShopify.addItemCart();
   cmsheroShopify.stAddCart();    
   cmsheroShopify.initPopup();
   cmsheroShopify.checkSlide();
   cmsheroShopify.filtersAJX();   
   cmsheroShopify.sc_lazy();
   cmsheroShopify.pin_lookbook();
   cmsheroShopify.back_to_top();
   cmsheroShopify.quickView();
   cmsheroShopify.Sortby();
   cmsheroShopify.quantity();
   cmsheroShopify.Numberby();
   cmsheroShopify.changeTagFilter();
   cmsheroShopify.changeView();   
   cmsheroShopify.countdownProduct();
   cmsheroShopify.initVideo();
   cmsheroShopify.PromotionPopup();
   cmsheroShopify.tab_heading();
   cmsheroShopify.pagePopup(); 
   cmsheroShopify.initSlick();
   cmsheroShopify.ScrollAnimation();
   cmsheroShopify.animateEffect();
   cmsheroShopify.loadMoreProduct();
   cmsheroShopify.lightBox();
   cmsheroShopify.buyTogether();
   cmsheroShopify.groupProduct();
   cmsheroShopify.outSideElement();
   cmsheroShopify.sidebarMenu();
   cmsheroShopify.checkOrderTrackingPage();
    var prc = new ProductCurrency();
    var t = new ProductOptions();
    var l = new Loader();
    var pin = new ProductImagesNavigation();
    var pih = new ProductImagesHover();
    var v = new ProductVisitors();
    var sl = new StoreLists();
    var sc = new SortingCollections();
    var pct = new ProductTextCountdown();
    var pg = new ProductGallery(); 
   
    /* Show slider after lazy is loaed*/
    if($("div[data-wrapper-slidershow] .pr_lazy_img" ).hasClass("lazyloaded" )){ 
      $("div[data-wrapper-slidershow] .content-item").removeClass('closed');
    } 
  	/* End show*/
    //$(".js_product_single .swatch .swatch-element").first().trigger("click");
    $("div[data-slide-nav] .thumb_img" ).first().trigger("click");
    //$("#product-single div[data-js-all] .thumb_img" ).first().trigger("click");
    
    $("div[data-lazy-product-load]").on('lazyloaded', function() {
      if (typeof theme.ProductCurrency != "undefined") {
        theme.ProductCurrency.update(); 
      }
    })      
    
    $(document).on('shopify:section:load', function(e){
      $('.cp_cd_js').removeClass('d-none');  
    })
    
    $(document).on('click', '.dcp_cd_btn', function(e) {
      var _this = $(this),
          html = _this.siblings('.dcp_cd_ip')[0]; 
      html.select();
      html.setSelectionRange(0, 99999)
      document.execCommand("copy");
      _this.text('Copied Shortcode');
    });
  
    var sps = '#shopify-section-',
        tcr = 'slideshow',
        jcr_ = '.js_carousel';

    var slickBlock = {
      select: function($parentSection,blockId){
		$('body').addClass('admin');
        if ($('#cms_'+blockId).length > 0) {
          var slideIndex = $('#cms_'+blockId).closest(".wrap_slide").attr("data-slick-index");          
        } else {
          var slideIndex = $('#cms_b_'+blockId).closest('.js_image_slide').attr("data-slick-index"); 
        }
        $parentSection.find(jcr_).slick("slickGoTo", parseInt(slideIndex));
      },
      deselect: function($parentSection){
        //$parentSection.find(jcr_).slick("slickGoTo", 0);
      }
    };
    
    $(document).on('shopify:block:select', function(e){
      var id = e.detail.sectionId, blockId = e.detail.blockId,
          $parentSection = $(sps + id);    
      if ( $parentSection.hasClass(tcr) ) {
        slickBlock.select($parentSection,blockId);
      }
      if ($parentSection.hasClass('header_megamenu')) {
        if ($('#cms_'+blockId).length > 0 ) {
          var li = $('.menu-item-has-children#item_'+$('#cms_'+blockId).attr("data-id"));
        } else {
          var li = $('.menu-item-has-children#item_'+blockId);
        }
        $('.header_megamenu .menu-item').removeClass('menu_item_hover');
        li.addClass('menu_item_hover');
      }
    })
    
    $(document).on('shopify:block:deselect', function(e){
      var id = e.detail.sectionId, blockId = e.detail.blockId,
          $parentSection = $(sps + id);

      if ( $parentSection.hasClass(tcr) ) {
        slickBlock.deselect($parentSection);
      }

      if ($parentSection.hasClass('header_megamenu')) {
        $('.header_megamenu .menu-item').removeClass('menu_item_hover');
      }
    })

    $(document).on('shopify:section:load', function(e){   
      cmsheroShopify.init(); 
      cmsheroShopify.clone_main_menu();
      cmsheroShopify.popupSidebar();
      cmsheroShopify.searchProduct();
      cmsheroShopify.ajaxSwatch();
      cmsheroShopify.addItemCart();
      cmsheroShopify.stAddCart();    
      cmsheroShopify.initPopup();
      cmsheroShopify.checkSlide();
      cmsheroShopify.filtersAJX();   
      cmsheroShopify.sc_lazy();
      cmsheroShopify.pin_lookbook();
      cmsheroShopify.back_to_top();
      cmsheroShopify.quickView();
      cmsheroShopify.Sortby();
      cmsheroShopify.quantity();
      cmsheroShopify.Numberby();
      cmsheroShopify.changeTagFilter();
      cmsheroShopify.changeView();   
      cmsheroShopify.countdownProduct();
      cmsheroShopify.initVideo();    
      cmsheroShopify.tab_heading();
      cmsheroShopify.pagePopup(); 
      cmsheroShopify.initSlick();
      cmsheroShopify.ScrollAnimation();
      cmsheroShopify.animateEffect();
      cmsheroShopify.SalesPopup();    
      $('body').addClass('loaded');
      
    })
    $(document).on('shopify:section:select', function(e){   
      var id = e.detail.sectionId,
          $parentSection = $(sps + id);    
      var hnp = 'type_promotion_popup';
      if ( $parentSection.hasClass(hnp) ) {
        cmsheroShopify.PromotionPopup(true);
      }
    })
    
    $('select[name="product_cat"]').niceSelect();
   })  
   $('body').addClass('loaded');

   /* checkbox buy it now producct page */
    $("#prpage-cart-term-conditions-checkbox").change(function() {
      if(this.checked) {
        $(this).closest(".group-button-buyitnow").removeClass("disabled").find("button").removeAttr("disabled");        
      }else{
        $(this).closest(".group-button-buyitnow").addClass("disabled").find("button").prop("disabled","disabled");   
      }
    });
   $(window).on('load', function () {
     var win = $(this); 
     if (win.height() >= 992) { 
       $("div[data-js-footer]").removeClass("hidden-sm");
       $("div[data-js-footer]").removeClass("hidden-xs");
     }else{
       $("div[data-js-footer]").addClass("hidden-sm");
       $("div[data-js-footer]").addClass("hidden-xs");
     }     
   })

   $(".write-review").on("click",function(){
     $('[href="#tab_review"]').trigger('click');
     $(".spr-summary-actions-newreview").trigger('click');
   })
   if($( ".wrap-main-collection" ).hasClass( "cms-full" )){
     $(".header-top > .container").addClass('cms-full');
   }
  $(".cms-header-bar-link").on("click",function(){
    $("div[data-header-bottom]").toggleClass('opened');

  })
  $("span[data-show-filter]").on("click",function(){    
    $("div[data-top-content-filter]").toggleClass('opened');
  })
  
  
  /* Menu lazy click */
  $("#cms-panel-menu-main-menu .menu-item-has-children a").on("click",function(){
    $(this).addClass("lazyload").on("lazyincluded",function(){		
    })
  })  
  
  /* Detect small size for product item <280px */ 
  $("body").on("mouseover",function(){    
    if($(".product-item-style2").length > 0){      
      $(".product-item-style2").on('mouseover',function(){ 
        var width = $(this).width();    
        if(width < 260){
          $(this).addClass("small");
        }else{
          $(this).removeClass("small");
        }
      })
    }
  })
  
  var lastScrollTop = 0;
  $(window).scroll(function(event){
    var st = $(this).scrollTop();
    var h_Header = $("header").height();
    if (st > lastScrollTop){
      // downscroll code
      if(st > h_Header){   
        $("#headroom").removeClass("headroom--top");
      }
		$("#headroom").addClass("headroom--down").addClass("headroom--unpinned").removeClass("headroom--up").removeClass("headroom--pinned");  
    } else {
      // upscroll code
      if($(window).width() >= 1025){
                
        if(st > h_Header){         
          $("#headroom").addClass("headroom--up").addClass("headroom--pinned").removeClass("headroom--down").removeClass("headroom--unpinned");         
        }else{
           $("#headroom").addClass("headroom--top");
           $("#headroom").removeClass("headroom--up").removeClass("headroom--pinned").removeClass("headroom--down").addClass("headroom--unpinned");  
        }
      }
    }
    
    lastScrollTop = st;
  });
  // Khi thay đổi kích thước cửa sổ window
  $( window ).resize(function() {
    var win = $(this); 
     if (win.height() >= 992) { 
       $("div[data-js-footer]").removeClass("hidden-sm");
       $("div[data-js-footer]").removeClass("hidden-xs");
     }else{
       $("div[data-js-footer]").addClass("hidden-sm");
       $("div[data-js-footer]").addClass("hidden-xs");
     }         
    
    var vMaxHeight = 0 ;
    $("div[data-js-slick-brand] .brand_list").each(function(){
      var bHeight = $(this).find("img").height();
      if(bHeight > vMaxHeight){
        vMaxHeight = bHeight;
      }
    })
    if(vMaxHeight > 1){
      $("div[data-js-slick-brand] .brand_list").css('height',vMaxHeight + "px");
    }    
    // Khởi tạo lại slick slider
    cmsheroShopify.initSlick();
    
    if($(".product-item-style2").length > 0){
      $(".product-item-style2").each(function(){
        var width = $(this).width();
        if(width < 260){
          $(this).addClass("small");
        }else{
          $(this).removeClass("small");
        }
      })
    }    
  }) 
  
})

  $("[open-popup-lookbook]").click(function() {
    	$(this).siblings(".content-product-lookbook").toggleClass("open");
    	$(this).closest("[data-parents]").siblings("[data-parents]").children(".content-product-lookbook").removeClass("open");
  });

  turnon();
  $(window).resize(function() {
      if (window.matchMedia('(max-width: 585px)').matches) {
        var value = $("[data-opennnt]").attr("data-opennnt");
        $("[data-opennnt]").attr("data-opennt",value);
		turnon();        
      }else{
      	$("[data-opennt]").removeAttr("data-opennt");
	  }
  });
  function turnon (){
    if (window.matchMedia('(max-width: 585px)').matches) {      
      var m = $("[data-opennnt]");
      $(m).each(function(i,item){
          	$(item).attr("data-opennt",$(item).attr("data-opennnt"));		
      });
      initpopup();        
    }
  }
  function initpopup (){
    jQuery("body").on('click', '[data-opennt]', function (e) {             
      var $this = $(e.currentTarget),
          html = $("html"),
          datas = $this.data(),
          id = datas.opennt,
          color = datas.color,
          bg = datas.bg,
          position = datas.pos,
          ani = datas.ani || 'has_ntcanvas',
          remove = datas.remove,
          cl = datas.class,
          close = datas.close || false,
          focuslast = datas.focuslast || false,
          focus = $this.attr("data-focus"),
          YOffset = window.pageYOffset,
          height = window.height - $('#shopify-section-header_banner').outerHeight() - $('.ntheader_wrapper').outerHeight();              

      var nt_scroll = function () {
        if( !YOffset) return; 
        $('html, body').scrollTop(YOffset);
      }
      $this.addClass("current_clicked");
      $.magnificPopup.open({
        items: {
          src: id,
          type: "inline",
          tLoading: '<div class="loading-spin dark"></div>'
        },
        tClose: "Close (Esc)",
        removalDelay: 300,
        closeBtnInside: close,
        focus: focus,
        autoFocusLast: focuslast,
        callbacks: {
          beforeOpen: function() {
            this.st.mainClass = ani + " " + color + " " + ani+"_" + position;                     
          },
          open: function() {                     
            html.addClass(ani); 
            html.addClass(ani+"_" + position); 
            cl && $(".mfp-content").addClass(cl); 
            bg && $(".mfp-bg").addClass(bg); 

            jQuery("body").on('click', '.close_pp', function(e) {
              e.preventDefault();
              $.magnificPopup.close();
            });
            nt_scroll();
          },
          beforeClose: function() {
            html.removeClass(ani);  
          },
          afterClose: function() {
            html.removeClass(ani+"_" + position);                      
            $(".current_clicked").removeClass("current_clicked"); 
            remove && $(id).removeClass("mfp-hide");
          }
        }
      });
      e.preventDefault()
    })
  }
 
  $(document).ready(function()   {
      var handlerSize  = function(numberSize){
        var $listProduct = $('.product-item.product-item-style3');
        $listProduct.each(function(index1){
          var $listSizeContainer = $('.product-collection__image .cms-option-item [data-property=Size]');
          var $listSize = $(this).find('.product-collection__image .cms-option-item [data-property=Size] .product-options__value');
          var $countSize = $listSize.length;
          if($countSize > numberSize+1 ) {
            var coutingDel = 0;
            $listSize.each(function(index){            
              if(index >= numberSize){
                  $(this).remove();
                  coutingDel++;
              }       	
            })          	
            if(coutingDel > 0 ){
              var appendString = '<div class="product-options__value product-options__value--text  border  " data-js-option-value=""  data-bg="none" data-scale="2">'+'+'+coutingDel+'</div>'
              $(this).find('.product-collection__image .cms-option-item [data-property=Size] .product-options__value:last-child').after( appendString );
            }
          }
        })
      }    
      handlerSize(3);
  })

  /*
$('#menu-main-menu .lazy_menu ').one('lazyloaded', function(e) {
 
});
  */
